function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _call_super(_this, derived, args) {
    derived = _get_prototype_of(derived);
    return _possible_constructor_return(_this, _is_native_reflect_construct() ? Reflect.construct(derived, args || [], _get_prototype_of(_this).constructor) : derived.apply(_this, args));
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _construct(Parent, args, Class) {
    if (_is_native_reflect_construct()) {
        _construct = Reflect.construct;
    } else {
        _construct = function construct(Parent, args, Class) {
            var a = [
                null
            ];
            a.push.apply(a, args);
            var Constructor = Function.bind.apply(Parent, a);
            var instance = new Constructor();
            if (Class) _set_prototype_of(instance, Class.prototype);
            return instance;
        };
    }
    return _construct.apply(null, arguments);
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _is_native_function(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _wrap_native_super(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    _wrap_native_super = function wrapNativeSuper(Class) {
        if (Class === null || !_is_native_function(Class)) return Class;
        if (typeof Class !== "function") {
            throw new TypeError("Super expression must either be null or a function");
        }
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return _construct(Class, arguments, _get_prototype_of(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return _set_prototype_of(Wrapper, Class);
    };
    return _wrap_native_super(Class);
}
function _is_native_reflect_construct() {
    try {
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return (_is_native_reflect_construct = function() {
        return !!result;
    })();
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  position: fixed;\n  inset: 0;\n  z-index: 9999;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  .dialog-overlay {\n    position: fixed;\n    inset: 0;\n    background-color: rgba(0, 0, 0, 0.3);\n    backdrop-filter: blur(4px);\n  }\n\n  .dialog-surface {\n    position: relative;\n    background: #fcfcfb;\n    border-radius: 18px;\n    border: 3px solid #ccffff;\n    box-shadow:\n      0px 0px 11px 1px rgba(228, 255, 254, 0.55),\n      0px 3px 11px 0px rgba(0, 0, 0, 0.05);\n    max-width: 600px;\n    width: 90vw;\n    max-height: 85vh;\n    overflow-y: auto;\n    padding: 1.5rem;\n    outline: none;\n  }\n\n  .dialog-title {\n    font-size: 1rem;\n    font-weight: 600;\n    color: #333;\n    margin-bottom: 1rem;\n  }\n\n  .dialog-content {\n    color: #424242;\n  }\n\n  .dialog-actions {\n    display: flex;\n    justify-content: flex-end;\n    gap: 0.5rem;\n    margin-top: 1.5rem;\n  }\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  font-size: 0.9375rem;\n  line-height: 1.5;\n  color: #424242;\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  ",
        "\n  border: 1px solid #e1e2ea;\n  background: #ffffff;\n  color: #424242;\n\n  &:hover {\n    background: #f5f5f5;\n  }\n"
    ]);
    _templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n  ",
        "\n  border: 1px solid ",
        ";\n  background: ",
        ";\n  color: #ffffff;\n\n  &:hover {\n    background: ",
        ";\n    border-color: ",
        ";\n  }\n"
    ]);
    _templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _tagged_template_literal([
        "\n  width: 880px;\n  position: fixed; /* fixed positioning to prevent layout shift */\n  display: flex;\n  flex-direction: column;\n  border-radius: var(--X-Large, 8px);\n  border: var(--None, 1px) solid var(--Neutral-Stroke-1-Glass2, #fff);\n  background: var(--Neutral-Background-1-Base-Glass, rgba(255, 255, 255, 0.4));\n  box-shadow:\n    3px 4px 24px 0px rgba(255, 255, 255, 0.5) inset,\n    0px 3px 11px 0px rgba(0, 0, 0, 0.05);\n  backdrop-filter: blur(50px);\n  z-index: 1000;\n\n  &.hovering::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    border-radius: var(--X-Large, 8px);\n    border: 4px dashed var(--Gradients-Colour-None, #c0f7ff);\n    box-shadow:\n      0px 4px 4px 0px rgba(0, 0, 0, 0.25),\n      3px 4px 24px 0px rgba(255, 255, 255, 0.5) inset,\n      0px 3px 11px 0px rgba(0, 0, 0, 0.05);\n    pointer-events: none;\n    box-sizing: border-box;\n  }\n\n  &.dragging::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    border-radius: var(--X-Large, 8px);\n    border: 4px solid var(--Gradients-Colour-None, #c0f7ff);\n    pointer-events: none;\n    box-sizing: border-box;\n    box-shadow:\n      0px 4px 15px 0px rgba(0, 0, 0, 0.4),\n      3px 4px 24px 0px rgba(255, 255, 255, 0.5) inset,\n      0px 3px 11px 0px rgba(0, 0, 0, 0.05);\n    backdrop-filter: blur(15px);\n  }\n"
    ]);
    _templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _tagged_template_literal([
        "\n  .list-group-header {\n    display: flex;\n    align-items: center;\n    gap: ",
        ";\n    width: 100%;\n    padding: ",
        " ",
        " ",
        ";\n    background: none;\n    border: none;\n    border-radius: ",
        ";\n    cursor: pointer;\n    text-align: left;\n    font: inherit;\n    color: ",
        ";\n\n    &:hover {\n      background: ",
        ";\n    }\n\n    &:focus-visible {\n      outline: none;\n      box-shadow: ",
        ";\n    }\n  }\n\n  .chevron {\n    flex-shrink: 0;\n    color: ",
        ";\n  }\n\n  .list-group-icon {\n    display: inline-flex;\n    flex-shrink: 0;\n  }\n\n  .list-group-title {\n    font-size: ",
        ";\n    font-weight: ",
        ";\n  }\n\n  .list-group-count {\n    font-size: ",
        ";\n    color: ",
        ";\n    font-variant-numeric: tabular-nums;\n  }\n\n  .list-group-hint {\n    font-size: ",
        ";\n    line-height: ",
        ";\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject6 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _tagged_template_literal([
        "\n  background: ",
        ";\n  box-shadow:\n    0 0 0 2px ",
        ",\n    0 0 16px 4px ",
        ";\n"
    ]);
    _templateObject7 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _tagged_template_literal([
        "\n  &[",
        "]:not([",
        "='fading']) {\n    box-shadow: ",
        ";\n  }\n  &[",
        "='fading'] {\n    transition: box-shadow ",
        " ",
        ";\n  }\n  @media (prefers-reduced-motion: reduce) {\n    &[",
        "='fading'] {\n      transition: none;\n    }\n  }\n"
    ]);
    _templateObject8 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _tagged_template_literal([
        "\n  /* On the row itself, not only on .linked: a transition declared only on the class leaves with\n     it, so the linked look snapped off instead of fading out (spec R13). */\n  transition:\n    box-shadow ",
        " ",
        ",\n    background ",
        " ",
        ";\n\n  &:hover,\n  &.hovered {\n    background: ",
        ";\n    box-shadow: ",
        ";\n  }\n\n  &.selected {\n    background: ",
        ";\n    box-shadow: ",
        ";\n  }\n\n  /* Jumped to: the glow alone, on the row's resting background (Rob's ruling of 2026-10-27). */\n  &.linked {\n    box-shadow: ",
        ";\n  }\n\n  &.drop-target {\n    ",
        "\n  }\n\n  ",
        "\n  &.glow-arrived {\n    box-shadow: ",
        ";\n  }\n\n  /* A total the operator has just added: the fading glow (board v2 NEW). After .selected, so it\n     wins while it lasts (frame 07 draws the new row so while Add is open). Its removal fades on the\n     row's own transition, and snaps off under reduced motion. */\n  &.glow-new,\n  &.selected.glow-new {\n    box-shadow: ",
        ";\n  }\n\n  @media (prefers-reduced-motion: reduce) {\n    & {\n      transition: none;\n    }\n  }\n"
    ]);
    _templateObject9 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _tagged_template_literal([
        "\n  opacity: 0.55;\n  background: ",
        ";\n  border-style: dashed;\n  border-color: color-mix(in srgb, ",
        " 55%, transparent);\n  box-shadow: none;\n"
    ]);
    _templateObject10 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _tagged_template_literal([
        "\n  .",
        " {\n    box-sizing: border-box;\n    margin: ",
        ";\n    width: auto !important;\n    right: 0;\n    border: 1.5px dashed ",
        ";\n    border-radius: ",
        ";\n    background: ",
        ";\n  }\n"
    ]);
    _templateObject11 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _tagged_template_literal([
        "\n  flex: none;\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: ",
        "px;\n  height: ",
        "px;\n  border-radius: ",
        ";\n  color: ",
        ";\n  background: ",
        ";\n  box-shadow: ",
        ";\n"
    ]);
    _templateObject12 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _tagged_template_literal([
        "\n  color: ",
        ";\n  font-size: ",
        ";\n  /* The second line's own height (frame 11), so a note never makes the row taller. */\n  line-height: inherit;\n  overflow-wrap: anywhere;\n"
    ]);
    _templateObject13 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _tagged_template_literal([
        "\n  display: inline-flex;\n  justify-content: center;\n  width: 16px;\n  flex-shrink: 0;\n  color: ",
        ";\n  cursor: grab;\n"
    ]);
    _templateObject14 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n  padding: 0.4rem 0.5rem;\n  border-radius: 8px;\n\n  /* The onboarding list's row looks (listRowLook): hover — also while the plan's pointer is over\n     the entity — the picked row, and the mint glow of a row that has just changed group. */\n  ",
        "\n\n  .kind {\n    position: relative;\n    display: inline-flex;\n    flex-shrink: 0;\n  }\n\n  .kind-icon {\n    color: ",
        ";\n    flex-shrink: 0;\n  }\n\n  /* A host's marker sits on the kind icon's corner (v3 design, state 05). */\n  .kind-dot {\n    position: absolute;\n    right: -3px;\n    bottom: -3px;\n  }\n\n  .row-select {\n    display: flex;\n    align-items: center;\n    /* A host's state line wraps onto its own line, so the name keeps its width. */\n    flex-wrap: wrap;\n    gap: 0.4rem;\n    flex: 1;\n    min-width: 0;\n    padding: 0;\n    background: none;\n    border: none;\n    cursor: pointer;\n    font-size: 0.8125rem;\n    color: #333;\n    text-align: left;\n    border-radius: ",
        ";\n\n    /* A row with nothing to press (Checks' *To place*) is read, not pressed. */\n    &.not-pressable {\n      cursor: default;\n    }\n\n    /* A keyboard focus ring from the token (spec FR16): the browser's default was all the row had,\n       and it varies by browser. The tight ring, as the list group's header draws it. */\n    &:focus-visible {\n      outline: none;\n      box-shadow: ",
        ";\n    }\n  }\n\n  /* A name is never cut off (Rob, 2026-09-24): a truncated machine name is one an operator cannot\n     act on. Where it does not fit, it wraps — `anywhere`, so a long unbroken code still wraps\n     rather than widening the row. */\n  .row-label {\n    flex: 1;\n    min-width: 0;\n    white-space: normal;\n    overflow-wrap: anywhere;\n  }\n\n  .expander {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 16px;\n    flex-shrink: 0;\n    padding: 0;\n    background: none;\n    border: none;\n    cursor: pointer;\n    color: #a3a3a3;\n\n    svg {\n      transition: transform 0.15s ease;\n    }\n\n    &.open svg {\n      transform: rotate(90deg);\n    }\n\n    &:focus-visible {\n      outline: none;\n      border-radius: ",
        ";\n      box-shadow: ",
        ";\n    }\n  }\n\n  .expander-spacer {\n    width: 16px;\n    flex-shrink: 0;\n  }\n\n  /* ---- The disc look (floor-plan-page-list-rows) — every rule below is scoped to .look-disc, so\n     the plain row's computed style is exactly what it was. Measured off Rob's frames at 1:1\n     (packages/ui/design-cards/PROVENANCE.md, \"Onboarding list rows\"). ---- */\n  &.look-disc {\n    position: relative;\n    gap: 0;\n    /* A 1 px edge at rest, so the dragged look's dashed edge moves nothing (frame 09). */\n    border: ",
        "px solid transparent;\n    /* Targets frame 11's 46 px two-line row: 1 + 5 + 20 (name) + 14 (second line) + 5 + 1. Built,\n       it measures 47 px — the mono code's strut on the second line (PROVENANCE). */\n    padding-top: calc(",
        " + 1px);\n    padding-bottom: calc(",
        " + 1px);\n\n    /* An open branch's chevron points down (frame 11). The plain look's rule targets an `svg`\n       the Font Awesome font build never renders, so it is matched on the glyph here. */\n    .expander.open .fa-chevron-right {\n      transform: rotate(90deg);\n    }\n\n    .kind {\n      margin-right: ",
        "px;\n    }\n\n    /* The disc carries the glyph's colour: grey at rest, teal on frost when selected. */\n    .kind-icon {\n      color: inherit;\n    }\n\n    /* Frame 11: the state dot sits flush on the disc's lower-right corner. */\n    .kind-dot {\n      right: 0;\n      bottom: 0;\n      line-height: 0;\n    }\n\n    .row-select {\n      flex-wrap: nowrap;\n      gap: ",
        ";\n      font-size: ",
        ";\n      line-height: ",
        ";\n      color: ",
        ";\n    }\n\n    /* Frames 03 and 11: the selected row's name is teal and semibold. */\n    &.selected .row-label {\n      color: ",
        ";\n      font-weight: ",
        ";\n    }\n\n    .row-lines {\n      display: flex;\n      flex-direction: column;\n      flex: 1;\n      min-width: 0;\n    }\n\n    .row-line-1 {\n      display: flex;\n      align-items: center;\n      gap: ",
        "px;\n      min-width: 0;\n    }\n\n    .row-line-2 {\n      font-size: ",
        ";\n      line-height: ",
        ";\n      color: ",
        ";\n      overflow-wrap: anywhere;\n    }\n\n    /* A second line holding a control (`subAction`): the button and the line stacked in one\n       column, the button stretched over the whole row by its ::after so the line's words press it,\n       and the control lifted above that cover (`duplicate-holder-links`). */\n    .row-body {\n      display: flex;\n      flex-direction: column;\n      flex: 1;\n      min-width: 0;\n    }\n\n    .row-body > .row-select {\n      flex: none;\n      width: 100%;\n    }\n\n    .row-select.stretched::after {\n      content: '';\n      position: absolute;\n      inset: 0;\n    }\n\n    /* The controls a stretched button would otherwise cover. */\n    .row-sub-action,\n    .row-actions {\n      position: relative;\n      z-index: 1;\n    }\n\n    /* The BID on the second line: plain mono text, the Composite measures list's code size. A\n       descendant, not a child: with `subAction` the line's words sit in an aria-hidden span. */\n    .row-line-2 .row-code {\n      font-family: ",
        ";\n      font-size: ",
        ";\n      line-height: ",
        ";\n      color: ",
        ";\n    }\n\n    .row-trailing {\n      display: inline-flex;\n      align-items: center;\n      gap: ",
        "px;\n      flex-shrink: 0;\n      margin-left: auto;\n    }\n\n    /* Frame 11: one 1 px line per ancestor level, at that level's chevron, the full row height, so\n       stacked rows draw a continuous guide. The selected row's frost covers them, as drawn. */\n    .row-guide {\n      position: absolute;\n      top: -1px;\n      bottom: -1px;\n      width: 1px;\n      background: ",
        ";\n      pointer-events: none;\n    }\n\n    &.selected .row-guide,\n    &.linked .row-guide,\n    &.drop-target .row-guide {\n      display: none;\n    }\n\n    &.dragging {\n      ",
        "\n    }\n\n    .row-label.muted {\n      color: ",
        ";\n    }\n\n    /* Frame 15's square chip behind a reference's glyph: the disc's size, fill and lift, square. */\n    .kind-square {\n      display: inline-flex;\n      align-items: center;\n      justify-content: center;\n      width: ",
        "px;\n      height: ",
        "px;\n      border-radius: ",
        ";\n      background: ",
        ";\n      box-shadow: ",
        ";\n      color: ",
        ";\n    }\n\n    .row-editing {\n      display: inline-flex;\n      flex: 1;\n      min-width: 0;\n    }\n\n    .row-actions {\n      display: inline-flex;\n      align-items: center;\n      gap: ",
        ";\n      flex-shrink: 0;\n      margin-left: ",
        ";\n    }\n  }\n"
    ], [
        "\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n  padding: 0.4rem 0.5rem;\n  border-radius: 8px;\n\n  /* The onboarding list's row looks (listRowLook): hover — also while the plan's pointer is over\n     the entity — the picked row, and the mint glow of a row that has just changed group. */\n  ",
        "\n\n  .kind {\n    position: relative;\n    display: inline-flex;\n    flex-shrink: 0;\n  }\n\n  .kind-icon {\n    color: ",
        ";\n    flex-shrink: 0;\n  }\n\n  /* A host's marker sits on the kind icon's corner (v3 design, state 05). */\n  .kind-dot {\n    position: absolute;\n    right: -3px;\n    bottom: -3px;\n  }\n\n  .row-select {\n    display: flex;\n    align-items: center;\n    /* A host's state line wraps onto its own line, so the name keeps its width. */\n    flex-wrap: wrap;\n    gap: 0.4rem;\n    flex: 1;\n    min-width: 0;\n    padding: 0;\n    background: none;\n    border: none;\n    cursor: pointer;\n    font-size: 0.8125rem;\n    color: #333;\n    text-align: left;\n    border-radius: ",
        ";\n\n    /* A row with nothing to press (Checks' *To place*) is read, not pressed. */\n    &.not-pressable {\n      cursor: default;\n    }\n\n    /* A keyboard focus ring from the token (spec FR16): the browser's default was all the row had,\n       and it varies by browser. The tight ring, as the list group's header draws it. */\n    &:focus-visible {\n      outline: none;\n      box-shadow: ",
        ";\n    }\n  }\n\n  /* A name is never cut off (Rob, 2026-09-24): a truncated machine name is one an operator cannot\n     act on. Where it does not fit, it wraps — \\`anywhere\\`, so a long unbroken code still wraps\n     rather than widening the row. */\n  .row-label {\n    flex: 1;\n    min-width: 0;\n    white-space: normal;\n    overflow-wrap: anywhere;\n  }\n\n  .expander {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 16px;\n    flex-shrink: 0;\n    padding: 0;\n    background: none;\n    border: none;\n    cursor: pointer;\n    color: #a3a3a3;\n\n    svg {\n      transition: transform 0.15s ease;\n    }\n\n    &.open svg {\n      transform: rotate(90deg);\n    }\n\n    &:focus-visible {\n      outline: none;\n      border-radius: ",
        ";\n      box-shadow: ",
        ";\n    }\n  }\n\n  .expander-spacer {\n    width: 16px;\n    flex-shrink: 0;\n  }\n\n  /* ---- The disc look (floor-plan-page-list-rows) — every rule below is scoped to .look-disc, so\n     the plain row's computed style is exactly what it was. Measured off Rob's frames at 1:1\n     (packages/ui/design-cards/PROVENANCE.md, \"Onboarding list rows\"). ---- */\n  &.look-disc {\n    position: relative;\n    gap: 0;\n    /* A 1 px edge at rest, so the dragged look's dashed edge moves nothing (frame 09). */\n    border: ",
        "px solid transparent;\n    /* Targets frame 11's 46 px two-line row: 1 + 5 + 20 (name) + 14 (second line) + 5 + 1. Built,\n       it measures 47 px — the mono code's strut on the second line (PROVENANCE). */\n    padding-top: calc(",
        " + 1px);\n    padding-bottom: calc(",
        " + 1px);\n\n    /* An open branch's chevron points down (frame 11). The plain look's rule targets an \\`svg\\`\n       the Font Awesome font build never renders, so it is matched on the glyph here. */\n    .expander.open .fa-chevron-right {\n      transform: rotate(90deg);\n    }\n\n    .kind {\n      margin-right: ",
        "px;\n    }\n\n    /* The disc carries the glyph's colour: grey at rest, teal on frost when selected. */\n    .kind-icon {\n      color: inherit;\n    }\n\n    /* Frame 11: the state dot sits flush on the disc's lower-right corner. */\n    .kind-dot {\n      right: 0;\n      bottom: 0;\n      line-height: 0;\n    }\n\n    .row-select {\n      flex-wrap: nowrap;\n      gap: ",
        ";\n      font-size: ",
        ";\n      line-height: ",
        ";\n      color: ",
        ";\n    }\n\n    /* Frames 03 and 11: the selected row's name is teal and semibold. */\n    &.selected .row-label {\n      color: ",
        ";\n      font-weight: ",
        ";\n    }\n\n    .row-lines {\n      display: flex;\n      flex-direction: column;\n      flex: 1;\n      min-width: 0;\n    }\n\n    .row-line-1 {\n      display: flex;\n      align-items: center;\n      gap: ",
        "px;\n      min-width: 0;\n    }\n\n    .row-line-2 {\n      font-size: ",
        ";\n      line-height: ",
        ";\n      color: ",
        ";\n      overflow-wrap: anywhere;\n    }\n\n    /* A second line holding a control (\\`subAction\\`): the button and the line stacked in one\n       column, the button stretched over the whole row by its ::after so the line's words press it,\n       and the control lifted above that cover (\\`duplicate-holder-links\\`). */\n    .row-body {\n      display: flex;\n      flex-direction: column;\n      flex: 1;\n      min-width: 0;\n    }\n\n    .row-body > .row-select {\n      flex: none;\n      width: 100%;\n    }\n\n    .row-select.stretched::after {\n      content: '';\n      position: absolute;\n      inset: 0;\n    }\n\n    /* The controls a stretched button would otherwise cover. */\n    .row-sub-action,\n    .row-actions {\n      position: relative;\n      z-index: 1;\n    }\n\n    /* The BID on the second line: plain mono text, the Composite measures list's code size. A\n       descendant, not a child: with \\`subAction\\` the line's words sit in an aria-hidden span. */\n    .row-line-2 .row-code {\n      font-family: ",
        ";\n      font-size: ",
        ";\n      line-height: ",
        ";\n      color: ",
        ";\n    }\n\n    .row-trailing {\n      display: inline-flex;\n      align-items: center;\n      gap: ",
        "px;\n      flex-shrink: 0;\n      margin-left: auto;\n    }\n\n    /* Frame 11: one 1 px line per ancestor level, at that level's chevron, the full row height, so\n       stacked rows draw a continuous guide. The selected row's frost covers them, as drawn. */\n    .row-guide {\n      position: absolute;\n      top: -1px;\n      bottom: -1px;\n      width: 1px;\n      background: ",
        ";\n      pointer-events: none;\n    }\n\n    &.selected .row-guide,\n    &.linked .row-guide,\n    &.drop-target .row-guide {\n      display: none;\n    }\n\n    &.dragging {\n      ",
        "\n    }\n\n    .row-label.muted {\n      color: ",
        ";\n    }\n\n    /* Frame 15's square chip behind a reference's glyph: the disc's size, fill and lift, square. */\n    .kind-square {\n      display: inline-flex;\n      align-items: center;\n      justify-content: center;\n      width: ",
        "px;\n      height: ",
        "px;\n      border-radius: ",
        ";\n      background: ",
        ";\n      box-shadow: ",
        ";\n      color: ",
        ";\n    }\n\n    .row-editing {\n      display: inline-flex;\n      flex: 1;\n      min-width: 0;\n    }\n\n    .row-actions {\n      display: inline-flex;\n      align-items: center;\n      gap: ",
        ";\n      flex-shrink: 0;\n      margin-left: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject15 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = _tagged_template_literal([
        "\n  display: inline-flex;\n  align-items: center;\n  min-height: 22px;\n  padding: 3px 10px;\n  border-radius: ",
        ";\n  background: rgba(255, 255, 255, 0.88);\n  backdrop-filter: ",
        ";\n  -webkit-backdrop-filter: ",
        ";\n  box-shadow: 0 2px 8px rgba(",
        ", 0.12);\n  color: ",
        ";\n  font-size: ",
        ";\n  line-height: ",
        ";\n  font-weight: ",
        ";\n  /* Flex items default to min-width:auto and will not shrink below their content, so without this\n     a long name overflows the pill and is hard-clipped by Inner instead of ellipsising. */\n  min-width: 0;\n"
    ]);
    _templateObject16 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = _tagged_template_literal([
        "\n  display: block;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n"
    ]);
    _templateObject17 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = _tagged_template_literal([
        "\n  from {\n    opacity: 0;\n  }\n"
    ]);
    _templateObject18 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = _tagged_template_literal([
        "\n  position: absolute;\n  inset: 0;\n  background: color-mix(in srgb, ",
        " 55%, transparent);\n  backdrop-filter: ",
        ";\n  -webkit-backdrop-filter: ",
        ";\n  animation: ",
        " ",
        "ms ",
        " backwards;\n\n  @media (prefers-reduced-motion: reduce) {\n    animation: none;\n  }\n"
    ]);
    _templateObject19 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = _tagged_template_literal([
        "\n  flex: none;\n  width: 6px;\n  height: 6px;\n  border-radius: ",
        ";\n  background: ",
        ";\n"
    ]);
    _templateObject20 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: center;\n  gap: ",
        ";\n  min-width: 0;\n  /* Card 21's .cw-pfoot geometry: 6 / 5 / 7 px, no token step for the 5 and the 7. */\n  padding: 6px 5px 7px;\n  font-size: ",
        ";\n  line-height: ",
        ";\n  color: ",
        ";\n\n  .grip {\n    flex: none;\n    color: ",
        ";\n  }\n  .label {\n    flex: none;\n    font-weight: ",
        ";\n    white-space: nowrap;\n  }\n  .label.is-not-placed {\n    color: ",
        ";\n  }\n  .camera {\n    min-width: 0;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    color: ",
        ";\n  }\n  [data-placement-hint] {\n    margin-left: auto;\n    min-width: 0;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    color: ",
        ";\n    font-weight: ",
        ";\n    opacity: 0;\n    transition: opacity ",
        " ",
        ";\n\n    @media (prefers-reduced-motion: reduce) {\n      transition: none;\n    }\n  }\n"
    ]);
    _templateObject21 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = _tagged_template_literal([
        "\n  display: inline-flex;\n  align-items: center;\n  gap: ",
        ";\n  flex: 0 1 auto;\n  min-height: 28px;\n  min-width: 0;\n  padding: ",
        " ",
        ";\n  box-sizing: border-box;\n  border-radius: ",
        ";\n  background: rgba(255, 255, 255, 0.95);\n  box-shadow: 0 2px 8px rgba(",
        ", 0.14);\n  font-size: ",
        ";\n  line-height: ",
        ";\n  font-weight: ",
        ";\n  color: ",
        ";\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n\n  b {\n    display: inline-flex;\n    align-items: center;\n    gap: ",
        ";\n    flex: none;\n    font-weight: ",
        ";\n  }\n  b.is-not-placed {\n    color: ",
        ";\n  }\n  .sentence {\n    min-width: 0;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n"
    ]);
    _templateObject22 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = _tagged_template_literal([
        "\n          height: 100%;\n        "
    ]);
    _templateObject23 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = _tagged_template_literal([
        "\n          aspect-ratio: 16 / 9;\n        "
    ]);
    _templateObject24 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = _tagged_template_literal([
        "\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  /* In the grid the cell is a fixed 16:9 so the grid stays even whatever ratios the cameras give.\n     Enlarged, the surrounding box has already been sized to the feed's own ratio, so the cell fills\n     it instead — see ExpandedPanel in CameraWall.tsx and the zoom's layer. */\n  ",
        "\n"
    ]);
    _templateObject25 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject26() {
    var data = _tagged_template_literal([
        "\n          box-shadow: ",
        ";\n        "
    ]);
    _templateObject26 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject27() {
    var data = _tagged_template_literal([
        "\n  position: relative;\n  box-sizing: border-box;\n  width: ",
        ";\n  height: ",
        ';\n  /* The health border belongs to the IMAGE, not the cell — card 21, "Border". */\n  padding: 1.5px;\n  background: ',
        ";\n  border-radius: ",
        ";\n  container-type: inline-size;\n  container-name: feed;\n\n  /* The selected glow — the design system's own selected shadow (Rob, 2026-09-30), replacing the\n     interim 2px cyan ring. An outset box-shadow rather than a border or extra padding, so the\n     tile's own geometry — the health border, the feed box's exact ratio — is untouched and the grid\n     does not shift when a tile is picked. See CameraWallTileProps.selected. */\n  ",
        "\n\n  /* The whole-tile button's FOCUS RING, drawn here rather than on the button. ExpandHit and\n     SelectHit fill Inner, which clips (overflow: hidden), and --tl-focus is entirely\n     outset — so a ring on the button itself was clipped away to nothing and a keyboard operator\n     could not see which tile had focus (camera-feeds-selection review). Feed does not clip.\n     Composed with the selected glow so a focused selected tile shows both. */\n  &:has([data-whole-tile-hit]:focus-visible) {\n    box-shadow: ",
        ";\n  }\n"
    ]);
    _templateObject27 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject28() {
    var data = _tagged_template_literal([
        "\n  position: relative;\n  width: 100%;\n  height: 100%;\n  border-radius: ",
        ";\n  overflow: hidden;\n  background: ",
        ";\n"
    ]);
    _templateObject28 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject29() {
    var data = _tagged_template_literal([
        "\n  width: 100%;\n  height: 100%;\n  /* `contain`, never `cover`: the box is sized from the feed's declared ratio, which falls back to\n     16:9 when a stream reports no size. Where the declaration is right, contain and cover paint the\n     same pixels; where it is wrong, contain letterboxes inside the box and cover would crop — card\n     21's first rule is \"never crop a feed\". */\n  object-fit: contain;\n  display: block;\n  filter: ",
        ";\n"
    ], [
        "\n  width: 100%;\n  height: 100%;\n  /* \\`contain\\`, never \\`cover\\`: the box is sized from the feed's declared ratio, which falls back to\n     16:9 when a stream reports no size. Where the declaration is right, contain and cover paint the\n     same pixels; where it is wrong, contain letterboxes inside the box and cover would crop — card\n     21's first rule is \"never crop a feed\". */\n  object-fit: contain;\n  display: block;\n  filter: ",
        ";\n"
    ]);
    _templateObject29 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject30() {
    var data = _tagged_template_literal([
        "\n  position: absolute;\n  inset: 0;\n  z-index: 1;\n  pointer-events: none;\n"
    ]);
    _templateObject30 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject31() {
    var data = _tagged_template_literal([
        "\n  position: absolute;\n  inset: 0;\n  background: ",
        ";\n  pointer-events: none;\n"
    ]);
    _templateObject31 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject32() {
    var data = _tagged_template_literal([
        "\n          @container feed (max-width: ",
        "px) {\n            right: ",
        ";\n          }\n        "
    ]);
    _templateObject32 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject33() {
    var data = _tagged_template_literal([
        "\n  position: absolute;\n  z-index: 2;\n  top: ",
        ";\n  left: ",
        ";\n  /* Clear of the top-right control: 42 px for a 28 px button; card 21's enlarged chrome keeps 60. */\n  right: ",
        ";\n  display: flex;\n\n  ",
        "\n"
    ]);
    _templateObject33 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject34() {
    var data = _tagged_template_literal([
        "\n  min-height: 28px;\n  padding: 4px 12px;\n  font-size: ",
        ";\n  line-height: ",
        ";\n"
    ]);
    _templateObject34 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject35() {
    var data = _tagged_template_literal([
        "\n  ",
        "\n"
    ]);
    _templateObject35 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject36() {
    var data = _tagged_template_literal([
        "\n  width: 28px;\n  height: 28px;\n  border: none;\n  border-radius: ",
        ";\n  background: rgba(255, 255, 255, 0.72);\n  backdrop-filter: ",
        ";\n  -webkit-backdrop-filter: ",
        ";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: ",
        ";\n  color: ",
        ";\n  cursor: pointer;\n  transition: all ",
        " ",
        ";\n\n  &:hover {\n    background: rgba(255, 255, 255, 0.92);\n    box-shadow: ",
        ";\n  }\n  &:focus-visible {\n    outline: none;\n    box-shadow: var(--tl-focus-tight);\n  }\n"
    ]);
    _templateObject36 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject37() {
    var data = _tagged_template_literal([
        "\n          @container feed (max-width: ",
        "px) {\n            display: none;\n          }\n        "
    ]);
    _templateObject37 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject38() {
    var data = _tagged_template_literal([
        "\n  position: absolute;\n  z-index: 4;\n  top: ",
        ";\n  right: ",
        ";\n\n  ",
        "\n"
    ]);
    _templateObject38 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject39() {
    var data = _tagged_template_literal([
        "\n  position: absolute;\n  z-index: ",
        ";\n  ",
        "\n  left: ",
        ";\n  right: ",
        ";\n  bottom: ",
        ";\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  gap: ",
        ";\n"
    ]);
    _templateObject39 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject40() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: ",
        ";\n  gap: ",
        ";\n  min-width: 0;\n"
    ]);
    _templateObject40 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject41() {
    var data = _tagged_template_literal([
        "\n  flex: 1;\n"
    ]);
    _templateObject41 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject42() {
    var data = _tagged_template_literal([
        "\n          @container feed (max-width: ",
        "px) {\n            justify-content: center;\n            gap: 0;\n            padding: 0;\n            width: ",
        ";\n            height: ",
        ";\n            min-height: ",
        ";\n            box-shadow: 0 1px 4px rgba(",
        ", 0.25);\n\n            > span {\n              display: none;\n            }\n\n            > svg {\n              width: ",
        ";\n              height: ",
        ";\n            }\n          }\n        "
    ]);
    _templateObject42 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject43() {
    var data = _tagged_template_literal([
        "\n  display: inline-flex;\n  flex: none;\n  align-items: center;\n  gap: ",
        ";\n  min-height: 22px;\n  padding: 3px 9px;\n  border-radius: ",
        ";\n  white-space: nowrap;\n  background: ",
        ";\n  color: ",
        ";\n  font-size: ",
        ";\n  line-height: ",
        ";\n  font-weight: ",
        ";\n  box-shadow: 0 2px 8px rgba(",
        ", 0.14);\n\n  ",
        "\n\n  ",
        "\n"
    ]);
    _templateObject43 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject44() {
    var data = _tagged_template_literal([
        "\n  /* Takes the pointer back from a raised, click-through Foot, so its full-time title still shows\n     on a selectable tile. A press on the stamp therefore does not select — a small area, and the\n     exact capture time is the one thing on the tile nothing else says. */\n  pointer-events: auto;\n  display: inline-flex;\n  align-items: center;\n  min-height: 22px;\n  padding: 3px 10px;\n  border-radius: ",
        ";\n  background: rgba(228, 255, 254, 0.9);\n  backdrop-filter: ",
        ";\n  -webkit-backdrop-filter: ",
        ";\n  color: ",
        ";\n  font-size: ",
        ";\n  line-height: ",
        ";\n  font-weight: ",
        ";\n  white-space: nowrap;\n  flex: none;\n  box-shadow: 0 2px 8px rgba(",
        ", 0.12);\n\n  ",
        "\n"
    ]);
    _templateObject44 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject45() {
    var data = _tagged_template_literal([
        "\n          @container feed (max-width: ",
        "px) {\n            display: none;\n          }\n        "
    ]);
    _templateObject45 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject46() {
    var data = _tagged_template_literal([
        "\n  ",
        "\n"
    ]);
    _templateObject46 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject47() {
    var data = _tagged_template_literal([
        "\n  position: absolute;\n  inset: 0;\n  border-radius: ",
        ";\n"
    ]);
    _templateObject47 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject48() {
    var data = _tagged_template_literal([
        "\n  ",
        "\n"
    ]);
    _templateObject48 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject49() {
    var data = _tagged_template_literal([
        "\n  flex: none;\n  width: 36px;\n  height: 36px;\n  border-radius: ",
        ";\n  background: ",
        ";\n  color: ",
        ";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"
    ]);
    _templateObject49 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject50() {
    var data = _tagged_template_literal([
        "\n  ",
        "\n  z-index: 2;\n  box-sizing: border-box;\n  background: linear-gradient(150deg, ",
        ", ",
        ");\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: ",
        ";\n  text-align: center;\n  padding: ",
        "px ",
        " ",
        "px;\n  overflow: hidden;\n\n  @container feed (max-width: ",
        "px) {\n    ",
        " {\n      display: none;\n    }\n  }\n"
    ]);
    _templateObject50 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject51() {
    var data = _tagged_template_literal([
        "\n  color: ",
        ";\n  font-size: ",
        ";\n  line-height: ",
        ";\n  font-weight: ",
        ";\n"
    ]);
    _templateObject51 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject52() {
    var data = _tagged_template_literal([
        "\n  display: inline-flex;\n  align-items: center;\n  height: 24px;\n  padding: 0 ",
        ";\n  border-radius: ",
        ";\n  /* The work-to-do role: adding the camera is the job this tile is waiting on, so it reads as work\n     to do, not as the dead end its state shows (ruled 2026-10-29,\n     onboarding-status-colours-camera-wall). Drawn as the status page draws work to do (wash, mark\n     edge, ink): the ink on the solid mark is 2.75:1, on the wash over this column 4.63:1 or more. */\n  border: 1px solid ",
        ";\n  background: ",
        ";\n  color: ",
        ";\n  font-size: ",
        ";\n  line-height: ",
        ";\n  font-weight: ",
        ";\n  box-shadow: ",
        ";\n  cursor: pointer;\n\n  &:focus-visible {\n    outline: none;\n    box-shadow: var(--tl-focus-tight);\n  }\n"
    ]);
    _templateObject52 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject53() {
    var data = _tagged_template_literal([
        "\n  display: inline-flex;\n  align-items: center;\n  align-self: flex-start;\n  max-width: 100%;\n  height: 24px;\n  padding: 0 ",
        ";\n  border: none;\n  border-radius: ",
        ";\n  background: ",
        ";\n  backdrop-filter: ",
        ";\n  -webkit-backdrop-filter: ",
        ";\n  color: ",
        ";\n  font-size: ",
        ";\n  line-height: ",
        ";\n  font-weight: ",
        ";\n  box-shadow: ",
        ";\n  cursor: pointer;\n  /* Takes clicks back from a raised, click-through Foot (a selectable tile). */\n  pointer-events: auto;\n  /* A long camera name ellipsises rather than pushing the pill past the tile — the same rule\n     NameLabel above exists for, and for the same reason. */\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n\n  &:focus-visible {\n    outline: none;\n    box-shadow: var(--tl-focus-tight);\n  }\n"
    ]);
    _templateObject53 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject54() {
    var data = _tagged_template_literal([
        "\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n"
    ]);
    _templateObject54 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject55() {
    var data = _tagged_template_literal([
        "\n  display: block;\n  width: ",
        ";\n  height: ",
        ";\n  border-radius: ",
        ";\n  overflow: hidden;\n  background: ",
        ";\n"
    ]);
    _templateObject55 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject56() {
    var data = _tagged_template_literal([
        "\n  display: block;\n  width: 100%;\n  height: 100%;\n  /* contain, as `Picture` says why: a stream with no declared size must letterbox, not crop. */\n  object-fit: contain;\n  filter: ",
        ";\n"
    ], [
        "\n  display: block;\n  width: 100%;\n  height: 100%;\n  /* contain, as \\`Picture\\` says why: a stream with no declared size must letterbox, not crop. */\n  object-fit: contain;\n  filter: ",
        ";\n"
    ]);
    _templateObject56 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject57() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n  border-radius: ",
        ";\n  background: linear-gradient(150deg, ",
        ", ",
        ");\n  color: ",
        ";\n"
    ]);
    _templateObject57 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject58() {
    var data = _tagged_template_literal([
        "\n  position: absolute;\n  top: 5px;\n  left: 5px;\n  max-width: calc(100% - 10px);\n  padding: ",
        " 7px 3px;\n  border-radius: ",
        ";\n  background: ",
        ";\n  color: ",
        ";\n  font-size: ",
        ";\n  line-height: ",
        ";\n  font-weight: ",
        ";\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n"
    ]);
    _templateObject58 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject59() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n"
    ]);
    _templateObject59 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject60() {
    var data = _tagged_template_literal([
        "\n  display: grid;\n  grid-template-columns: auto 1fr auto;\n  align-items: start;\n  gap: ",
        ";\n"
    ]);
    _templateObject60 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject61() {
    var data = _tagged_template_literal([
        "\n  font-family: ",
        ";\n  font-size: ",
        ";\n  line-height: ",
        ";\n  font-weight: ",
        ";\n  color: ",
        ";\n  margin: 0;\n"
    ]);
    _templateObject61 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject62() {
    var data = _tagged_template_literal([
        "\n  margin: 0;\n  font-family: ",
        ";\n  font-size: ",
        ";\n  line-height: ",
        ";\n  color: ",
        ";\n"
    ]);
    _templateObject62 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject63() {
    var data = _tagged_template_literal([
        "\n  margin: 0;\n  font-family: ",
        ";\n  font-size: ",
        ";\n  line-height: ",
        ";\n  font-variant-numeric: tabular-nums;\n  font-weight: ",
        ";\n  color: ",
        ";\n  white-space: nowrap;\n"
    ]);
    _templateObject63 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject64() {
    var data = _tagged_template_literal([
        "\n  margin: 0;\n  font-family: ",
        ";\n  font-size: ",
        ";\n  line-height: ",
        ";\n  color: ",
        ";\n"
    ]);
    _templateObject64 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject65() {
    var data = _tagged_template_literal([
        "\n  display: contents;\n"
    ]);
    _templateObject65 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject66() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n"
    ]);
    _templateObject66 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject67() {
    var data = _tagged_template_literal([
        "\n  position: relative;\n  width: ",
        "px;\n  height: ",
        "px;\n  flex: none;\n  border-radius: ",
        ";\n  overflow: hidden;\n  /* cards.css's third stop (#e6eef7) has no token: the panel tint carries on to the edge. */\n  background: radial-gradient(circle at 50% 35%, ",
        " 0%, ",
        " 70%);\n  border: 1px solid ",
        ";\n  box-shadow: inset 0 0 0 1px ",
        ";\n"
    ]);
    _templateObject67 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject68() {
    var data = _tagged_template_literal([
        "\n  position: fixed;\n  left: 0;\n  top: 0;\n  z-index: ",
        ";\n  width: ",
        "px;\n  box-sizing: border-box;\n  padding: ",
        ";\n  border-radius: ",
        ";\n  background: ",
        ";\n  border: 1.5px solid ",
        ";\n  /* Card 24: a frost glow and the glass ink's drop, both from tokens. */\n  box-shadow:\n    0 0 ",
        " 3px ",
        ",\n    0 14px 30px rgba(",
        ", 0.3);\n  pointer-events: none;\n  transform-origin: 0 100%;\n"
    ]);
    _templateObject68 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject69() {
    var data = _tagged_template_literal([
        "\n  aspect-ratio: 16 / 9;\n"
    ]);
    _templateObject69 = function _templateObject() {
        return data;
    };
    return data;
}
import { visuallyHidden } from "./chunk-MLHALTYO.mjs";
// src/components/elements/TagSwitcher/TagSwitcher.tsx
import { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import { Icon, Tag } from "@repo/design-system";
import { space } from "@repo/design-tokens";
import { jsx, jsxs } from "react/jsx-runtime";
var TagSwitcher = function(param) {
    var className = param.className, label = param.label, selectedValue = param.selectedValue, options = param.options, setValue = param.setValue, _param_activation = param.activation, activation = _param_activation === void 0 ? "automatic" : _param_activation, _param_size = param.size, size = _param_size === void 0 ? "roomy" : _param_size, disabled = param.disabled, onChange = param.onChange, children = param.children;
    var controlled = onChange !== void 0;
    useEffect(function() {
        setValue === null || setValue === void 0 ? void 0 : setValue(selectedValue);
    }, [
        selectedValue,
        setValue
    ]);
    var _useState = _sliced_to_array(useState(selectedValue ? selectedValue : ""), 2), selectedTab = _useState[0], setSelectedTab = _useState[1];
    useEffect(function() {
        if (selectedValue) {
            setSelectedTab(selectedValue);
        }
    }, [
        selectedValue
    ]);
    var refs = useRef([]);
    var _useState1 = _sliced_to_array(useState(null), 2), focusIndex = _useState1[0], setFocusIndex = _useState1[1];
    var choose = function(index) {
        var value = options[index].value;
        if (!controlled) setSelectedTab(value);
        setValue === null || setValue === void 0 ? void 0 : setValue(value);
        onChange === null || onChange === void 0 ? void 0 : onChange(value);
    };
    var enabledFrom = function(index, step) {
        for(var n = 0; n < options.length; n++){
            var i = ((index + step * n) % options.length + options.length) % options.length;
            if (!options[i].disabled) return i;
        }
        return null;
    };
    var moveTo = function(index, step) {
        var _refs_current_i;
        var i = enabledFrom(index, step);
        if (i === null) return;
        if (activation === "automatic") choose(i);
        setFocusIndex(i);
        (_refs_current_i = refs.current[i]) === null || _refs_current_i === void 0 ? void 0 : _refs_current_i.focus();
    };
    var chosen = controlled ? selectedValue : selectedTab;
    var selectedIndex = options.findIndex(function(opt) {
        return opt.value === chosen;
    });
    var _enabledFrom;
    var restingStop = selectedIndex !== -1 && !options[selectedIndex].disabled ? selectedIndex : (_enabledFrom = enabledFrom(0, 1)) !== null && _enabledFrom !== void 0 ? _enabledFrom : 0;
    var tabStop = focusIndex !== null && focusIndex < options.length && !options[focusIndex].disabled ? focusIndex : restingStop;
    return /* @__PURE__ */ jsxs("div", {
        className: className,
        role: "group",
        "aria-label": label,
        onFocus: function(e) {
            var i = refs.current.indexOf(e.target);
            if (i !== -1) setFocusIndex(i);
        },
        onBlur: function(e) {
            if (!e.currentTarget.contains(e.relatedTarget)) setFocusIndex(null);
        },
        children: [
            options.map(function(opt, index) {
                var active = opt.value === chosen;
                return /* @__PURE__ */ jsxs(Tag, {
                    ref: function(el) {
                        refs.current[index] = el;
                    },
                    surface: "on-glass",
                    size: size,
                    toggle: true,
                    active: active,
                    tone: active ? opt.tone : void 0,
                    disabled: disabled || opt.disabled,
                    count: opt.count,
                    "aria-label": opt.ariaLabel,
                    title: opt.title,
                    onToggle: function() {
                        setFocusIndex(index);
                        choose(index);
                    },
                    tabIndex: index === tabStop ? 0 : -1,
                    icon: opt.icon ? /* @__PURE__ */ jsx(Icon, {
                        name: opt.icon,
                        size: "xs",
                        variant: active ? "solid" : "regular"
                    }) : void 0,
                    onKeyDown: function(e) {
                        var target = null;
                        var step = 1;
                        if (e.key === "ArrowRight" || e.key === "ArrowDown") target = index + 1;
                        else if (e.key === "ArrowLeft" || e.key === "ArrowUp") {
                            target = index - 1;
                            step = -1;
                        } else if (e.key === "Home") target = 0;
                        else if (e.key === "End") {
                            target = options.length - 1;
                            step = -1;
                        }
                        if (target === null) return;
                        e.preventDefault();
                        moveTo(target, step);
                    },
                    children: [
                        opt.text,
                        opt.trailing
                    ]
                }, opt.value);
            }),
            children
        ]
    });
};
var TagSwitcher_default = styled(TagSwitcher)(_templateObject(), space[1]);
// src/components/elements/TLDialog/TLDialog.tsx
import { useCallback, useEffect as useEffect2, useRef as useRef2 } from "react";
import { createPortal } from "react-dom";
import styled2 from "styled-components";
import { jsx as jsx2, jsxs as jsxs2 } from "react/jsx-runtime";
var TLDialog = function(param) {
    var className = param.className, title = param.title, dialogContent = param.dialogContent, dialogActions = param.dialogActions, defaultOpen = param.defaultOpen, width = param.width, onClose = param.onClose, _param_disablePadding = param.disablePadding, disablePadding = _param_disablePadding === void 0 ? false : _param_disablePadding;
    var surfaceRef = useRef2(null);
    var returnFocusRef = useRef2(null);
    if (defaultOpen) {
        if (returnFocusRef.current === null && typeof document !== "undefined") {
            returnFocusRef.current = document.activeElement;
        }
    } else {
        returnFocusRef.current = null;
    }
    var handleEscape = useCallback(function(e) {
        if (e.key === "Escape") {
            onClose === null || onClose === void 0 ? void 0 : onClose();
        }
    }, [
        onClose
    ]);
    var handleTab = useCallback(function(e) {
        if (e.key !== "Tab" || !surfaceRef.current) return;
        var focusable = surfaceRef.current.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
        if (focusable.length === 0) return;
        var first = focusable[0];
        var last = focusable[focusable.length - 1];
        if (e.shiftKey) {
            if (document.activeElement === first) {
                e.preventDefault();
                last.focus();
            }
        } else {
            if (document.activeElement === last) {
                e.preventDefault();
                first.focus();
            }
        }
    }, []);
    useEffect2(function() {
        if (!defaultOpen) return;
        document.addEventListener("keydown", handleEscape);
        document.addEventListener("keydown", handleTab);
        return function() {
            document.removeEventListener("keydown", handleEscape);
            document.removeEventListener("keydown", handleTab);
        };
    }, [
        defaultOpen,
        handleEscape,
        handleTab
    ]);
    useEffect2(function() {
        var _surfaceRef_current;
        if (!defaultOpen) return;
        var restoreTo = returnFocusRef.current;
        var prevOverflow = document.body.style.overflow;
        document.body.style.overflow = "hidden";
        (_surfaceRef_current = surfaceRef.current) === null || _surfaceRef_current === void 0 ? void 0 : _surfaceRef_current.focus();
        return function() {
            document.body.style.overflow = prevOverflow;
            if (_instanceof(restoreTo, HTMLElement) && restoreTo.isConnected) restoreTo.focus();
        };
    }, [
        defaultOpen
    ]);
    if (!defaultOpen) return null;
    var surfaceStyle = _object_spread({}, width ? {
        maxWidth: width,
        width: width
    } : {}, disablePadding ? {
        padding: 0,
        overflowX: "hidden"
    } : {});
    var dialog = /* @__PURE__ */ jsxs2("div", {
        className: className,
        role: "dialog",
        "aria-modal": "true",
        "aria-label": title,
        children: [
            /* @__PURE__ */ jsx2("div", {
                className: "dialog-overlay",
                onClick: onClose
            }),
            /* @__PURE__ */ jsxs2("div", {
                className: "dialog-surface",
                ref: surfaceRef,
                style: surfaceStyle,
                tabIndex: -1,
                children: [
                    title && !disablePadding && /* @__PURE__ */ jsx2("div", {
                        className: "dialog-title",
                        children: title
                    }),
                    /* @__PURE__ */ jsx2("div", {
                        className: "dialog-content",
                        children: dialogContent
                    }),
                    dialogActions && /* @__PURE__ */ jsx2("div", {
                        className: "dialog-actions",
                        children: dialogActions
                    })
                ]
            })
        ]
    });
    return createPortal(dialog, document.body);
};
var TLDialog_default = styled2(TLDialog)(_templateObject1());
// src/components/elements/ConfirmDialog/ConfirmDialog.tsx
import styled3 from "styled-components";
import { focus } from "@repo/design-tokens";
import { Fragment, jsx as jsx3, jsxs as jsxs3 } from "react/jsx-runtime";
var ConfirmDialog = function(param) {
    var mode = param.mode, title = param.title, message = param.message, confirmLabel = param.confirmLabel, cancelLabel = param.cancelLabel, alternativeLabel = param.alternativeLabel, _param_danger = param.danger, danger = _param_danger === void 0 ? false : _param_danger, width = param.width, onConfirm = param.onConfirm, onCancel = param.onCancel, onAlternative = param.onAlternative;
    return /* @__PURE__ */ jsx3(TLDialog_default, {
        defaultOpen: true,
        width: width !== null && width !== void 0 ? width : "440px",
        title: title !== null && title !== void 0 ? title : mode === "alert" ? "Notice" : "Please confirm",
        onClose: onCancel,
        dialogContent: /* @__PURE__ */ jsx3(Message, {
            children: message
        }),
        dialogActions: /* @__PURE__ */ jsxs3(Fragment, {
            children: [
                mode !== "alert" && /* @__PURE__ */ jsx3(SecondaryButton, {
                    type: "button",
                    onClick: onCancel,
                    children: cancelLabel !== null && cancelLabel !== void 0 ? cancelLabel : "Cancel"
                }),
                mode === "choose" && /* @__PURE__ */ jsx3(SecondaryButton, {
                    type: "button",
                    onClick: onAlternative,
                    children: alternativeLabel
                }),
                /* @__PURE__ */ jsx3(PrimaryButton, {
                    type: "button",
                    $danger: danger,
                    onClick: onConfirm,
                    autoFocus: true,
                    children: confirmLabel !== null && confirmLabel !== void 0 ? confirmLabel : mode === "alert" ? "OK" : "Confirm"
                })
            ]
        })
    });
};
var Message = styled3.div(_templateObject2());
var buttonBase = "\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0.5rem 1rem;\n  border-radius: 8px;\n  font-size: 0.875rem;\n  font-weight: 600;\n  cursor: pointer;\n\n  /* Both buttons carried only the browser's default outline, which the danger variant's red fill\n     swallows almost entirely. The ring comes from the design tokens rather than a hex literal, so a\n     token refresh reaches it — and so that this dialog matches every design-system control the app\n     has already migrated. */\n  &:focus-visible {\n    outline: none;\n    box-shadow: ".concat(focus.ring, ";\n  }\n");
var SecondaryButton = styled3.button(_templateObject3(), buttonBase);
var PrimaryButton = styled3.button(_templateObject4(), buttonBase, function(param) {
    var $danger = param.$danger;
    return $danger ? "#d13438" : "#00bbcc";
}, function(param) {
    var $danger = param.$danger;
    return $danger ? "#d13438" : "#00bbcc";
}, function(param) {
    var $danger = param.$danger;
    return $danger ? "#b52b2f" : "#00a5b5";
}, function(param) {
    var $danger = param.$danger;
    return $danger ? "#b52b2f" : "#00a5b5";
});
// src/components/elements/ConfirmDialog/useConfirm.tsx
import { useCallback as useCallback2, useEffect as useEffect3, useRef as useRef3, useState as useState2 } from "react";
import { jsx as jsx4 } from "react/jsx-runtime";
function useConfirm() {
    var _useState2 = _sliced_to_array(useState2(null), 2), request = _useState2[0], setRequest = _useState2[1];
    var resolverRef = useRef3(null);
    var settle = useCallback2(function(result) {
        var resolve = resolverRef.current;
        resolverRef.current = null;
        setRequest(null);
        resolve === null || resolve === void 0 ? void 0 : resolve(result);
    }, []);
    var claim = useCallback2(function(resolve) {
        var previous = resolverRef.current;
        resolverRef.current = resolve;
        previous === null || previous === void 0 ? void 0 : previous("cancel");
    }, []);
    var confirm = useCallback2(function(options) {
        return new Promise(function(resolve) {
            claim(function(outcome) {
                return resolve(outcome === "confirm");
            });
            setRequest(_object_spread({
                mode: "confirm"
            }, options));
        });
    }, [
        claim
    ]);
    var alert = useCallback2(function(options) {
        return new Promise(function(resolve) {
            claim(function() {
                return resolve();
            });
            setRequest(_object_spread({
                mode: "alert"
            }, options));
        });
    }, [
        claim
    ]);
    var choose = useCallback2(function(options) {
        return new Promise(function(resolve) {
            claim(resolve);
            setRequest(_object_spread({
                mode: "choose"
            }, options));
        });
    }, [
        claim
    ]);
    useEffect3(function() {
        return function() {
            var pending = resolverRef.current;
            resolverRef.current = null;
            pending === null || pending === void 0 ? void 0 : pending("cancel");
        };
    }, []);
    var dialog = request === null ? null : request.mode === "choose" ? /* @__PURE__ */ jsx4(ConfirmDialog, _object_spread_props(_object_spread({}, request), {
        onConfirm: function() {
            return settle("confirm");
        },
        onAlternative: function() {
            return settle("alternative");
        },
        onCancel: function() {
            return settle("cancel");
        }
    })) : /* @__PURE__ */ jsx4(ConfirmDialog, _object_spread_props(_object_spread({}, request), {
        onConfirm: function() {
            return settle("confirm");
        },
        onCancel: function() {
            return settle("cancel");
        }
    }));
    return {
        confirm: confirm,
        alert: alert,
        choose: choose,
        dialog: dialog
    };
}
// src/components/DraggablePanel/useDragPosition.ts
import { useCallback as useCallback3, useEffect as useEffect4, useRef as useRef4, useState as useState3 } from "react";
var CAPTURE_PX = 4;
var ARROWS = {
    ArrowLeft: [
        -1,
        0
    ],
    ArrowRight: [
        1,
        0
    ],
    ArrowUp: [
        0,
        -1
    ],
    ArrowDown: [
        0,
        1
    ]
};
var useDragPosition = function(param) {
    var targetRef = param.targetRef, boundsRef = param.boundsRef, tmp = param.inset, inset5 = tmp === void 0 ? 0 : tmp, _param_rightInset = param.rightInset, rightInset = _param_rightInset === void 0 ? 0 : _param_rightInset, controlled = param.position, onCommit = param.onCommit, keyboard = param.keyboard, onHome = param.onHome, _param_threshold = param.threshold, threshold = _param_threshold === void 0 ? 4 : _param_threshold, _param_live = param.live, live = _param_live === void 0 ? "transform" : _param_live;
    var _useState3 = _sliced_to_array(useState3({
        x: 0,
        y: 0
    }), 2), own = _useState3[0], setOwn = _useState3[1];
    var resting = controlled !== null && controlled !== void 0 ? controlled : own;
    var restingRef = useRef4(resting);
    restingRef.current = resting;
    var _useState31 = _sliced_to_array(useState3(false), 2), isDragging = _useState31[0], setIsDragging = _useState31[1];
    var press = useRef4(null);
    var frame = useRef4(null);
    var framePending = useRef4(false);
    var measureBox = useCallback3(function() {
        var target = targetRef.current;
        var bounds = boundsRef === null || boundsRef === void 0 ? void 0 : boundsRef.current;
        var r = bounds ? bounds.getBoundingClientRect() : null;
        var _target_offsetWidth, _target_offsetHeight;
        return {
            width: r ? r.width : window.innerWidth,
            height: r ? r.height : window.innerHeight,
            right: bounds ? 0 : rightInset,
            w: (_target_offsetWidth = target === null || target === void 0 ? void 0 : target.offsetWidth) !== null && _target_offsetWidth !== void 0 ? _target_offsetWidth : 0,
            h: (_target_offsetHeight = target === null || target === void 0 ? void 0 : target.offsetHeight) !== null && _target_offsetHeight !== void 0 ? _target_offsetHeight : 0
        };
    }, [
        targetRef,
        boundsRef,
        rightInset
    ]);
    var clamp = useCallback3(function(p) {
        var box = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : measureBox();
        var maxX = box.width - box.right - inset5 - box.w;
        var maxY = box.height - inset5 - box.h;
        return {
            x: Math.max(inset5, Math.min(maxX, p.x)),
            y: Math.max(inset5, Math.min(maxY, p.y))
        };
    }, [
        measureBox,
        inset5
    ]);
    var commit = useCallback3(function(p) {
        if (controlled === void 0) setOwn(p);
        onCommit === null || onCommit === void 0 ? void 0 : onCommit(p);
    }, [
        controlled,
        onCommit
    ]);
    var clearLive = function() {
        if (frame.current !== null) cancelAnimationFrame(frame.current);
        frame.current = null;
        framePending.current = false;
        if (live === "transform" && targetRef.current) targetRef.current.style.transform = "";
    };
    var showLive = function(p) {
        if (live === "state") {
            setOwn(p);
            return;
        }
        if (framePending.current) return;
        framePending.current = true;
        frame.current = requestAnimationFrame(function() {
            var _press_current;
            framePending.current = false;
            frame.current = null;
            var target = targetRef.current;
            var at = (_press_current = press.current) === null || _press_current === void 0 ? void 0 : _press_current.live;
            if (!target || !at) return;
            var from = restingRef.current;
            target.style.transform = "translate(".concat(at.x - from.x, "px, ").concat(at.y - from.y, "px)");
        });
    };
    var handlers = useRef4(null);
    var listening = useRef4(null);
    var stopListening = function() {
        var l = listening.current;
        if (!l) return;
        document.removeEventListener("pointermove", l.move);
        document.removeEventListener("pointerup", l.up);
        document.removeEventListener("pointercancel", l.cancel);
        listening.current = null;
    };
    var release = function(p) {
        if (!p.captured) return;
        try {
            var _p_grip_releasePointerCapture, _p_grip;
            (_p_grip_releasePointerCapture = (_p_grip = p.grip).releasePointerCapture) === null || _p_grip_releasePointerCapture === void 0 ? void 0 : _p_grip_releasePointerCapture.call(_p_grip, p.pointerId);
        } catch (e) {}
    };
    var end = function(e, keep) {
        var p = press.current;
        if (!p || p.pointerId !== e.pointerId) return;
        press.current = null;
        release(p);
        stopListening();
        clearLive();
        if (p.dragging) {
            setIsDragging(false);
            if (keep) commit(p.live);
            else if (live === "state") setOwn(p.from);
        }
    };
    var move = function(e) {
        var p = press.current;
        if (!p || p.pointerId !== e.pointerId) return;
        if (e.pointerType === "mouse" && e.buttons === 0) {
            end(e, false);
            return;
        }
        var dx = e.clientX - p.startX;
        var dy = e.clientY - p.startY;
        if (!p.dragging) {
            if (Math.hypot(dx, dy) < threshold) return;
            p.dragging = true;
            setIsDragging(true);
        }
        if (!p.box) p.box = measureBox();
        if (!p.captured && Math.hypot(dx, dy) >= CAPTURE_PX) {
            p.captured = true;
            try {
                var _p_grip_setPointerCapture, _p_grip;
                (_p_grip_setPointerCapture = (_p_grip = p.grip).setPointerCapture) === null || _p_grip_setPointerCapture === void 0 ? void 0 : _p_grip_setPointerCapture.call(_p_grip, p.pointerId);
            } catch (e) {}
        }
        p.live = clamp({
            x: p.from.x + dx,
            y: p.from.y + dy
        }, p.box);
        showLive(p.live);
    };
    handlers.current = {
        move: move,
        end: end
    };
    var onPointerDown = function(e) {
        if (e.button !== void 0 && e.button !== 0) return;
        if (press.current) {
            if (press.current.pointerId !== e.pointerId) return;
            var _e_nativeEvent;
            end((_e_nativeEvent = e.nativeEvent) !== null && _e_nativeEvent !== void 0 ? _e_nativeEvent : e, false);
        }
        stopListening();
        var from = restingRef.current;
        press.current = {
            pointerId: e.pointerId,
            startX: e.clientX,
            startY: e.clientY,
            from: from,
            dragging: threshold <= 0,
            live: from,
            grip: e.currentTarget,
            captured: false,
            box: null
        };
        if (threshold <= 0) setIsDragging(true);
        var l = {
            move: function(ev) {
                var _handlers_current;
                return (_handlers_current = handlers.current) === null || _handlers_current === void 0 ? void 0 : _handlers_current.move(ev);
            },
            up: function(ev) {
                var _handlers_current;
                return (_handlers_current = handlers.current) === null || _handlers_current === void 0 ? void 0 : _handlers_current.end(ev, true);
            },
            cancel: function(ev) {
                var _handlers_current;
                return (_handlers_current = handlers.current) === null || _handlers_current === void 0 ? void 0 : _handlers_current.end(ev, false);
            }
        };
        listening.current = l;
        document.addEventListener("pointermove", l.move);
        document.addEventListener("pointerup", l.up);
        document.addEventListener("pointercancel", l.cancel);
    };
    var dragging = function() {
        var _press_current;
        return !!((_press_current = press.current) === null || _press_current === void 0 ? void 0 : _press_current.dragging);
    };
    var onKeyDown = keyboard ? function(e) {
        if (dragging()) return;
        if (e.key === "Home") {
            if (!onHome) return;
            e.preventDefault();
            e.stopPropagation();
            onHome();
            return;
        }
        var dir = ARROWS[e.key];
        if (!dir) return;
        e.preventDefault();
        e.stopPropagation();
        var by = e.shiftKey ? keyboard.bigStep : keyboard.step;
        var from = restingRef.current;
        commit(clamp({
            x: from.x + dir[0] * by,
            y: from.y + dir[1] * by
        }));
    } : void 0;
    var onDoubleClick = onHome ? function(e) {
        e.preventDefault();
        if (dragging()) return;
        onHome();
    } : void 0;
    var onMouseDown = function(e) {
        if (e.button === 0) e.preventDefault();
    };
    useEffect4(function() {
        return function() {
            if (frame.current !== null) cancelAnimationFrame(frame.current);
            stopListening();
            if (press.current) release(press.current);
            press.current = null;
        };
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    return {
        gripProps: _object_spread({
            onPointerDown: onPointerDown,
            onMouseDown: onMouseDown
        }, onKeyDown ? {
            onKeyDown: onKeyDown
        } : {}, onDoubleClick ? {
            onDoubleClick: onDoubleClick
        } : {}),
        isDragging: isDragging,
        position: resting,
        setPosition: setOwn
    };
};
// src/components/DraggablePanel/DraggablePanel.tsx
import React3, { useRef as useRef5, useEffect as useEffect5 } from "react";
import styled4 from "styled-components";
import { jsx as jsx5, jsxs as jsxs4 } from "react/jsx-runtime";
var SCROLLBAR_WIDTH = 25;
var MARGIN_FROM_RIGHT = 15;
var MARGIN_FROM_TOP = 48;
var MARGIN_IN_BOUNDS = 16;
var DraggablePanel = function(param) {
    var children = param.children, headerElement = param.headerElement, className = param.className, isHeaderHovered = param.isHeaderHovered, boundsRef = param.boundsRef;
    var panelRef = useRef5(null);
    var _useDragPosition = useDragPosition({
        targetRef: panelRef,
        boundsRef: boundsRef,
        rightInset: SCROLLBAR_WIDTH,
        threshold: 0,
        live: "state"
    }), gripProps = _useDragPosition.gripProps, isDragging = _useDragPosition.isDragging, position = _useDragPosition.position, setPosition = _useDragPosition.setPosition;
    useEffect5(function() {
        if (!panelRef.current) return;
        var offsetWidth = panelRef.current.offsetWidth;
        if (boundsRef === null || boundsRef === void 0 ? void 0 : boundsRef.current) {
            setPosition({
                x: MARGIN_IN_BOUNDS,
                y: MARGIN_IN_BOUNDS
            });
        } else {
            setPosition({
                x: window.innerWidth - offsetWidth - MARGIN_FROM_RIGHT,
                y: MARGIN_FROM_TOP
            });
        }
    }, []);
    return /* @__PURE__ */ jsxs4("div", {
        ref: panelRef,
        className: "".concat(className, " ").concat(isDragging ? "dragging" : "", " ").concat(isHeaderHovered ? "hovering" : ""),
        style: {
            left: position.x,
            top: position.y,
            position: "absolute"
        },
        children: [
            headerElement && React3.cloneElement(headerElement, gripProps),
            /* @__PURE__ */ jsx5("div", {
                children: children
            })
        ]
    });
};
var DraggablePanel_default = styled4(DraggablePanel)(_templateObject5());
// src/components/OnboardingList/ListGroup.tsx
import { useState as useState4 } from "react";
import styled5 from "styled-components";
import { focus as focus2, ink, inset, radius, rgba, space as space2, surface, typeScale, weight } from "@repo/design-tokens";
import { Icon as Icon2, Tag as Tag2 } from "@repo/design-system";
import { Fragment as Fragment2, jsx as jsx6, jsxs as jsxs5 } from "react/jsx-runtime";
var ListGroup = function(param) {
    var title = param.title, tone = param.tone, dotTone = param.dotTone, count = param.count, icon2 = param.icon, hint = param.hint, openProp = param.open, _param_defaultOpen = param.defaultOpen, defaultOpen = _param_defaultOpen === void 0 ? true : _param_defaultOpen, onOpenChange = param.onOpenChange, id = param.id, className = param.className, children = param.children;
    var _useState4 = _sliced_to_array(useState4(defaultOpen), 2), openState = _useState4[0], setOpenState = _useState4[1];
    var open = openProp !== null && openProp !== void 0 ? openProp : openState;
    var toggle = function() {
        var next = !open;
        if (openProp === void 0) setOpenState(next);
        onOpenChange === null || onOpenChange === void 0 ? void 0 : onOpenChange(next);
    };
    return /* @__PURE__ */ jsxs5("div", {
        className: className,
        children: [
            /* @__PURE__ */ jsxs5("button", {
                type: "button",
                className: "list-group-header",
                "aria-expanded": open,
                "aria-controls": id,
                onClick: toggle,
                children: [
                    /* @__PURE__ */ jsx6(Icon2, {
                        name: open ? "chevron-down" : "chevron-right",
                        size: "xs",
                        className: "chevron"
                    }),
                    tone ? /* @__PURE__ */ jsx6(Tag2, _object_spread_props(_object_spread({
                        surface: "on-glass",
                        tone: tone,
                        dot: true
                    }, dotTone ? {
                        dotTone: dotTone
                    } : {}, typeof count === "number" ? {
                        count: count
                    } : {}), {
                        children: title
                    })) : /* @__PURE__ */ jsxs5(Fragment2, {
                        children: [
                            icon2 ? /* @__PURE__ */ jsx6("span", {
                                className: "list-group-icon",
                                "aria-hidden": "true",
                                children: icon2
                            }) : null,
                            /* @__PURE__ */ jsx6("span", {
                                className: "list-group-title",
                                children: title
                            }),
                            typeof count === "number" ? /* @__PURE__ */ jsxs5(Fragment2, {
                                children: [
                                    " ",
                                    /* @__PURE__ */ jsx6("span", {
                                        className: "list-group-count",
                                        children: count
                                    })
                                ]
                            }) : null
                        ]
                    }),
                    hint ? /* @__PURE__ */ jsx6("span", {
                        className: "list-group-hint",
                        children: hint
                    }) : null
                ]
            }),
            /* @__PURE__ */ jsx6("div", {
                id: id,
                className: "list-group-body",
                hidden: !open,
                children: open ? children : null
            })
        ]
    });
};
var ListGroup_default = styled5(ListGroup)(_templateObject6(), space2[2], inset[3], inset[2], space2[1], radius.md, ink[2], rgba(surface[0], 0.5), focus2.tight, ink[4], typeScale.caption1.fontSize, weight.semibold, typeScale.caption1.fontSize, ink[3], typeScale.captionCompact.fontSize, typeScale.captionCompact.lineHeight, ink[4]);
// src/motion/prefersReducedMotion.ts
var prefersReducedMotion = function() {
    try {
        var _window_matchMedia, _window;
        return !!((_window_matchMedia = (_window = window).matchMedia) === null || _window_matchMedia === void 0 ? void 0 : _window_matchMedia.call(_window, "(prefers-reduced-motion: reduce)").matches);
    } catch (e) {
        return false;
    }
};
// src/motion/scrollWithin.ts
var layoutBoxWithin = function(container, el) {
    var top = 0;
    var node = el;
    while(node && node !== container){
        top += node.offsetTop;
        node = node.offsetParent;
    }
    return node === container ? {
        top: top,
        height: el.offsetHeight
    } : null;
};
var scrollWithin = function(container, el, param) {
    var _param_margin = param.margin, margin = _param_margin === void 0 ? 0 : _param_margin, reduced = param.reduced, box = param.box;
    var at = box;
    if (!at) {
        if (!el) return;
        var c = container.getBoundingClientRect();
        var r = el.getBoundingClientRect();
        at = {
            top: r.top - c.top + container.scrollTop,
            height: r.height
        };
    }
    var viewTop = container.scrollTop;
    var viewBottom = viewTop + container.clientHeight;
    var to = null;
    if (at.top - margin < viewTop) to = at.top - margin;
    else if (at.top + at.height + margin > viewBottom) to = at.top + at.height + margin - container.clientHeight;
    if (to === null) return;
    to = Math.max(0, to);
    if (typeof container.scrollTo === "function") container.scrollTo({
        top: to,
        behavior: reduced ? "auto" : "smooth"
    });
    else container.scrollTop = to;
};
// src/motion/useRowMotion.ts
import { useEffect as useEffect6, useLayoutEffect, useRef as useRef6, useState as useState5 } from "react";
import { motion } from "@repo/design-tokens";
var ROW_MOTION_KEY_ATTR = "data-motion-key";
var ROW_MOTION_ARRIVED_ATTR = "data-motion-arrived";
var ROW_MOTION_GAP_CLASS = "row-motion-gap";
var DURATION_MS = parseFloat(motion.durMid) * 1e3;
var EASE = motion.easeUi;
var GAP_PX = 8;
var ROW_MOTION_ARRIVED_MS = 1e3;
var keyedRows = function(container) {
    var elOf = /* @__PURE__ */ new Map();
    container.querySelectorAll("[".concat(ROW_MOTION_KEY_ATTR, "]")).forEach(function(el) {
        var key = el.getAttribute(ROW_MOTION_KEY_ATTR);
        if (key) elOf.set(key, el);
    });
    return elOf;
};
var measure = function(container) {
    var c = container.getBoundingClientRect();
    var seen = /* @__PURE__ */ new Map();
    var elOf = /* @__PURE__ */ new Map();
    container.querySelectorAll("[".concat(ROW_MOTION_KEY_ATTR, "]")).forEach(function(el) {
        var key = el.getAttribute(ROW_MOTION_KEY_ATTR);
        if (!key) return;
        var r = el.getBoundingClientRect();
        elOf.set(key, el);
        seen.set(key, {
            top: r.top - c.top + container.scrollTop,
            left: r.left - c.left + container.scrollLeft,
            height: r.height,
            width: r.width
        });
    });
    return {
        seen: seen,
        elOf: elOf
    };
};
var useRowMotion = function(containerRef, param) {
    var groups = param.groups, epoch = param.epoch, _param_maxMoves = param.maxMoves, maxMoves = _param_maxMoves === void 0 ? 8 : _param_maxMoves, _param_scrollMargin = param.scrollMargin, scrollMargin = _param_scrollMargin === void 0 ? 0 : _param_scrollMargin, arrived = param.arrived;
    var _before_current;
    var _useState5 = _sliced_to_array(useState5([]), 2), moved = _useState5[0], setMoved = _useState5[1];
    var last = useRef6(null);
    var before = useRef6(null);
    var running = useRef6(/* @__PURE__ */ new Set());
    var gaps = useRef6(/* @__PURE__ */ new Set());
    var timers = useRef6(/* @__PURE__ */ new Set());
    var prev = last.current;
    if (prev && prev.groups !== groups && groups.size > 0 && ((_before_current = before.current) === null || _before_current === void 0 ? void 0 : _before_current.groups) !== groups && containerRef.current) {
        before.current = {
            groups: groups,
            seen: measure(containerRef.current).seen
        };
    }
    useLayoutEffect(function() {
        var was = last.current;
        last.current = {
            epoch: epoch,
            groups: groups
        };
        var first = before.current;
        before.current = null;
        var container = containerRef.current;
        if (was && was.epoch !== epoch) {
            running.current.forEach(function(a) {
                return a.cancel();
            });
            running.current.clear();
            gaps.current.forEach(function(gap) {
                return gap.remove();
            });
            gaps.current.clear();
            timers.current.forEach(function(t) {
                return window.clearTimeout(t);
            });
            timers.current.clear();
            container === null || container === void 0 ? void 0 : container.querySelectorAll("[".concat(ROW_MOTION_ARRIVED_ATTR, "]")).forEach(function(el) {
                return el.removeAttribute(ROW_MOTION_ARRIVED_ATTR);
            });
        }
        var later = function(ms, then) {
            var t = window.setTimeout(function() {
                timers.current.delete(t);
                then();
            }, ms);
            timers.current.add(t);
        };
        var glow = function(el, reduced2) {
            el.setAttribute(ROW_MOTION_ARRIVED_ATTR, "");
            if (reduced2) later(ROW_MOTION_ARRIVED_MS, function() {
                return el.removeAttribute(ROW_MOTION_ARRIVED_ATTR);
            });
            else later(ROW_MOTION_ARRIVED_MS, function() {
                el.setAttribute(ROW_MOTION_ARRIVED_ATTR, "fading");
                later(DURATION_MS, function() {
                    return el.removeAttribute(ROW_MOTION_ARRIVED_ATTR);
                });
            });
        };
        var glowArrivals = function(isNew) {
            if (!arrived || arrived.size === 0 || !container) return;
            var keys = Array.from(groups.keys()).filter(function(key) {
                return arrived.has(key) && isNew(key);
            });
            if (keys.length === 0) return;
            var elOf2 = keyedRows(container);
            var reduced2 = prefersReducedMotion();
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var key = _step.value;
                    var el = elOf2.get(key);
                    if (el) glow(el, reduced2);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        };
        if (!was) glowArrivals(function() {
            return true;
        });
        if (!was || was.epoch !== epoch || was.groups === groups || !container) return;
        glowArrivals(function(key) {
            return !was.groups.has(key);
        });
        if (!first || first.groups !== groups) return;
        var movedNow = [];
        groups.forEach(function(group, key) {
            var had = was.groups.get(key);
            if (had !== void 0 && had !== group) movedNow.push(key);
        });
        if (movedNow.length === 0 || movedNow.length > maxMoves) return;
        running.current.forEach(function(a) {
            return a.cancel();
        });
        var _measure = measure(container), now = _measure.seen, elOf = _measure.elOf;
        var reduced = prefersReducedMotion();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = movedNow[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var key = _step.value;
                var el = elOf.get(key);
                if (el) glow(el, reduced);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (!reduced && typeof container.animate === "function") {
            now.forEach(function(at, key) {
                var from = first.seen.get(key);
                var el = elOf.get(key);
                if (!from || !el) return;
                var dx = from.left - at.left;
                var dy = from.top - at.top;
                if (dx === 0 && dy === 0) return;
                var a = el.animate([
                    {
                        transform: "translate(".concat(dx, "px, ").concat(dy, "px)")
                    },
                    {
                        transform: "none"
                    }
                ], {
                    duration: DURATION_MS,
                    easing: EASE
                });
                running.current.add(a);
                a.onfinish = a.oncancel = function() {
                    return running.current.delete(a);
                };
            });
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                var _loop = function() {
                    var key = _step1.value;
                    var from = first.seen.get(key);
                    if (!from || !elOf.has(key)) return "continue";
                    var gap = document.createElement("div");
                    gap.className = ROW_MOTION_GAP_CLASS;
                    gap.setAttribute("aria-hidden", "true");
                    Object.assign(gap.style, {
                        position: "absolute",
                        left: "".concat(from.left, "px"),
                        top: "".concat(from.top + (from.height - GAP_PX) / 2, "px"),
                        width: "".concat(from.width, "px"),
                        height: "".concat(GAP_PX, "px"),
                        pointerEvents: "none"
                    });
                    container.appendChild(gap);
                    gaps.current.add(gap);
                    var a = gap.animate([
                        {
                            height: "".concat(GAP_PX, "px"),
                            opacity: 1
                        },
                        {
                            height: "0px",
                            opacity: 0
                        }
                    ], {
                        duration: DURATION_MS,
                        easing: EASE,
                        fill: "forwards"
                    });
                    running.current.add(a);
                    var done = function() {
                        running.current.delete(a);
                        gaps.current.delete(gap);
                        gap.remove();
                    };
                    a.onfinish = done;
                    a.oncancel = done;
                };
                for(var _iterator1 = movedNow[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true)_loop();
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
        }
        var target = movedNow.map(function(k) {
            return now.get(k);
        }).find(Boolean);
        if (target) scrollWithin(container, null, {
            margin: scrollMargin,
            reduced: reduced,
            box: target
        });
        setMoved(movedNow);
    }, [
        containerRef,
        groups,
        epoch,
        maxMoves,
        scrollMargin,
        arrived
    ]);
    useEffect6(function() {
        var anims = running.current;
        var placeholders = gaps.current;
        var pending = timers.current;
        return function() {
            var _containerRef_current;
            anims.forEach(function(a) {
                return a.cancel();
            });
            anims.clear();
            placeholders.forEach(function(g) {
                return g.remove();
            });
            placeholders.clear();
            pending.forEach(function(t) {
                return window.clearTimeout(t);
            });
            pending.clear();
            (_containerRef_current = containerRef.current) === null || _containerRef_current === void 0 ? void 0 : _containerRef_current.querySelectorAll("[".concat(ROW_MOTION_ARRIVED_ATTR, "]")).forEach(function(el) {
                return el.removeAttribute(ROW_MOTION_ARRIVED_ATTR);
            });
            last.current = null;
            before.current = null;
        };
    }, [
        containerRef
    ]);
    return {
        moved: moved
    };
};
// src/components/OnboardingList/listRowLook.ts
import { css } from "styled-components";
import { brand, motion as motion2, rgba as rgba2, semantic, shadow, surface as surface2 } from "@repo/design-tokens";
var _semantic_status = semantic.status, roles = _semantic_status.roles, fadingGlow = _semantic_status.fadingGlow;
var LIST_ROW_STATUS_LOOK = {
    /** A row jumped to (`.linked`): the fading glow on the row's own background. */ jumpedTo: fadingGlow,
    /** The row motion's arrived glow, and `.glow-arrived`. */ arrived: fadingGlow,
    /** A total just added (`.glow-new`). */ newTotal: fadingGlow,
    /** The dashed edge of the place a moved row left (`rowMotionGapLook`). */ gapEdge: rgba2(roles.justChanged.mark, 0.95),
    /** That place's fill. */ gapFill: rgba2(roles.justChanged.mark, 0.12),
    /** The dashed edge of a row or tile being dragged (`draggedLook`): being edited. */ draggedEdge: roles.beingEdited.mark
};
var linkedRing = LIST_ROW_STATUS_LOOK.jumpedTo;
var dropTargetLook = css(_templateObject7(), rgba2(brand.frost, 0.7), rgba2(brand.cyan, 0.55), rgba2(brand.cyan, 0.3));
var rowArrivedLook = css(_templateObject8(), ROW_MOTION_ARRIVED_ATTR, ROW_MOTION_ARRIVED_ATTR, LIST_ROW_STATUS_LOOK.arrived, ROW_MOTION_ARRIVED_ATTR, motion2.durMid, motion2.easeUi, ROW_MOTION_ARRIVED_ATTR);
var listRowLook = css(_templateObject9(), motion2.durMid, motion2.easeUi, motion2.durMid, motion2.easeUi, semantic.surface.base, shadow.glassSm, semantic.status.selected.fill, shadow.glassHover, LIST_ROW_STATUS_LOOK.jumpedTo, dropTargetLook, rowArrivedLook, LIST_ROW_STATUS_LOOK.arrived, LIST_ROW_STATUS_LOOK.newTotal);
var draggedLook = css(_templateObject10(), rgba2(surface2[0], 0.35), LIST_ROW_STATUS_LOOK.draggedEdge);
// src/components/OnboardingList/rowMotionGapLook.ts
import { css as css2 } from "styled-components";
import { radius as radius2 } from "@repo/design-tokens";
var rowMotionGapLook = function(margin) {
    return css2(_templateObject11(), ROW_MOTION_GAP_CLASS, margin, LIST_ROW_STATUS_LOOK.gapEdge, radius2.pill, LIST_ROW_STATUS_LOOK.gapFill);
};
// src/components/OnboardingList/IconDisc.tsx
import styled6 from "styled-components";
import { accent, brand as brand2, ink as ink2, inkGlass, inkOn, radius as radius3, rgba as rgba3, semantic as semantic2, shadow as shadow2, support, surface as surface3 } from "@repo/design-tokens";
import { jsx as jsx7 } from "react/jsx-runtime";
var ICON_DISC_TONE = {
    plain: {
        fill: surface3[0],
        ink: ink2[3],
        glow: shadow2.glassSm
    },
    selected: {
        fill: semantic2.status.selected.fill,
        ink: semantic2.status.selected.ink,
        glow: semantic2.status.selected.shadow
    },
    edit: {
        fill: accent.butter,
        ink: inkGlass.warn,
        glow: "0 0 8px 1px ".concat(rgba3(accent.butter, 0.6))
    },
    /*
   * Frame 13's *Identify* role, as the Equipment page file draws the *Manufacturer identified*
   * score glyph (`equipment-page-stage`): periwinkle at .24 with its on-periwinkle ink, a 1.5 px
   * white edge and a periwinkle glow.
   */ identify: {
        fill: rgba3(support.periwinkle, 0.24),
        ink: inkOn.peri,
        glow: "0 0 0 1.5px ".concat(surface3[0], ", 0 0 8px 1px ").concat(rgba3(support.periwinkle, 0.35))
    },
    /*
   * Frame 13's *Done* role, as the Equipment page file draws the *assets are in* summary's check
   * (`equipment-page-landed`, frame 04): mint at .30 with its on-mint ink, a 1.5 px white edge and
   * a mint glow at .55 — the bundle's `TONE.mint` and the summary's `glow`.
   */ done: {
        fill: rgba3(support.mint, 0.3),
        ink: inkOn.mint,
        glow: "0 0 0 1.5px ".concat(surface3[0], ", 0 0 8px 1px ").concat(rgba3(support.mint, 0.55))
    },
    /*
   * Frame 08's draft header in the onboarding wizard's *Versions* (`twin-details-page-versions`): the
   * pen on butter at .32 with the warn ink — the twin chip's *Updating live twin* tint — and a 2 px
   * white ring, no glow (the header card carries the glow). Owed Rob's ratification.
   */ draft: {
        fill: rgba3(accent.butter, 0.32),
        ink: inkGlass.warn,
        glow: "0 0 0 2px ".concat(surface3[0])
    },
    /*
   * The Opening hours step's calendar cards (`twin-details-page-hours-week`, frame 06): a standard
   * week's clock on frost at .9 with the on-aqua ink (the bundle's `TONE.aqua`), and a past
   * calendar's archive box on the panel tint at .95 with the grey glyph (`TONE.neutral`). Each with
   * a 1 px white ring and, like `draft`, no glow. Owed Rob's ratification.
   */ aqua: {
        fill: rgba3(brand2.frost, 0.9),
        ink: inkOn.aqua,
        glow: "0 0 0 1px ".concat(surface3[0])
    },
    neutral: {
        fill: rgba3(surface3[2], 0.95),
        ink: ink2[3],
        glow: "0 0 0 1px ".concat(surface3[0])
    },
    /*
   * A special period's calendar card (`twin-details-page-hours-special`, frame 07): the calendar on
   * lavender at .34 with the on-lavender ink (the bundle's `TONE.lav`), a 1 px white ring and, like
   * `aqua`, no glow. Owed Rob's ratification.
   */ lavender: {
        fill: rgba3(support.lavender, 0.34),
        ink: inkOn.lav,
        glow: "0 0 0 1px ".concat(surface3[0])
    }
};
var ICON_DISC_ROW_SIZE = 28;
var Disc = styled6.span(_templateObject12(), function(param) {
    var $size = param.$size;
    return $size;
}, function(param) {
    var $size = param.$size;
    return $size;
}, radius3.pill, function(param) {
    var $tone = param.$tone;
    return ICON_DISC_TONE[$tone].ink;
}, function(param) {
    var $tone = param.$tone;
    return ICON_DISC_TONE[$tone].fill;
}, function(param) {
    var $tone = param.$tone, $flat = param.$flat;
    return $flat ? "none" : ICON_DISC_TONE[$tone].glow;
});
var IconDisc = function(param) {
    var tone = param.tone, _param_size = param.size, size = _param_size === void 0 ? ICON_DISC_ROW_SIZE : _param_size, _param_flat = param.flat, flat = _param_flat === void 0 ? false : _param_flat, className = param.className, children = param.children;
    return /* @__PURE__ */ jsx7(Disc, {
        className: [
            "tl-icon-disc",
            "tone-".concat(tone),
            className
        ].filter(Boolean).join(" "),
        $tone: tone,
        $size: size,
        $flat: flat,
        "aria-hidden": "true",
        children: children
    });
};
var IconDisc_default = IconDisc;
// src/components/OnboardingList/rowState.tsx
import styled7 from "styled-components";
import { ink as ink3, semantic as semantic3, statusRoleOnStep, typeScale as typeScale2 } from "@repo/design-tokens";
import { jsx as jsx8 } from "react/jsx-runtime";
var ROW_STATE_ROLE = {
    error: "problem",
    check: "problem",
    identify: statusRoleOnStep("workToDo", "assets", "plan"),
    place: "workToDo"
};
var WORDS = {
    error: "error",
    check: "to check",
    identify: "to identify",
    place: "to place"
};
var lookOf = function(state) {
    var role = semantic3.status.roles[ROW_STATE_ROLE[state]];
    return {
        fill: role.mark,
        ink: role.ink,
        words: WORDS[state]
    };
};
var ROW_STATE_LOOK = {
    error: lookOf("error"),
    check: lookOf("check"),
    identify: lookOf("identify"),
    place: lookOf("place")
};
var rowStateLookOf = function(state) {
    return state ? ROW_STATE_LOOK[state] : void 0;
};
var Note = styled7.span(_templateObject13(), function(param) {
    var $state = param.$state;
    var _rowStateLookOf;
    var _rowStateLookOf_ink;
    return (_rowStateLookOf_ink = (_rowStateLookOf = rowStateLookOf($state)) === null || _rowStateLookOf === void 0 ? void 0 : _rowStateLookOf.ink) !== null && _rowStateLookOf_ink !== void 0 ? _rowStateLookOf_ink : ink3[3];
}, typeScale2.caption1.fontSize);
var RowNote = function(param) {
    var state = param.state, children = param.children;
    return /* @__PURE__ */ jsx8(Note, {
        className: "tl-row-note state-".concat(state),
        $state: state,
        children: children
    });
};
// src/components/OnboardingList/HierarchyTree.tsx
import React5, { useEffect as useEffect7, useRef as useRef7 } from "react";
import styled8 from "styled-components";
import { focus as focus3, fontMono, ink as ink4, line, radius as radius4, semantic as semantic4, shadow as shadow3, space as space3, surface as surface4, typeScale as typeScale3, weight as weight2 } from "@repo/design-tokens";
import { Dot, Icon as Icon3, Tag as Tag3 } from "@repo/design-system";
import { Fragment as Fragment3, jsx as jsx9, jsxs as jsxs6 } from "react/jsx-runtime";
var kindGlyphName = function(kind) {
    return kind === "floor" ? "layer-group" : kind === "reference" ? "file-pdf" : kind === "surface" ? "object-union" : "dumbbell";
};
var KindGlyph = function(param) {
    var kind = param.kind;
    return /* @__PURE__ */ jsx9(Icon3, {
        name: kindGlyphName(kind),
        size: "md",
        className: "kind-icon"
    });
};
var Grip = styled8.span(_templateObject14(), ink4[4]);
var RowGrip = function(dragProps) {
    return /* @__PURE__ */ jsx9(Grip, _object_spread_props(_object_spread({
        className: "row-grip",
        "aria-hidden": "true"
    }, dragProps), {
        children: /* @__PURE__ */ jsx9(Icon3, {
            name: "grip-vertical",
            size: "sm"
        })
    }));
};
var INDENT_STEP = 16;
var DISC_TEXT_GAP = 6;
var ROW_EDGE = 1;
var TRAILING_CONTROL = [
    "button",
    "a[href]",
    "input",
    "select",
    "textarea",
    "summary",
    "iframe",
    '[contenteditable=""]',
    '[contenteditable="true"]',
    '[tabindex]:not([tabindex="-1"])',
    '[role="button"]',
    '[role="link"]',
    '[role="checkbox"]',
    '[role="switch"]'
].join(", ");
var DISC_ONLY_PROPS = [
    "glyph",
    "state",
    "sub",
    "codePlacement",
    "trailing",
    "inset",
    "subAction",
    "subSpoken",
    "dragging",
    "guides",
    "pressable",
    "glyphShape",
    "labelMuted",
    "actions",
    "editing",
    "buttonRef",
    "buttonProps",
    "rowAttributes"
];
var separator = /* @__PURE__ */ jsx9("span", {
    style: visuallyHidden,
    children: ", "
});
var PlainEntityRow = function(param) {
    var className = param.className, refid = param.refid, kind = param.kind, label = param.label, code = param.code, selected = param.selected, _param_current = param.current, current = _param_current === void 0 ? false : _param_current, _param_announceSelected = param.announceSelected, announceSelected = _param_announceSelected === void 0 ? false : _param_announceSelected, _param_hovered = param.hovered, hovered = _param_hovered === void 0 ? false : _param_hovered, _param_depth = param.depth, depth = _param_depth === void 0 ? 0 : _param_depth, leading = param.leading, marker = param.marker, details = param.details, onSelect = param.onSelect;
    return /* @__PURE__ */ jsxs6("div", _object_spread_props(_object_spread({
        className: "".concat(className, " ").concat(selected || current ? "selected" : "", " ").concat(hovered ? "hovered" : ""),
        "data-refid": refid
    }, _define_property({}, ROW_MOTION_KEY_ATTR, refid)), {
        style: {
            paddingLeft: "calc(".concat(space3[1], " + ").concat(depth * 16, "px)")
        },
        children: [
            leading,
            /* @__PURE__ */ jsxs6("span", {
                className: "kind",
                children: [
                    /* @__PURE__ */ jsx9(KindGlyph, {
                        kind: kind
                    }),
                    marker
                ]
            }),
            /* @__PURE__ */ jsxs6("button", {
                type: "button",
                className: "row-select",
                "aria-current": current ? "true" : void 0,
                onClick: onSelect,
                children: [
                    /* @__PURE__ */ jsx9("span", {
                        className: "row-label",
                        children: label
                    }),
                    code && /* row-code kept as the chip's hook: tests and the capture rigs find a row by its code. */ /* @__PURE__ */ jsx9(Tag3, {
                        surface: "on-glass",
                        tone: "code",
                        className: "row-code",
                        children: code
                    }),
                    details,
                    announceSelected && selected && /* @__PURE__ */ jsx9("span", {
                        style: visuallyHidden,
                        children: " (selected)"
                    })
                ]
            })
        ]
    }));
};
var useWarnOnce = function(when, message) {
    var warned = useRef7(false);
    useEffect7(function() {
        if (process.env.NODE_ENV === "production" || !when || warned.current) return;
        warned.current = true;
        console.warn(message);
    });
};
var DiscEntityRow = function(param) {
    var className = param.className, refid = param.refid, kind = param.kind, label = param.label, code = param.code, selected = param.selected, _param_current = param.current, current = _param_current === void 0 ? false : _param_current, _param_announceSelected = param.announceSelected, announceSelected = _param_announceSelected === void 0 ? false : _param_announceSelected, _param_hovered = param.hovered, hovered = _param_hovered === void 0 ? false : _param_hovered, _param_depth = param.depth, depth = _param_depth === void 0 ? 0 : _param_depth, leading = param.leading, marker = param.marker, details = param.details, glyph = param.glyph, state = param.state, sub = param.sub, _param_codePlacement = param.codePlacement, codePlacement = _param_codePlacement === void 0 ? "inline" : _param_codePlacement, trailing = param.trailing, inset5 = param.inset, subAction = param.subAction, subSpoken = param.subSpoken, _param_dragging = param.dragging, dragging = _param_dragging === void 0 ? false : _param_dragging, _param_guides = param.guides, guides = _param_guides === void 0 ? false : _param_guides, _param_pressable = param.pressable, pressable = _param_pressable === void 0 ? true : _param_pressable, _param_glyphShape = param.glyphShape, glyphShape = _param_glyphShape === void 0 ? "disc" : _param_glyphShape, _param_labelMuted = param.labelMuted, labelMuted = _param_labelMuted === void 0 ? false : _param_labelMuted, actions = param.actions, editing = param.editing, buttonRef = param.buttonRef, buttonProps = param.buttonProps, rowAttributes = param.rowAttributes, onSelect = param.onSelect;
    var trailingRef = useRef7(null);
    var warnedTrailing = useRef7(false);
    useEffect7(function() {
        var _trailingRef_current;
        if (process.env.NODE_ENV === "production" || warnedTrailing.current) return;
        if ((_trailingRef_current = trailingRef.current) === null || _trailingRef_current === void 0 ? void 0 : _trailingRef_current.querySelector(TRAILING_CONTROL)) {
            warnedTrailing.current = true;
            console.warn('HierarchyEntityRow "'.concat(label, "\": `trailing` holds a control, which cannot sit inside the row's button. Put it in `inset`."));
        }
    });
    useWarnOnce(subAction != null && leading != null, 'HierarchyEntityRow "'.concat(label, '": `subAction` with `leading`: the stretched row button covers the leading control, so the mouse cannot reach it.'));
    useWarnOnce(subAction != null && !subSpoken, 'HierarchyEntityRow "'.concat(label, "\": `subAction` was given without `subSpoken`, so the row's button cannot say its second line."));
    useWarnOnce(!!rowStateLookOf(state) && marker != null, 'HierarchyEntityRow "'.concat(label, '": both `state` and `marker` were given; drawing `state`.'));
    useWarnOnce(!!state && state !== "ok" && sub == null, 'HierarchyEntityRow "'.concat(label, '": state "').concat(state, '" has no visible words; pass its problem as `sub` (a RowNote) so colour is not the only cue.'));
    var isSelected = selected || current;
    var stateLook = rowStateLookOf(state);
    var codeChip = code ? /* @__PURE__ */ jsx9(Tag3, {
        surface: "on-glass",
        tone: "code",
        className: "row-code",
        children: code
    }) : null;
    var codeInline = codePlacement === "inline" ? codeChip : null;
    var codeSub = code && codePlacement === "sub" ? /* @__PURE__ */ jsx9("span", {
        className: "row-code",
        children: code
    }) : null;
    var codeTrailing = codePlacement === "trailing" ? codeChip : null;
    var indent = "calc(".concat(space3[1], " + ").concat(depth * INDENT_STEP, "px)");
    var splitLine = subAction != null;
    var lineTwoBody = /* @__PURE__ */ jsxs6(Fragment3, {
        children: [
            codeSub,
            codeSub && sub ? " " : null,
            sub
        ]
    });
    var lineTwo = (codeSub || sub) && /* @__PURE__ */ jsxs6("span", {
        className: "row-line-2",
        children: [
            separator,
            lineTwoBody
        ]
    });
    var rowContent = /* @__PURE__ */ jsxs6(Fragment3, {
        children: [
            /* @__PURE__ */ jsxs6("span", {
                className: "row-lines",
                children: [
                    /* @__PURE__ */ jsxs6("span", {
                        className: "row-line-1",
                        children: [
                            /* @__PURE__ */ jsx9("span", {
                                className: labelMuted ? "row-label muted" : "row-label",
                                children: label
                            }),
                            codeInline
                        ]
                    }),
                    splitLine ? /* @__PURE__ */ jsxs6("span", {
                        style: visuallyHidden,
                        children: [
                            ", ",
                            codeSub ? "".concat(code, " ") : "",
                            subSpoken
                        ]
                    }) : lineTwo
                ]
            }),
            details,
            stateLook && /* @__PURE__ */ jsxs6("span", {
                style: visuallyHidden,
                children: [
                    ", ",
                    stateLook.words
                ]
            }),
            (codeTrailing || trailing) && /* @__PURE__ */ jsxs6("span", {
                className: "row-trailing",
                ref: trailingRef,
                children: [
                    separator,
                    codeTrailing,
                    trailing
                ]
            }),
            announceSelected && selected && /* @__PURE__ */ jsx9("span", {
                style: visuallyHidden,
                children: " (selected)"
            })
        ]
    });
    var select = editing ? /* @__PURE__ */ jsx9("span", {
        className: "row-editing",
        children: editing
    }) : pressable ? /* @__PURE__ */ jsx9("button", _object_spread_props(_object_spread({}, buttonProps), {
        ref: buttonRef,
        type: "button",
        className: splitLine ? "row-select stretched" : "row-select",
        "aria-current": current ? "true" : void 0,
        onClick: onSelect,
        children: rowContent
    })) : // A row with nothing to press is read, not pressed: the same lines in a plain span, outside
    // the tab order (`floor-plan-page-checks`, R4.5).
    /* @__PURE__ */ jsx9("span", {
        className: "row-select not-pressable",
        children: rowContent
    });
    return /* @__PURE__ */ jsxs6(Fragment3, {
        children: [
            /* @__PURE__ */ jsxs6("div", _object_spread_props(_object_spread(_object_spread_props(_object_spread({
                className: [
                    className,
                    "look-disc",
                    isSelected ? "selected" : "",
                    hovered ? "hovered" : "",
                    dragging ? "dragging" : ""
                ].filter(Boolean).join(" ")
            }, rowAttributes), {
                "data-refid": refid
            }), _define_property({}, ROW_MOTION_KEY_ATTR, refid)), {
                style: {
                    paddingLeft: indent
                },
                children: [
                    guides && Array.from({
                        length: depth
                    }, function(_, level) {
                        return /* @__PURE__ */ jsx9("span", {
                            className: "row-guide",
                            "aria-hidden": "true",
                            style: {
                                left: "calc(".concat(space3[1], " + ").concat(level * INDENT_STEP + INDENT_STEP / 2, "px)")
                            }
                        }, level);
                    }),
                    leading,
                    /* @__PURE__ */ jsxs6("span", {
                        className: "kind",
                        children: [
                            glyphShape === "square" ? /* @__PURE__ */ jsx9("span", {
                                className: "kind-square",
                                "aria-hidden": "true",
                                children: /* @__PURE__ */ jsx9(Icon3, {
                                    name: glyph !== null && glyph !== void 0 ? glyph : kindGlyphName(kind),
                                    size: "xs",
                                    className: "kind-icon"
                                })
                            }) : /* @__PURE__ */ jsx9(IconDisc, {
                                tone: isSelected ? "selected" : "plain",
                                flat: isSelected,
                                children: /* @__PURE__ */ jsx9(Icon3, {
                                    name: glyph !== null && glyph !== void 0 ? glyph : kindGlyphName(kind),
                                    size: "sm",
                                    className: "kind-icon"
                                })
                            }),
                            stateLook ? /* @__PURE__ */ jsx9("span", {
                                className: "kind-dot",
                                "aria-hidden": "true",
                                children: /* @__PURE__ */ jsx9(Dot, {
                                    color: stateLook.fill,
                                    label: stateLook.words,
                                    labelHidden: true
                                })
                            }) : marker
                        ]
                    }),
                    splitLine && !editing ? // The second line outside the button, so it can hold `subAction`; the button stretches
                    // over the whole row, so the line's words still press the row (`duplicate-holder-links`).
                    /* @__PURE__ */ jsxs6("span", {
                        className: "row-body",
                        children: [
                            select,
                            /* @__PURE__ */ jsxs6("span", {
                                className: "row-line-2 row-line-outside",
                                children: [
                                    /* @__PURE__ */ jsx9("span", {
                                        "aria-hidden": "true",
                                        children: lineTwoBody
                                    }),
                                    " ",
                                    /* @__PURE__ */ jsx9("span", {
                                        className: "row-sub-action",
                                        children: subAction
                                    })
                                ]
                            })
                        ]
                    }) : select,
                    actions && /* @__PURE__ */ jsx9("span", {
                        className: "row-actions",
                        children: actions
                    })
                ]
            })),
            inset5 && /* @__PURE__ */ jsx9("div", {
                className: "row-inset",
                style: {
                    marginLeft: "calc(".concat(space3[1], " + ").concat(ROW_EDGE + depth * INDENT_STEP + (leading ? INDENT_STEP : 0) + ICON_DISC_ROW_SIZE + DISC_TEXT_GAP, "px)"),
                    marginRight: "calc(".concat(space3[2], " + ").concat(ROW_EDGE, "px)")
                },
                children: inset5
            })
        ]
    });
};
var EntityRow = function(props) {
    var ignored = props.look !== "disc" ? DISC_ONLY_PROPS.filter(function(key) {
        return props[key] !== void 0;
    }) : [];
    useWarnOnce(ignored.length > 0, 'HierarchyEntityRow "'.concat(props.label, '": ').concat(ignored.join(", "), " apply to the disc look only; this row is plain, so they are ignored."));
    return props.look === "disc" ? /* @__PURE__ */ jsx9(DiscEntityRow, _object_spread({}, props)) : /* @__PURE__ */ jsx9(PlainEntityRow, _object_spread({}, props));
};
var StyledEntityRowBase = styled8(EntityRow)(_templateObject15(), listRowLook, semantic4.interactive.accent, radius4.sm, focus3.tight, radius4.sm, focus3.tight, ROW_EDGE, space3[1], space3[1], DISC_TEXT_GAP, space3[2], typeScale3.body1.fontSize, typeScale3.body1.lineHeight, semantic4.text.primary, semantic4.status.selected.ink, weight2.semibold, DISC_TEXT_GAP, typeScale3.caption1.fontSize, typeScale3.captionCompact.lineHeight, ink4[3], fontMono, typeScale3.caption2.fontSize, typeScale3.caption2.lineHeight, ink4[3], DISC_TEXT_GAP, line[1], draggedLook, ink4[3], ICON_DISC_ROW_SIZE, ICON_DISC_ROW_SIZE, radius4.sm, surface4[0], shadow3.glassSm, semantic4.text.secondary, space3[1], space3[2]);
var sameLeading = function(a, b) {
    if (!React5.isValidElement(a) || !React5.isValidElement(b)) return a === b;
    var pa = a.props;
    var pb = b.props;
    return a.type === b.type && pa.className === pb.className && pa["aria-expanded"] === pb["aria-expanded"];
};
var rowPropsEqual = function(prev, next) {
    var keys = /* @__PURE__ */ new Set(_to_consumable_array(Object.keys(prev)).concat(_to_consumable_array(Object.keys(next))));
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Array.from(keys)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var key = _step.value;
            if (key === "onSelect") continue;
            if (key === "marker" || key === "details" || key === "sub" || key === "trailing") {
                if (prev.slotKey === void 0 || next.slotKey === void 0) {
                    if (prev[key] !== next[key]) return false;
                }
                continue;
            }
            if (key === "leading") {
                if (!sameLeading(prev.leading, next.leading)) return false;
                continue;
            }
            if (prev[key] !== next[key]) return false;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return true;
};
var HierarchyEntityRow = React5.memo(StyledEntityRowBase, rowPropsEqual);
var HierarchyTreeRows = function(param) {
    var nodes = param.nodes, depth = param.depth, expanded = param.expanded, selectedIds = param.selectedIds, currentId = param.currentId, hoveredId = param.hoveredId, rowSlots = param.rowSlots, announceSelected = param.announceSelected, look = param.look, guides = param.guides, codePlacement = param.codePlacement, onToggle = param.onToggle, onSelect = param.onSelect;
    var onSelectRef = useRef7(onSelect);
    onSelectRef.current = onSelect;
    var onToggleRef = useRef7(onToggle);
    onToggleRef.current = onToggle;
    var seen = /* @__PURE__ */ new Map();
    return /* @__PURE__ */ jsx9(Fragment3, {
        children: nodes.map(function(node) {
            var hasChildren = node.children.length > 0;
            var isOpen = expanded.has(node.refid);
            var slots = rowSlots === null || rowSlots === void 0 ? void 0 : rowSlots(node);
            var _seen_get;
            var copy = (_seen_get = seen.get(node.refid)) !== null && _seen_get !== void 0 ? _seen_get : 0;
            seen.set(node.refid, copy + 1);
            return /* @__PURE__ */ jsxs6(React5.Fragment, {
                children: [
                    /* @__PURE__ */ jsx9(HierarchyEntityRow, _object_spread_props(_object_spread({
                        refid: node.refid,
                        kind: node.kind,
                        label: node.label,
                        code: node.code,
                        selected: selectedIds.has(node.refid),
                        current: currentId != null && currentId === node.refid,
                        hovered: hoveredId === node.refid,
                        depth: depth,
                        announceSelected: announceSelected,
                        marker: slots === null || slots === void 0 ? void 0 : slots.marker,
                        details: slots === null || slots === void 0 ? void 0 : slots.details,
                        slotKey: slots === null || slots === void 0 ? void 0 : slots.slotKey
                    }, look === "disc" ? _object_spread({
                        look: look,
                        guides: guides,
                        codePlacement: codePlacement,
                        glyph: slots === null || slots === void 0 ? void 0 : slots.glyph,
                        state: slots === null || slots === void 0 ? void 0 : slots.state,
                        sub: slots === null || slots === void 0 ? void 0 : slots.sub,
                        trailing: slots === null || slots === void 0 ? void 0 : slots.trailing,
                        inset: slots === null || slots === void 0 ? void 0 : slots.inset,
                        dragging: slots === null || slots === void 0 ? void 0 : slots.dragging
                    }, (slots === null || slots === void 0 ? void 0 : slots.dropTarget) ? {
                        className: "drop-target"
                    } : {}) : {}), {
                        leading: hasChildren ? /* @__PURE__ */ jsx9("button", {
                            type: "button",
                            className: "expander ".concat(isOpen ? "open" : ""),
                            "aria-expanded": isOpen,
                            "aria-label": "".concat(isOpen ? "Collapse" : "Expand", " ").concat(node.label),
                            onClick: function() {
                                return onToggleRef.current(node.refid);
                            },
                            children: /* @__PURE__ */ jsx9(Icon3, {
                                name: "chevron-right",
                                size: "xs"
                            })
                        }) : /* @__PURE__ */ jsx9("span", {
                            className: "expander-spacer"
                        }),
                        onSelect: function() {
                            return onSelectRef.current(node.refid, node.kind);
                        }
                    })),
                    hasChildren && isOpen && /* @__PURE__ */ jsx9(HierarchyTreeRows, {
                        nodes: node.children,
                        depth: depth + 1,
                        expanded: expanded,
                        selectedIds: selectedIds,
                        currentId: currentId,
                        hoveredId: hoveredId,
                        rowSlots: rowSlots,
                        announceSelected: announceSelected,
                        look: look,
                        guides: guides,
                        codePlacement: codePlacement,
                        onToggle: onToggle,
                        onSelect: onSelect
                    })
                ]
            }, copy === 0 ? node.refid : "".concat(node.refid, "#").concat(copy));
        })
    });
};
// src/components/OnboardingList/buildHierarchyTree.ts
import { naturalSort, resolvePlanParentage } from "@repo/front-end-utils";
var compareNodes = function(a, b) {
    var byLabel = naturalSort(a.label, b.label);
    if (byLabel !== 0) return byLabel;
    if (a.code && b.code) return naturalSort(a.code, b.code);
    if (a.code) return -1;
    if (b.code) return 1;
    return 0;
};
var buildHierarchyTree = function(surfaces, items, labels) {
    var parentage = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : resolvePlanParentage({
        surfaces: surfaces,
        items: items
    });
    var surfaceIds = new Set(surfaces.map(function(s) {
        return s.refid;
    }));
    var parentOfSurface = function(s) {
        var _parentage_surface;
        var _parentage_surface_effectiveParent;
        return (_parentage_surface_effectiveParent = (_parentage_surface = parentage.surface(s.refid)) === null || _parentage_surface === void 0 ? void 0 : _parentage_surface.effectiveParent) !== null && _parentage_surface_effectiveParent !== void 0 ? _parentage_surface_effectiveParent : null;
    };
    var parentOfItem = function(i) {
        var _parentage_item;
        var _parentage_item_effectiveParent;
        return (_parentage_item_effectiveParent = (_parentage_item = parentage.item(i)) === null || _parentage_item === void 0 ? void 0 : _parentage_item.effectiveParent) !== null && _parentage_item_effectiveParent !== void 0 ? _parentage_item_effectiveParent : null;
    };
    var itemNode = function(i) {
        return {
            refid: i.refid,
            kind: "item",
            label: labels.item(i),
            code: i.entityCode,
            children: []
        };
    };
    var surfaceNode = function(s) {
        return {
            refid: s.refid,
            kind: "surface",
            label: labels.surface(s),
            code: s.entityCode,
            // Areas first, then machines, each group in natural order. The NODE lists are sorted, never
            // `surfaces` or `items`: those are the plan's own arrays.
            children: _to_consumable_array(surfaces.filter(function(c) {
                return parentOfSurface(c) === s.refid;
            }).map(surfaceNode).sort(compareNodes)).concat(_to_consumable_array(items.filter(function(i) {
                return parentOfItem(i) === s.refid;
            }).map(itemNode).sort(compareNodes)))
        };
    };
    var isRoot = function(parent) {
        return parent === null || !surfaceIds.has(parent);
    };
    var rootSurfaces = surfaces.filter(function(s) {
        return isRoot(parentOfSurface(s));
    }).map(surfaceNode).sort(compareNodes);
    var rootItems = items.filter(function(i) {
        return isRoot(parentOfItem(i));
    }).map(itemNode).sort(compareNodes);
    return _to_consumable_array(rootSurfaces).concat(_to_consumable_array(rootItems));
};
// src/components/OnboardingList/CapacityTag.tsx
import { Icon as Icon4, Tag as Tag4 } from "@repo/design-system";
import { semantic as semantic5 } from "@repo/design-tokens";
import { jsx as jsx10 } from "react/jsx-runtime";
var TAG_TONE = {
    neutral: "neutral",
    error: semantic5.status.roles.problem.tagTone,
    warn: semantic5.status.roles.problem.tagTone
};
var SOURCE = {
    calculated: {
        glyph: "calculator",
        words: "calculated"
    },
    hand: {
        glyph: "hand",
        words: "set by hand"
    },
    product: {
        glyph: "tag",
        words: "from the product"
    }
};
var shown = function(value) {
    return value !== null && Number.isFinite(value) ? value : null;
};
var capacityWords = function(value, source) {
    var _SOURCE_source;
    var v = shown(value);
    if (v === null) return "Capacity not set";
    var words = (_SOURCE_source = SOURCE[source]) === null || _SOURCE_source === void 0 ? void 0 : _SOURCE_source.words;
    return words ? "Capacity ".concat(v, ", ").concat(words) : "Capacity ".concat(v);
};
var CapacityTag = function(param) {
    var value = param.value, source = param.source, _param_tone = param.tone, tone = _param_tone === void 0 ? "neutral" : _param_tone, tmp = param.surface, surface8 = tmp === void 0 ? "on-glass" : tmp, className = param.className;
    var _SOURCE_source;
    var glyph = (_SOURCE_source = SOURCE[source]) === null || _SOURCE_source === void 0 ? void 0 : _SOURCE_source.glyph;
    var _TAG_TONE_tone, _shown;
    return /* @__PURE__ */ jsx10(Tag4, {
        surface: surface8,
        tone: (_TAG_TONE_tone = TAG_TONE[tone]) !== null && _TAG_TONE_tone !== void 0 ? _TAG_TONE_tone : "neutral",
        size: "dense",
        icon: glyph ? /* @__PURE__ */ jsx10(Icon4, {
            name: glyph,
            size: "xs"
        }) : void 0,
        "aria-label": capacityWords(value, source),
        className: [
            "tl-capacity-tag",
            "source-".concat(source),
            className
        ].filter(Boolean).join(" "),
        children: (_shown = shown(value)) !== null && _shown !== void 0 ? _shown : "\u2013"
    });
};
// src/components/CameraWall/cameraWallStates.ts
import { semantic as semantic6, ink as ink5, rgba as rgba4 } from "@repo/design-tokens";
var CAMERA_WALL_STATE_ROLE = {
    healthy: "information",
    warning: "information",
    error: "deadEnd",
    connecting: "information",
    not_configured: "deadEnd"
};
var _semantic6_status = semantic6.status, roles2 = _semantic6_status.roles;
var veilFor = function(role, bottomAlpha) {
    return "linear-gradient(160deg, ".concat(rgba4(roles2[role].mark, 0.1), ", ").concat(rgba4(ink5[1], bottomAlpha), ")");
};
var looksOf = function(state) {
    var role = roles2[CAMERA_WALL_STATE_ROLE[state]];
    return {
        fill: role.mark,
        ink: role.ink,
        dot: role.mark
    };
};
var CAMERA_WALL_STATES = {
    healthy: _object_spread_props(_object_spread({}, looksOf("healthy")), {
        veil: veilFor(CAMERA_WALL_STATE_ROLE.healthy, 0.14),
        label: "Healthy",
        live: true
    }),
    warning: _object_spread_props(_object_spread({}, looksOf("warning")), {
        veil: veilFor(CAMERA_WALL_STATE_ROLE.warning, 0.16),
        label: "Stale",
        live: true
    }),
    error: _object_spread_props(_object_spread({}, looksOf("error")), {
        veil: veilFor(CAMERA_WALL_STATE_ROLE.error, 0.34),
        label: "Signal lost",
        live: true
    }),
    connecting: _object_spread_props(_object_spread({}, looksOf("connecting")), {
        label: "Connecting\u2026",
        live: false
    }),
    not_configured: _object_spread_props(_object_spread({}, looksOf("not_configured")), {
        label: "Not configured",
        live: false
    })
};
var CAMERA_WALL_STATE_ORDER = [
    "healthy",
    "warning",
    "error",
    "connecting",
    "not_configured"
];
var CAMERA_WALL_PLACEMENT_STATUS_ORDER = [
    "healthy",
    "warning",
    "error",
    "connecting"
];
var CAMERA_WALL_FILTER_LABELS = {
    healthy: "Healthy",
    warning: "Stale",
    error: "Signal lost",
    connecting: "Connecting",
    not_configured: "Not configured"
};
// src/components/CameraWall/cameraWallMotion.ts
import { space as space4 } from "@repo/design-tokens";
var EXPAND_MS = 260;
var EXPAND_EASE = "cubic-bezier(.4, 0, .2, 1)";
var FRAME_ZOOM_REST_MS = 1e3;
var ARRIVED_MS = 1200;
var FRAME_ZOOM_INSET_PX = parseInt(space4[12], 10);
var FRAME_ZOOM_LAYER = 1200;
// src/dragTypes.ts
var STREAM_DRAG_TYPE = "application/x-twinlabs-stream+json";
// src/components/CameraWall/cameraWallIcons.tsx
import { icon as iconSize } from "@repo/design-tokens";
import { jsx as jsx11, jsxs as jsxs7 } from "react/jsx-runtime";
var Svg = function(param) {
    var _param_size = param.size, size = _param_size === void 0 ? "sm" : _param_size, title = param.title, path = param.path, className = param.className, _param_viewBox = param.// Font Awesome paths are not all 512 wide — the video glyph is 576. Drawing it in a 512 box
    // clips its right edge.
    viewBox, viewBox = _param_viewBox === void 0 ? "0 0 512 512" : _param_viewBox;
    return /* @__PURE__ */ jsxs7("svg", {
        className: className,
        width: iconSize[size],
        height: iconSize[size],
        viewBox: viewBox,
        fill: "currentColor",
        "aria-hidden": title ? void 0 : true,
        role: title ? "img" : void 0,
        focusable: "false",
        children: [
            title ? /* @__PURE__ */ jsx11("title", {
                children: title
            }) : null,
            /* @__PURE__ */ jsx11("path", {
                d: path
            })
        ]
    });
};
var P = {
    rotate: "M463.5 224H472c13.3 0 24-10.7 24-24V72c0-9.7-5.8-18.5-14.8-22.2s-19.3-1.7-26.2 5.2L413.4 96.6c-87.6-86.5-228.7-86.2-315.8 1c-87.5 87.5-87.5 229.3 0 316.8s229.3 87.5 316.8 0c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0c-62.5 62.5-163.8 62.5-226.3 0s-62.5-163.8 0-226.3c62.2-62.2 162.7-62.5 225.3-1L327 183c-6.9 6.9-8.9 17.2-5.2 26.2s12.5 14.8 22.2 14.8H463.5z",
    circleCheck: "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z",
    triangleExclamation: "M256 32c14.2 0 27.3 7.5 34.5 19.8l216 368c7.3 12.4 7.3 27.7 .2 40.1S486.3 480 472 480H40c-14.3 0-27.6-7.7-34.7-20.1s-7-27.8 .2-40.1l216-368C228.7 39.5 241.8 32 256 32zm0 128c-13.3 0-24 10.7-24 24V296c0 13.3 10.7 24 24 24s24-10.7 24-24V184c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z",
    circleExclamation: "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c13.3 0 24 10.7 24 24V264c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z",
    videoSlash: "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L525.6 386.7c1.6-4.3 2.4-8.9 2.4-13.7V138.9c0-12.1-6.8-23.2-17.6-28.6s-23.7-4.3-33.3 3L400 172.2V128c0-35.3-28.7-64-64-64H113.9L38.8 5.1zM0 128V384c0 35.3 28.7 64 64 64H336c14.4 0 27.6-4.7 38.3-12.6L21.9 88.2C8.7 99.9 0 112.9 0 128z",
    video: "M0 128C0 92.7 28.7 64 64 64H320c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128zM559.1 99.8c10.4 5.6 16.9 16.4 16.9 28.2V384c0 11.8-6.5 22.6-16.9 28.2s-23 5-32.9-1.6l-96-64L416 337.1V320 192 174.9l14.2-9.5 96-64c9.8-6.5 22.4-7.2 32.9-1.6z",
    compress: "M160 64c0-17.7-14.3-32-32-32s-32 14.3-32 32v64H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c17.7 0 32-14.3 32-32V64zM32 320c-17.7 0-32 14.3-32 32s14.3 32 32 32H96v64c0 17.7 14.3 32 32 32s32-14.3 32-32V352c0-17.7-14.3-32-32-32H32zM352 64c0-17.7-14.3-32-32-32s-32 14.3-32 32v96c0 17.7 14.3 32 32 32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H352V64zM320 320c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32s32-14.3 32-32V384h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H320z"
};
var RefreshIcon = function(props) {
    return /* @__PURE__ */ jsx11(Svg, _object_spread_props(_object_spread({}, props), {
        path: P.rotate
    }));
};
var HealthyIcon = function(props) {
    return /* @__PURE__ */ jsx11(Svg, _object_spread_props(_object_spread({}, props), {
        path: P.circleCheck
    }));
};
var WarningIcon = function(props) {
    return /* @__PURE__ */ jsx11(Svg, _object_spread_props(_object_spread({}, props), {
        path: P.triangleExclamation
    }));
};
var ErrorIcon = function(props) {
    return /* @__PURE__ */ jsx11(Svg, _object_spread_props(_object_spread({}, props), {
        path: P.circleExclamation
    }));
};
var NoFeedIcon = function(props) {
    return /* @__PURE__ */ jsx11(Svg, _object_spread_props(_object_spread({}, props), {
        path: P.videoSlash
    }));
};
var CollapseIcon = function(props) {
    return /* @__PURE__ */ jsx11(Svg, _object_spread_props(_object_spread({}, props), {
        path: P.compress
    }));
};
var VideoIcon = function(_param) {
    var _param_size = _param.size, size = _param_size === void 0 ? "lg" : _param_size, props = _object_without_properties(_param, [
        "size"
    ]);
    return /* @__PURE__ */ jsx11(Svg, _object_spread_props(_object_spread({}, props), {
        size: size,
        viewBox: "0 0 576 512",
        path: P.video
    }));
};
var STATE_ICON = {
    healthy: HealthyIcon,
    warning: WarningIcon,
    error: ErrorIcon,
    connecting: RefreshIcon,
    not_configured: NoFeedIcon
};
// src/components/CameraWall/CameraPicture.tsx
import React6 from "react";
import styled12, { css as css3 } from "styled-components";
import { Icon as Icon6, Skeleton } from "@repo/design-system";
import { space as space6, inset as inset3, icon, radius as radius8, glass as glass3, shadow as shadow6, line as line2, surface as surface5, motion as motion4, typeRole as typeRole3, weight as weight5, semantic as semantic10, inkOn as inkOn2, ink as ink7, rgba as rgba5 } from "@repo/design-tokens";
// src/components/CameraWall/cameraWallLayout.ts
var CELL_RATIO = 16 / 9;
var feedBoxForRatio = function(ratio) {
    var r = typeof ratio === "number" && Number.isFinite(ratio) && ratio > 0 ? ratio : CELL_RATIO;
    if (r >= CELL_RATIO) {
        return {
            width: "100.000%",
            height: "".concat((CELL_RATIO / r * 100).toFixed(3), "%")
        };
    }
    return {
        width: "".concat((r / CELL_RATIO * 100).toFixed(3), "%"),
        height: "100.000%"
    };
};
var expandedRectFor = function(ratio, areaWidth, areaHeight) {
    var r = typeof ratio === "number" && Number.isFinite(ratio) && ratio > 0 ? ratio : CELL_RATIO;
    var width = areaWidth;
    var height = areaWidth / r;
    if (height > areaHeight) {
        height = areaHeight;
        width = areaHeight * r;
    }
    return {
        left: (areaWidth - width) / 2,
        top: (areaHeight - height) / 2,
        width: width,
        height: height
    };
};
// src/components/CameraWall/cameraWallName.tsx
import styled9 from "styled-components";
import { radius as radius5, glass, shadow as shadow4, typeRole, weight as weight3, semantic as semantic7 } from "@repo/design-tokens";
var NameText = styled9.span(_templateObject16(), radius5.pill, glass.blurSm, glass.blurSm, shadow4.inkGlassRgb, semantic7.text.primary, typeRole.caption1.fontSize, typeRole.caption1.lineHeight, weight3.medium);
var NameLabel = styled9.span(_templateObject17());
// src/components/CameraWall/cameraWallSurface.ts
import styled10, { keyframes } from "styled-components";
import { radius as radius6, semantic as semantic8, glass as glass2 } from "@repo/design-tokens";
var FEED_OUTER_RADIUS = "calc(".concat(radius6.md, " + 1.5px)");
var PICTURE_FILTER = "saturate(0.85) contrast(1.02)";
var surroundIn = keyframes(_templateObject18());
var CameraWallSurround = styled10.div(_templateObject19(), semantic8.surface.app, glass2.blurXs, glass2.blurXs, surroundIn, EXPAND_MS, EXPAND_EASE);
// src/components/CameraWall/cameraWallPlacement.tsx
import styled11 from "styled-components";
import { Icon as Icon5 } from "@repo/design-system";
import { brand as brand3, ink as ink6, inset as inset2, motion as motion3, radius as radius7, semantic as semantic9, shadow as shadow5, space as space5, typeRole as typeRole2, weight as weight4 } from "@repo/design-tokens";
import { jsx as jsx12, jsxs as jsxs8 } from "react/jsx-runtime";
var placementCameraName = function(placement, feedName) {
    return placement.placed && placement.camera && placement.camera !== feedName ? placement.camera : null;
};
var placementSummary = function(placed, total, camerasWithoutStream) {
    var noun = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "stream";
    var main = "".concat(placed, " of ").concat(total, " ").concat(total === 1 ? noun : "".concat(noun, "s"), " placed");
    if (camerasWithoutStream > 0) {
        return {
            main: main,
            note: {
                tone: "no-stream",
                text: camerasWithoutStream === 1 ? "1 camera on the plan has no stream" : "".concat(camerasWithoutStream, " cameras on the plan have no stream")
            }
        };
    }
    if (placed === 0) return {
        main: main,
        note: {
            tone: "neutral",
            text: "This step is optional"
        }
    };
    return {
        main: main,
        note: {
            tone: "placed",
            text: "Every camera on the plan has a stream"
        }
    };
};
var placementKey = function(placement) {
    var _placement_camera;
    return placement === void 0 ? "" : placement.placed ? "placed\0".concat(placement.floor, "\0").concat((_placement_camera = placement.camera) !== null && _placement_camera !== void 0 ? _placement_camera : "") : "not-placed";
};
var _semantic9_status_roles = semantic9.status.roles, workToDo = _semantic9_status_roles.workToDo, information = _semantic9_status_roles.information;
var PLACEMENT_TONE = {
    "not-placed": {
        dot: workToDo.mark,
        ink: workToDo.ink
    },
    "no-stream": {
        dot: information.mark,
        ink: information.ink
    }
};
var PlacementDot = styled11.span.attrs({
    "aria-hidden": true
})(_templateObject20(), radius7.pill, function(p) {
    return PLACEMENT_TONE[p.$tone].dot;
});
var Foot = styled11.div(_templateObject21(), inset2[2], typeRole2.caption1.fontSize, typeRole2.caption1.lineHeight, ink6[2], ink6[4], weight4.medium, PLACEMENT_TONE["not-placed"].ink, ink6[3], brand3.cyanPress, weight4.medium, motion3.durFast, motion3.easeUi);
var PlacementFoot = function(param) {
    var placement = param.placement, feedName = param.feedName;
    if (!placement.placed) {
        return /* @__PURE__ */ jsxs8(Foot, {
            "data-camera-wall-placement": "not-placed",
            children: [
                /* @__PURE__ */ jsx12("span", {
                    className: "grip",
                    children: /* @__PURE__ */ jsx12(Icon5, {
                        name: "grip-vertical",
                        size: "xs"
                    })
                }),
                /* @__PURE__ */ jsx12(PlacementDot, {
                    $tone: "not-placed"
                }),
                /* @__PURE__ */ jsx12("span", {
                    className: "label is-not-placed",
                    children: "Not placed"
                }),
                /* @__PURE__ */ jsx12("span", {
                    "data-placement-hint": true,
                    children: "Drag onto the plan"
                })
            ]
        });
    }
    var camera = placementCameraName(placement, feedName);
    return /* @__PURE__ */ jsxs8(Foot, {
        "data-camera-wall-placement": "placed",
        children: [
            /* @__PURE__ */ jsx12("span", {
                className: "label",
                children: placement.floor
            }),
            camera ? /* @__PURE__ */ jsxs8("span", {
                className: "camera",
                children: [
                    "\xB7 ",
                    camera
                ]
            }) : null
        ]
    });
};
var Caption = styled11.span(_templateObject22(), space5[2], space5[1], space5[3], radius7.pill, shadow5.inkGlassRgb, typeRole2.caption1.fontSize, typeRole2.caption1.lineHeight, weight4.regular, ink6[2], inset2[2], weight4.semibold, PLACEMENT_TONE["not-placed"].ink);
var placementSentence = function(placement, feedName) {
    if (!placement.placed) return "Drag the tile onto the plan to place it.";
    var camera = placementCameraName(placement, feedName);
    return camera ? "On the plan as ".concat(camera, ".") : "On the plan.";
};
var PlacementCaption = function(param) {
    var placement = param.placement, feedName = param.feedName;
    return /* @__PURE__ */ jsxs8(Caption, {
        "data-camera-wall-caption": true,
        children: [
            /* @__PURE__ */ jsxs8("b", {
                className: placement.placed ? void 0 : "is-not-placed",
                children: [
                    placement.placed ? null : /* @__PURE__ */ jsx12(PlacementDot, {
                        $tone: "not-placed"
                    }),
                    placement.placed ? placement.floor : "Not placed"
                ]
            }),
            /* @__PURE__ */ jsx12("span", {
                className: "sentence",
                children: placementSentence(placement, feedName)
            })
        ]
    });
};
// src/components/CameraWall/CameraPicture.tsx
import { Fragment as Fragment4, jsx as jsx13, jsxs as jsxs9 } from "react/jsx-runtime";
var COLLAPSE_STATUS_AT = 250;
var COLLAPSE_CHROME_AT = 150;
var FOOT_ROW_PX = 22;
var FOOT_EDGE_PX = 8;
var FOOT_ACTION_PX = 6 + 24;
var NAME_RESERVE_PX = 22 + 8;
var THUMB_RADIUS = "5px";
var DRAG_RADIUS = "9px";
var isWide = function(size) {
    return size === "enlarged";
};
var collapses = function(size) {
    return size === "tile";
};
var PictureCell = styled12.div(_templateObject25(), function(p) {
    return p.$fill ? css3(_templateObject23()) : css3(_templateObject24());
});
var Feed = styled12.div(_templateObject27(), function(p) {
    return p.$w;
}, function(p) {
    return p.$h;
}, function(p) {
    return p.$fill;
}, FEED_OUTER_RADIUS, function(p) {
    return p.$selected ? css3(_templateObject26(), shadow6.selected) : "";
}, function(p) {
    return p.$selected ? "var(--tl-focus), ".concat(shadow6.selected) : "var(--tl-focus)";
});
var Inner = styled12.div(_templateObject28(), radius8.md, line2[1]);
var Picture = styled12.img(_templateObject29(), PICTURE_FILTER);
var OverlayLayer = styled12.div(_templateObject30());
var Veil = styled12.div(_templateObject31(), function(p) {
    return p.$veil;
});
var NamePill = styled12.div(_templateObject33(), function(p) {
    return isWide(p.$size) ? space6[3] : space6[2];
}, function(p) {
    return isWide(p.$size) ? space6[3] : space6[2];
}, function(p) {
    return isWide(p.$size) ? "60px" : "42px";
}, function(p) {
    return collapses(p.$size) ? css3(_templateObject32(), COLLAPSE_CHROME_AT, space6[2]) : "";
});
var wideChrome = css3(_templateObject34(), typeRole3.caption1.fontSize, typeRole3.caption1.lineHeight);
var WideName = styled12(NameText)(_templateObject35(), wideChrome);
var RoundButton = styled12.button(_templateObject36(), radius8.pill, glass3.blurSm, glass3.blurSm, shadow6.glassSm, semantic10.text.primary, motion4.durFast, motion4.easeUi, shadow6.glassHover);
var CornerButton = styled12(RoundButton)(_templateObject38(), space6[2], space6[2], function(p) {
    return collapses(p.$size) ? css3(_templateObject37(), COLLAPSE_CHROME_AT) : "";
});
var Foot2 = styled12.div(_templateObject39(), function(p) {
    return p.$raised ? 4 : 2;
}, function(p) {
    return p.$raised ? "pointer-events: none;" : "";
}, function(p) {
    return isWide(p.$size) ? space6[3] : space6[2];
}, function(p) {
    return isWide(p.$size) ? space6[3] : space6[2];
}, function(p) {
    return isWide(p.$size) ? space6[3] : space6[2];
}, inset3[2]);
var FootRow = styled12.div(_templateObject40(), function(p) {
    return isWide(p.$size) ? "center" : "flex-end";
}, inset3[2]);
var Spacer = styled12.span(_templateObject41());
var StatusPill = styled12.span(_templateObject43(), inset3[2], radius8.pill, function(p) {
    return p.$fill;
}, function(p) {
    return p.$ink;
}, typeRole3.captionCompact.fontSize, typeRole3.captionCompact.lineHeight, weight5.medium, shadow6.inkGlassRgb, function(p) {
    return isWide(p.$size) ? wideChrome : "";
}, function(p) {
    return collapses(p.$size) ? css3(_templateObject42(), COLLAPSE_STATUS_AT, icon.md, icon.md, icon.md, shadow6.inkGlassRgb, inset3[3], inset3[3]) : "";
});
var Stamp = styled12.span(_templateObject44(), radius8.pill, glass3.blurSm, glass3.blurSm, inkOn2.aqua, typeRole3.caption2.fontSize, typeRole3.caption2.lineHeight, weight5.semibold, shadow6.inkGlassRgb, function(p) {
    return isWide(p.$size) ? wideChrome : "";
});
var StampDate = styled12.span(_templateObject46(), function(p) {
    return collapses(p.$size) ? css3(_templateObject45(), COLLAPSE_CHROME_AT) : "";
});
var placeholderFill = css3(_templateObject47(), radius8.md);
var WaitingSkeleton = styled12(Skeleton)(_templateObject48(), placeholderFill);
var NotConfiguredMark = styled12.div(_templateObject49(), radius8.pill, CAMERA_WALL_STATES.not_configured.fill, CAMERA_WALL_STATES.not_configured.ink);
var NotConfigured = styled12.div(_templateObject50(), placeholderFill, surface5[3], surface5[4], space6[2], NAME_RESERVE_PX, space6[2], function(p) {
    return p.$reserve;
}, function(p) {
    return p.$markMin;
}, NotConfiguredMark);
var footReservePx = function(withAction) {
    return FOOT_ROW_PX + FOOT_EDGE_PX + (withAction ? FOOT_ACTION_PX : 0);
};
var markMinPx = function(reserve, withAddCamera) {
    return Math.ceil((NAME_RESERVE_PX + 36 + 8 + 16 + (withAddCamera ? 8 + 24 : 0) + reserve + 3) * 16 / 9);
};
var NotConfiguredMsg = styled12.span(_templateObject51(), semantic10.text.primary, typeRole3.caption1.fontSize, typeRole3.caption1.lineHeight, weight5.medium);
var AddCamera = styled12.button(_templateObject52(), space6[3], radius8.pill, semantic10.status.roles.workToDo.mark, semantic10.status.roles.workToDo.wash, semantic10.status.roles.workToDo.ink, typeRole3.captionCompact.fontSize, typeRole3.captionCompact.lineHeight, weight5.medium, shadow6.glassSm);
var FeedAction = styled12.button(_templateObject53(), space6[3], radius8.pill, glass3.bgStrong, glass3.blurSm, glass3.blurSm, semantic10.text.primary, typeRole3.captionCompact.fontSize, typeRole3.captionCompact.lineHeight, weight5.medium, shadow6.glassSm);
var ThumbCell = styled12.span(_templateObject54());
var ThumbBox = styled12.span(_templateObject55(), function(p) {
    return p.$w;
}, function(p) {
    return p.$h;
}, function(p) {
    return p.$radius;
}, line2[1]);
var ThumbPicture = styled12.img(_templateObject56(), PICTURE_FILTER);
var ThumbPlaceholder = styled12.span(_templateObject57(), function(p) {
    return p.$radius;
}, surface5[3], surface5[4], ink7[4]);
var DragName = styled12.span(_templateObject58(), inset3[1], radius8.pill, rgba5(surface5[0], 0.95), semantic10.text.primary, typeRole3.captionCompact.fontSize, typeRole3.captionCompact.lineHeight, weight5.semibold);
var formatStamp = function(d) {
    return {
        date: d.toLocaleDateString("en-GB", {
            day: "numeric",
            month: "short"
        }),
        clock: d.toLocaleTimeString("en-GB", {
            hour12: false
        })
    };
};
var pictureAvailable = function(feed, imageBroken) {
    return CAMERA_WALL_STATES[feed.state].live && !!feed.imageUrl && !imageBroken;
};
var CameraPicture = function(param) {
    var feed = param.feed, size = param.size, _param_selected = param.selected, selected = _param_selected === void 0 ? false : _param_selected, onRefresh = param.onRefresh, onConfigure = param.onConfigure, action = param.action, onEnlarge = param.onEnlarge, caption = param.caption, _param_showStatus = param.showStatus, showStatus = _param_showStatus === void 0 ? true : _param_showStatus, _param_decorative = param.decorative, decorative = _param_decorative === void 0 ? false : _param_decorative, overlay = param.overlay, brokenProp = param.imageBroken, onImageError = param.onImageError, imageRef = param.imageRef, feedRef = param.feedRef, feedProps = param.feedProps, children = param.children, _param_raised = param.raised, raised = _param_raised === void 0 ? false : _param_raised;
    var _feed_capturedAt;
    var controlled = brokenProp !== void 0;
    var _React6_useState = _sliced_to_array(React6.useState(false), 2), brokenOwn = _React6_useState[0], setBrokenOwn = _React6_useState[1];
    React6.useEffect(function() {
        if (!controlled) setBrokenOwn(false);
    }, [
        feed.imageUrl,
        controlled
    ]);
    var imageBroken = controlled ? brokenProp : brokenOwn;
    var markBroken = function() {
        if (!controlled) setBrokenOwn(true);
        onImageError === null || onImageError === void 0 ? void 0 : onImageError();
    };
    var style = CAMERA_WALL_STATES[feed.state];
    var box = feedBoxForRatio(feed.aspectRatio);
    var hasPicture = pictureAvailable(feed, imageBroken);
    if (size === "thumb" || size === "drag") {
        var pictureRadius = size === "drag" ? DRAG_RADIUS : THUMB_RADIUS;
        return /* @__PURE__ */ jsxs9(ThumbCell, {
            "data-camera-picture": size,
            "data-state": feed.state,
            children: [
                /* @__PURE__ */ jsx13(ThumbBox, {
                    $w: box.width,
                    $h: box.height,
                    $radius: pictureRadius,
                    children: hasPicture ? /* @__PURE__ */ jsx13(ThumbPicture, {
                        ref: imageRef,
                        src: feed.imageUrl,
                        alt: "",
                        decoding: "async",
                        loading: "lazy",
                        onError: markBroken
                    }) : // "Waiting" and "no camera" are different glyphs, so a placeholder never claims the
                    // second when the truth is the first (spec Failure States, calibration 1).
                    /* @__PURE__ */ jsx13(ThumbPlaceholder, {
                        "data-thumb-placeholder": feed.state,
                        $radius: pictureRadius,
                        children: /* @__PURE__ */ jsx13(Icon6, {
                            name: feed.state === "connecting" ? "arrows-rotate" : "video-slash",
                            size: "xs"
                        })
                    })
                }),
                size === "drag" ? /* @__PURE__ */ jsx13(DragName, {
                    "data-camera-wall-name": true,
                    children: feed.name
                }) : null
            ]
        });
    }
    var enlarged = isWide(size);
    var showsAction = size === "tile" && !!action && !!onConfigure;
    var showsAddCamera = size === "tile" && !!onConfigure && !action;
    var reserve = footReservePx(showsAction);
    var markMin = markMinPx(reserve, showsAddCamera && feed.state === "not_configured");
    var veil = style.veil;
    var stampAt = feed.capturedAt && !Number.isNaN(feed.capturedAt.getTime()) ? feed.capturedAt : null;
    var stamp = stampAt ? formatStamp(stampAt) : null;
    var StateIcon = STATE_ICON[feed.state];
    var _feed_statusLabel;
    var label = (_feed_statusLabel = feed.statusLabel) !== null && _feed_statusLabel !== void 0 ? _feed_statusLabel : style.label;
    var Name = isWide(size) ? WideName : NameText;
    var _feed_reason;
    return /* @__PURE__ */ jsx13(PictureCell, {
        $fill: enlarged,
        children: /* @__PURE__ */ jsx13(Feed, _object_spread_props(_object_spread({}, feedProps), {
            ref: feedRef,
            $fill: showStatus ? style.fill : line2.control,
            $w: enlarged ? "100%" : box.width,
            $h: enlarged ? "100%" : box.height,
            $selected: size === "tile" && selected,
            "data-camera-picture": size,
            "data-state": feed.state,
            "aria-busy": feed.state === "connecting" || void 0,
            children: /* @__PURE__ */ jsxs9(Inner, {
                children: [
                    hasPicture ? /* @__PURE__ */ jsxs9(Fragment4, {
                        children: [
                            /* @__PURE__ */ jsx13(Picture, {
                                ref: imageRef,
                                src: feed.imageUrl,
                                alt: raised || decorative ? "" : "Latest frame from ".concat(feed.name),
                                decoding: "async",
                                loading: enlarged ? void 0 : "lazy",
                                onError: markBroken
                            }),
                            veil ? /* @__PURE__ */ jsx13(Veil, {
                                $veil: veil
                            }) : null,
                            overlay ? /* @__PURE__ */ jsx13(OverlayLayer, {
                                "data-testid": "tile-host-overlay",
                                children: overlay
                            }) : null
                        ]
                    }) : feed.state === "not_configured" ? /* @__PURE__ */ jsxs9(NotConfigured, {
                        $reserve: reserve,
                        $markMin: markMin,
                        children: [
                            /* @__PURE__ */ jsx13(NotConfiguredMark, {
                                children: /* @__PURE__ */ jsx13(NoFeedIcon, {
                                    size: "md"
                                })
                            }),
                            /* @__PURE__ */ jsx13(NotConfiguredMsg, {
                                children: (_feed_reason = feed.reason) !== null && _feed_reason !== void 0 ? _feed_reason : "No feed set up yet"
                            }),
                            showsAddCamera ? /* @__PURE__ */ jsx13(AddCamera, {
                                type: "button",
                                onClick: function() {
                                    return onConfigure(feed.id);
                                },
                                children: "Add camera"
                            }) : null
                        ]
                    }) : feed.state === "error" ? // NOT a skeleton. Card 21's rule is that a skeleton means "no frame yet"; a stream that
                    // has definitively given up is not still loading, and animating it tells the operator
                    // to wait for something that will never arrive.
                    /* @__PURE__ */ jsxs9(NotConfigured, {
                        $reserve: reserve,
                        $markMin: markMin,
                        children: [
                            /* @__PURE__ */ jsx13(NotConfiguredMark, {
                                children: /* @__PURE__ */ jsx13(StateIcon, {
                                    size: "md"
                                })
                            }),
                            /* @__PURE__ */ jsx13(NotConfiguredMsg, {
                                children: label
                            })
                        ]
                    }) : // The canonical design-system skeleton — never a local shimmer.
                    /* @__PURE__ */ jsx13(WaitingSkeleton, {
                        shape: "media"
                    }),
                    children,
                    /* @__PURE__ */ jsx13(NamePill, {
                        $size: size,
                        children: /* @__PURE__ */ jsx13(Name, {
                            children: /* @__PURE__ */ jsx13(NameLabel, {
                                "data-camera-wall-name": true,
                                title: feed.name,
                                children: feed.name
                            })
                        })
                    }),
                    size === "tile" && style.live && onRefresh ? /* @__PURE__ */ jsx13(CornerButton, {
                        $size: size,
                        type: "button",
                        "aria-label": "Refresh ".concat(feed.name),
                        onClick: function() {
                            return onRefresh(feed.id);
                        },
                        children: /* @__PURE__ */ jsx13(RefreshIcon, {
                            size: "sm"
                        })
                    }) : null,
                    size === "frame" && onEnlarge ? /* @__PURE__ */ jsx13(CornerButton, {
                        $size: size,
                        type: "button",
                        "aria-label": "Enlarge ".concat(feed.name),
                        onClick: function() {
                            return onEnlarge(feed.id);
                        },
                        children: /* @__PURE__ */ jsx13(Icon6, {
                            name: "up-right-and-down-left-from-center",
                            size: "sm"
                        })
                    }) : null,
                    /* @__PURE__ */ jsxs9(Foot2, {
                        $raised: raised,
                        $size: size,
                        children: [
                            /* @__PURE__ */ jsxs9(FootRow, {
                                $size: size,
                                children: [
                                    showStatus ? /* @__PURE__ */ jsxs9(StatusPill, {
                                        $fill: style.fill,
                                        $ink: style.ink,
                                        $size: size,
                                        role: "img",
                                        "aria-label": "".concat(feed.name, ": ").concat(label),
                                        children: [
                                            /* @__PURE__ */ jsx13(StateIcon, {
                                                size: "xs"
                                            }),
                                            /* @__PURE__ */ jsx13("span", {
                                                children: label
                                            })
                                        ]
                                    }) : null,
                                    size === "enlarged" && caption ? /* @__PURE__ */ jsx13(PlacementCaption, {
                                        placement: caption,
                                        feedName: feed.name
                                    }) : null,
                                    /* @__PURE__ */ jsx13(Spacer, {}),
                                    stamp ? /* @__PURE__ */ jsxs9(Stamp, {
                                        $size: size,
                                        title: (_feed_capturedAt = feed.capturedAt) === null || _feed_capturedAt === void 0 ? void 0 : _feed_capturedAt.toISOString(),
                                        children: [
                                            /* @__PURE__ */ jsxs9(StampDate, {
                                                $size: size,
                                                children: [
                                                    stamp.date,
                                                    " \xB7 "
                                                ]
                                            }),
                                            stamp.clock
                                        ]
                                    }) : null
                                ]
                            }),
                            showsAction ? /* @__PURE__ */ jsx13(FeedAction, {
                                type: "button",
                                "aria-label": action.ariaLabel,
                                title: action.label,
                                onClick: function() {
                                    return onConfigure(feed.id);
                                },
                                children: action.label
                            }) : null
                        ]
                    })
                ]
            })
        }))
    });
};
// src/components/IdentifiedScoreCard/IdentifiedScoreCard.tsx
import { useId } from "react";
import styled13 from "styled-components";
import { fontSans, ink as ink8, inkOn as inkOn3, space as space7, typeRole as typeRole4, typeScale as typeScale4, weight as weight6 } from "@repo/design-tokens";
import { Card, Icon as Icon7, Progress } from "@repo/design-system";
import { jsx as jsx14, jsxs as jsxs10 } from "react/jsx-runtime";
var IDENTIFIED_SCORE_FOOTNOTE = "Identified equipment gets its real capacity and 3D model, and can be compared across sites.";
var IDENTIFIED_SCORE_NOTHING = "Nothing here needs identifying.";
var identifiedScoreLine = function(param) {
    var brand5 = param.brand, base = param.base, generic = param.generic;
    return "".concat(brand5, " of ").concat(base, " to a brand \xb7 ").concat(generic, " generic");
};
var Root = styled13(Card)(_templateObject59(), space7[3]);
var Head = styled13.div(_templateObject60(), space7[3]);
var Title = styled13.h4(_templateObject61(), fontSans, typeRole4.body1.fontSize, typeRole4.body1.lineHeight, weight6.semibold, ink8[1]);
var Line = styled13.p(_templateObject62(), fontSans, typeScale4.caption1.fontSize, typeScale4.caption1.lineHeight, ink8[3]);
var Percent = styled13.p(_templateObject63(), fontSans, typeScale4.subtitle2.fontSize, typeScale4.subtitle2.lineHeight, weight6.semibold, inkOn3.aqua);
var Footnote = styled13.p(_templateObject64(), fontSans, typeScale4.caption1.fontSize, typeScale4.caption1.lineHeight, ink8[3]);
var IdentifiedScoreCard = function(param) {
    var score = param.score, _param_headingLevel = param.headingLevel, headingLevel = _param_headingLevel === void 0 ? 4 : _param_headingLevel, tmp = param.surface, surface8 = tmp === void 0 ? "on-solid" : tmp, className = param.className;
    var headingId = useId();
    var Heading = "h".concat(headingLevel);
    var scored = score.percent !== null;
    return /* @__PURE__ */ jsxs10(Root, {
        surface: surface8,
        size: "sm",
        className: className,
        "data-testid": "identified-score-card",
        children: [
            /* @__PURE__ */ jsxs10(Head, {
                children: [
                    /* @__PURE__ */ jsx14(IconDisc, {
                        tone: "identify",
                        children: /* @__PURE__ */ jsx14(Icon7, {
                            name: "industry",
                            variant: "solid"
                        })
                    }),
                    /* @__PURE__ */ jsxs10("div", {
                        children: [
                            /* @__PURE__ */ jsx14(Title, {
                                as: Heading,
                                id: headingId,
                                children: "Manufacturer identified"
                            }),
                            /* @__PURE__ */ jsx14(Line, {
                                children: scored ? identifiedScoreLine(score) : IDENTIFIED_SCORE_NOTHING
                            })
                        ]
                    }),
                    scored && /* @__PURE__ */ jsxs10(Percent, {
                        children: [
                            score.percent,
                            " %"
                        ]
                    })
                ]
            }),
            scored && /* @__PURE__ */ jsx14(Progress, {
                "aria-labelledby": headingId,
                value: score.brand,
                max: score.base,
                valueText: "".concat(score.brand, " of ").concat(score.base, " identified to a brand")
            }),
            /* @__PURE__ */ jsx14(Footnote, {
                children: IDENTIFIED_SCORE_FOOTNOTE
            })
        ]
    });
};
// src/components/IdentifyCard/useIdentifyPicker.ts
import { useCallback as useCallback4, useEffect as useEffect8, useMemo, useRef as useRef8, useState as useState6 } from "react";
import { isGenericCatalogueManufacturer } from "@repo/front-end-utils";
var YOUR_BRANDS = "Your brands";
var otherTwinsCaption = function(organisationName) {
    return organisationName ? "On ".concat(organisationName, "’s other twins") : "On this customer\u2019s other twins";
};
var orgName = function(organisationName) {
    return (organisationName === null || organisationName === void 0 ? void 0 : organisationName.trim()) || "this customer";
};
var groupCaption = function(key, maker, organisationName) {
    var org = orgName(organisationName);
    switch(key){
        case "similar-twin":
            return "Similar, in this twin";
        case "similar-organisation":
            return "Similar, on ".concat(org, "’s other twins");
        case "similar-catalogue":
            return "More similar from ".concat(maker);
        case "similar-other-makers":
            return "Similar from other makers";
        case "maker-twin":
            return "".concat(maker, " in this twin");
        case "maker-organisation":
            return "".concat(maker, " on ").concat(org, "’s other twins");
        default:
            return "More from ".concat(maker);
    }
};
var MAKERS_IN_TWIN = "Makers in this twin";
var makersOnOtherTwinsCaption = function(organisationName) {
    return "Makers on ".concat(orgName(organisationName), "’s other twins");
};
var EQUIPMENT_SUGGESTION_LIMIT = 10;
var MAKER_VALUE_PREFIX = "maker:";
var sameMaker = function(a, b) {
    return !!a && !!b && a.trim().toLowerCase() === b.trim().toLowerCase();
};
var makerMeta = function(maker) {
    if (maker.scope === "twin") return "".concat(maker.count, " in this twin");
    var _maker_twinCount;
    var twins = (_maker_twinCount = maker.twinCount) !== null && _maker_twinCount !== void 0 ? _maker_twinCount : 0;
    return "On ".concat(twins, " other ").concat(twins === 1 ? "twin" : "twins");
};
var makerCaption = function(maker, organisationName) {
    return maker.scope === "twin" ? MAKERS_IN_TWIN : makersOnOtherTwinsCaption(organisationName);
};
var makerOptions = function(makers, organisationName) {
    return makers.slice(0, EQUIPMENT_SUGGESTION_LIMIT).map(function(maker) {
        return {
            value: "".concat(MAKER_VALUE_PREFIX).concat(maker.manufacturer),
            label: maker.manufacturer,
            meta: makerMeta(maker),
            group: makerCaption(maker, organisationName),
            best: false,
            maker: maker.manufacturer
        };
    });
};
var groupedOptions = function(ranked, maker, organisationName) {
    var seen = /* @__PURE__ */ new Set();
    var options = [];
    var _ranked_groups;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = ((_ranked_groups = ranked.groups) !== null && _ranked_groups !== void 0 ? _ranked_groups : [])[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var group = _step.value;
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator1 = group.products[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var candidate = _step1.value;
                    if (seen.has(candidate.reference_id)) continue;
                    seen.add(candidate.reference_id);
                    var _candidateMeta;
                    options.push({
                        value: candidate.reference_id,
                        label: candidate.product,
                        meta: (_candidateMeta = candidateMeta(candidate, false)) !== null && _candidateMeta !== void 0 ? _candidateMeta : void 0,
                        group: groupCaption(group.key, maker, organisationName),
                        best: false
                    });
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return options;
};
var MATCHES = "Matches";
var ALL_MANUFACTURERS = "All manufacturers";
var seedText = function(seed) {
    return [
        seed === null || seed === void 0 ? void 0 : seed.manufacturer,
        seed === null || seed === void 0 ? void 0 : seed.kind
    ].filter(function(part) {
        return part && part.trim() !== "";
    }).join(" \xB7 ");
};
var toCatalogueQuery = function(typed) {
    return typed.replace(/·/g, " ").replace(/\s+/g, " ").trim();
};
var candidateMeta = function(candidate, other) {
    if (other) {
        var _candidate_twinCount;
        var twins = (_candidate_twinCount = candidate.twinCount) !== null && _candidate_twinCount !== void 0 ? _candidate_twinCount : 0;
        var on = twins > 0 ? "on ".concat(twins, " ").concat(twins === 1 ? "twin" : "twins") : null;
        return [
            candidate.manufacturer,
            on
        ].filter(Boolean).join(" \xB7 ") || null;
    }
    return [
        candidate.manufacturer,
        candidate.product_line
    ].filter(Boolean).join(" \xB7 ") || null;
};
var legacyRankedOptions = function(ranked, organisationName) {
    var section = function(list, group, other) {
        var best = list.filter(function(c) {
            return c.reference_id === ranked.bestGuess;
        });
        var rest = list.filter(function(c) {
            return c.reference_id !== ranked.bestGuess;
        });
        return _to_consumable_array(best).concat(_to_consumable_array(rest)).map(function(c) {
            var _candidateMeta;
            return {
                value: c.reference_id,
                label: c.product,
                meta: (_candidateMeta = candidateMeta(c, other)) !== null && _candidateMeta !== void 0 ? _candidateMeta : void 0,
                group: group,
                best: c.reference_id === ranked.bestGuess
            };
        });
    };
    var options = section(ranked.yours, YOUR_BRANDS, false);
    var seen = new Set(options.map(function(o) {
        return o.value;
    }));
    if (!ranked.otherTwinsUnavailable) {
        var _options;
        (_options = options).push.apply(_options, _to_consumable_array(section(ranked.otherTwins.filter(function(c) {
            return !seen.has(c.reference_id);
        }), otherTwinsCaption(organisationName), true)));
    }
    return options;
};
var isGrouped = function(ranked) {
    return ranked != null && Array.isArray(ranked.groups);
};
var makerOfReference = function(ranked, referenceId) {
    if (!referenceId || !isGrouped(ranked)) return null;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = ranked.groups[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var group = _step.value;
            var _product_manufacturer;
            var product = group.products.find(function(p) {
                return String(p.reference_id) === String(referenceId);
            });
            if (product) return ((_product_manufacturer = product.manufacturer) === null || _product_manufacturer === void 0 ? void 0 : _product_manufacturer.trim()) || null;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return null;
};
var proposalOptions = function(rankedList, proposal, topGroup) {
    var _proposal_product;
    var id = proposal.reference_id;
    var listed = rankedList.find(function(option) {
        return option.value === id;
    });
    var meta = [
        proposal.manufacturer,
        proposal.product_line
    ].filter(function(part) {
        return part && part.trim();
    }).join(" \xB7 ");
    var top = listed ? _object_spread_props(_object_spread({}, listed), {
        group: topGroup,
        best: true
    }) : {
        value: id,
        label: ((_proposal_product = proposal.product) === null || _proposal_product === void 0 ? void 0 : _proposal_product.trim()) || id,
        meta: meta || void 0,
        group: topGroup,
        best: true
    };
    return [
        top
    ].concat(_to_consumable_array(rankedList.filter(function(option) {
        return option.value !== id;
    }).map(function(option) {
        return _object_spread_props(_object_spread({}, option), {
            best: false
        });
    })));
};
var choiceOptions = function(choices, group) {
    return choices.map(function(choice) {
        var _choice_meta;
        return {
            value: choice.referenceId,
            label: choice.product,
            meta: (_choice_meta = choice.meta) !== null && _choice_meta !== void 0 ? _choice_meta : void 0,
            group: group,
            best: false
        };
    });
};
var matchesText = function(option, query) {
    var q = query.toLowerCase();
    var _option_meta;
    return option.label.toLowerCase().includes(q) || ((_option_meta = option.meta) !== null && _option_meta !== void 0 ? _option_meta : "").toLowerCase().includes(q);
};
var isAbort = function(error) {
    return (error === null || error === void 0 ? void 0 : error.name) === "AbortError";
};
var SEARCH_DEBOUNCE_MS = 300;
var statusOf = function(error) {
    var _error_response;
    var _error_status;
    return (_error_status = error === null || error === void 0 ? void 0 : error.status) !== null && _error_status !== void 0 ? _error_status : error === null || error === void 0 ? void 0 : (_error_response = error.response) === null || _error_response === void 0 ? void 0 : _error_response.status;
};
var useIdentifyPicker = function(param) {
    var assetId = param.assetId, answer = param.answer, fetchers = param.fetchers, organisationName = param.organisationName, logContext = param.logContext, proposal = param.proposal;
    var _proposal_manufacturer, _brandProposal_manufacturer;
    var fetchersRef = useRef8(fetchers);
    fetchersRef.current = fetchers;
    var logRef = useRef8(logContext);
    logRef.current = logContext;
    var _useState6 = _sliced_to_array(useState6(null), 2), ranked = _useState6[0], setRanked = _useState6[1];
    var _useState61 = _sliced_to_array(useState6(null), 2), rankedError = _useState61[0], setRankedError = _useState61[1];
    var _useState62 = _sliced_to_array(useState6(0), 2), rankedAttempt = _useState62[0], setRankedAttempt = _useState62[1];
    var _useState63 = _sliced_to_array(useState6("ranked"), 2), mode = _useState63[0], setMode = _useState63[1];
    var _useState64 = _sliced_to_array(useState6([]), 2), found = _useState64[0], setFound = _useState64[1];
    var _useState65 = _sliced_to_array(useState6(false), 2), searching = _useState65[0], setSearching = _useState65[1];
    var _useState66 = _sliced_to_array(useState6(null), 2), searchError = _useState66[0], setSearchError = _useState66[1];
    var seq = useRef8(0);
    var inFlight = useRef8(null);
    var debounce = useRef8(null);
    var lastQuery = useRef8("");
    var lastSearch = useRef8(null);
    var _useState67 = _sliced_to_array(useState6(null), 2), generics = _useState67[0], setGenerics = _useState67[1];
    var _useState68 = _sliced_to_array(useState6(null), 2), genericsError = _useState68[0], setGenericsError = _useState68[1];
    var _useState69 = _sliced_to_array(useState6(0), 2), genericsAttempt = _useState69[0], setGenericsAttempt = _useState69[1];
    var _useState610 = _sliced_to_array(useState6(null), 2), genericQuery = _useState610[0], setGenericQuery = _useState610[1];
    var _useState611 = _sliced_to_array(useState6(false), 2), typed = _useState611[0], setTyped = _useState611[1];
    var _useState612 = _sliced_to_array(useState6(void 0), 2), makerChoice = _useState612[0], setMakerChoice = _useState612[1];
    var _useState613 = _sliced_to_array(useState6(null), 2), makerAnswer = _useState613[0], setMakerAnswer = _useState613[1];
    var _useState614 = _sliced_to_array(useState6(null), 2), makerError = _useState614[0], setMakerError = _useState614[1];
    var makerSeq = useRef8(0);
    var makerInFlight = useRef8(null);
    var makerAsked = useRef8(null);
    var dropMakerRead = function() {
        var _makerInFlight_current;
        makerSeq.current += 1;
        (_makerInFlight_current = makerInFlight.current) === null || _makerInFlight_current === void 0 ? void 0 : _makerInFlight_current.abort();
        makerInFlight.current = null;
    };
    var dropSearch = function() {
        var _inFlight_current;
        seq.current += 1;
        (_inFlight_current = inFlight.current) === null || _inFlight_current === void 0 ? void 0 : _inFlight_current.abort();
        if (debounce.current) clearTimeout(debounce.current);
        debounce.current = null;
    };
    var _useState615 = _sliced_to_array(useState6(answer), 2), answerSeen = _useState615[0], setAnswerSeen = _useState615[1];
    if (answerSeen !== answer) {
        setAnswerSeen(answer);
        dropSearch();
        lastQuery.current = "";
        lastSearch.current = null;
        setMode("ranked");
        setFound([]);
        setSearching(false);
        setSearchError(null);
        setGenericQuery(null);
        setTyped(false);
        dropMakerRead();
        makerAsked.current = null;
        setMakerChoice(void 0);
        setMakerAnswer(null);
        setMakerError(null);
    }
    useEffect8(function() {
        var controller = new AbortController();
        setRankedError(null);
        fetchersRef.current.ranked(assetId, controller.signal).then(function(answerRanked) {
            if (!controller.signal.aborted) setRanked(answerRanked);
        }).catch(function(error) {
            if (controller.signal.aborted || isAbort(error)) return;
            console.warn("[identify] ranked candidates failed", _object_spread_props(_object_spread({}, logRef.current), {
                assetId: assetId,
                status: statusOf(error)
            }));
            setRankedError("Couldn\u2019t load suggestions");
        });
        return function() {
            return controller.abort();
        };
    }, [
        assetId,
        rankedAttempt
    ]);
    useEffect8(function() {
        if (answer !== "generic" || generics !== null) return void 0;
        var controller = new AbortController();
        setGenericsError(null);
        fetchersRef.current.generics(controller.signal).then(function(choices) {
            if (!controller.signal.aborted) setGenerics(choiceOptions(choices));
        }).catch(function(error) {
            if (controller.signal.aborted || isAbort(error)) return;
            console.warn("[identify] generic products failed", _object_spread_props(_object_spread({}, logRef.current), {
                status: statusOf(error)
            }));
            setGenericsError("Couldn\u2019t load generic products");
        });
        return function() {
            return controller.abort();
        };
    }, [
        answer,
        generics,
        genericsAttempt
    ]);
    useEffect8(function() {
        return function() {
            var _inFlight_current, _makerInFlight_current;
            (_inFlight_current = inFlight.current) === null || _inFlight_current === void 0 ? void 0 : _inFlight_current.abort();
            (_makerInFlight_current = makerInFlight.current) === null || _makerInFlight_current === void 0 ? void 0 : _makerInFlight_current.abort();
            if (debounce.current) clearTimeout(debounce.current);
        };
    }, []);
    var loadMaker = useCallback4(function(maker2) {
        dropMakerRead();
        var mine = makerSeq.current;
        var controller = new AbortController();
        makerInFlight.current = controller;
        makerAsked.current = maker2;
        setMakerAnswer(null);
        setMakerError(null);
        fetchersRef.current.ranked(assetId, controller.signal, maker2).then(function(answerForMaker) {
            if (mine !== makerSeq.current) return;
            setMakerAnswer(answerForMaker);
        }).catch(function(error) {
            if (mine !== makerSeq.current || isAbort(error)) return;
            console.warn("[identify] ranked candidates failed", _object_spread_props(_object_spread({}, logRef.current), {
                assetId: assetId,
                status: statusOf(error)
            }));
            setMakerError("Couldn’t load ".concat(maker2, "’s products"));
        });
    }, [
        assetId
    ]);
    var runSearch = useCallback4(function(query, nextMode) {
        dropSearch();
        var mine = seq.current;
        var controller = new AbortController();
        inFlight.current = controller;
        lastSearch.current = {
            query: query,
            mode: nextMode
        };
        setMode(nextMode);
        setSearching(true);
        setSearchError(null);
        fetchersRef.current.search(query, controller.signal).then(function(choices) {
            if (mine !== seq.current) return;
            setFound(choiceOptions(choices, nextMode === "all" ? ALL_MANUFACTURERS : MATCHES));
            setSearching(false);
        }).catch(function(error) {
            if (mine !== seq.current || isAbort(error)) return;
            console.warn("[identify] catalogue search failed", _object_spread_props(_object_spread({}, logRef.current), {
                queryLength: query.length,
                status: statusOf(error)
            }));
            setSearchError("Couldn\u2019t search the catalogue");
            setSearching(false);
        });
    }, []);
    var search = useCallback4(function(text2) {
        setTyped(true);
        if (answer === "generic") {
            setGenericQuery(text2.trim());
            return;
        }
        var query = toCatalogueQuery(text2);
        lastQuery.current = query;
        dropSearch();
        if (query === "") {
            setMode("ranked");
            setSearching(false);
            setSearchError(null);
            dropMakerRead();
            setMakerChoice(null);
            setMakerAnswer(null);
            setMakerError(null);
            return;
        }
        setMode("matches");
        setSearching(true);
        setSearchError(null);
        debounce.current = setTimeout(function() {
            debounce.current = null;
            runSearch(query, "matches");
        }, SEARCH_DEBOUNCE_MS);
    }, [
        answer,
        runSearch
    ]);
    var searchAll = useCallback4(function() {
        var query = lastQuery.current || (ranked === null || ranked === void 0 ? void 0 : ranked.everythingElse.kind) || (ranked === null || ranked === void 0 ? void 0 : ranked.seed.kind) || "";
        runSearch(query, "all");
    }, [
        ranked,
        runSearch
    ]);
    var retry = useCallback4(function() {
        if (answer === "generic") {
            setGenericsAttempt(function(n) {
                return n + 1;
            });
            return;
        }
        if (mode !== "ranked" && lastSearch.current) {
            runSearch(lastSearch.current.query, lastSearch.current.mode);
            return;
        }
        if (makerError && makerAsked.current) {
            loadMaker(makerAsked.current);
            return;
        }
        setRankedAttempt(function(n) {
            return n + 1;
        });
    }, [
        answer,
        mode,
        runSearch,
        makerError,
        loadMaker
    ]);
    var brandProposal = proposal && !isGenericCatalogueManufacturer((_proposal_manufacturer = proposal.manufacturer) === null || _proposal_manufacturer === void 0 ? void 0 : _proposal_manufacturer.trim()) ? proposal : null;
    var proposalMaker = (brandProposal === null || brandProposal === void 0 ? void 0 : (_brandProposal_manufacturer = brandProposal.manufacturer) === null || _brandProposal_manufacturer === void 0 ? void 0 : _brandProposal_manufacturer.trim()) || makerOfReference(ranked, brandProposal === null || brandProposal === void 0 ? void 0 : brandProposal.reference_id) || null;
    var grouped = isGrouped(ranked);
    var _ref;
    var defaultMaker = (_ref = proposalMaker !== null && proposalMaker !== void 0 ? proposalMaker : ranked === null || ranked === void 0 ? void 0 : ranked.chosenMaker) !== null && _ref !== void 0 ? _ref : null;
    var maker = makerChoice !== void 0 ? makerChoice : defaultMaker;
    var openingServesMaker = grouped && !!maker && sameMaker(ranked === null || ranked === void 0 ? void 0 : ranked.chosenMaker, maker);
    var makerGroups = openingServesMaker ? ranked : makerAnswer;
    useEffect8(function() {
        if (answer !== "brand" || !grouped || makerChoice !== void 0 || !defaultMaker) return;
        if (sameMaker(ranked === null || ranked === void 0 ? void 0 : ranked.chosenMaker, defaultMaker)) return;
        loadMaker(defaultMaker);
    }, [
        ranked,
        answer
    ]);
    var chooseMaker = useCallback4(function(next) {
        setTyped(true);
        dropSearch();
        setMode("ranked");
        setSearching(false);
        setSearchError(null);
        setMakerChoice(next);
        if (ranked && sameMaker(ranked.chosenMaker, next)) {
            dropMakerRead();
            setMakerAnswer(null);
            setMakerError(null);
            return;
        }
        loadMaker(next);
    }, [
        ranked,
        loadMaker
    ]);
    var view = !grouped ? "legacy" : maker ? "products" : "makers";
    var rankedList = useMemo(function() {
        if (!ranked) return [];
        if (!grouped) return legacyRankedOptions(ranked, organisationName);
        var _ranked_makers;
        if (!maker) return makerOptions((_ranked_makers = ranked.makers) !== null && _ranked_makers !== void 0 ? _ranked_makers : [], organisationName);
        return makerGroups ? groupedOptions(makerGroups, maker, organisationName) : [];
    }, [
        ranked,
        grouped,
        maker,
        makerGroups,
        organisationName
    ]);
    var seedFor = function() {
        var _ranked_seed_kind;
        if (answer === "brand") {
            if (grouped) return defaultMaker !== null && defaultMaker !== void 0 ? defaultMaker : "";
            return seedText(ranked === null || ranked === void 0 ? void 0 : ranked.seed);
        }
        if (answer !== "generic") return "";
        var _ranked_seed_kind_trim;
        var kind = (_ranked_seed_kind_trim = ranked === null || ranked === void 0 ? void 0 : (_ranked_seed_kind = ranked.seed.kind) === null || _ranked_seed_kind === void 0 ? void 0 : _ranked_seed_kind.trim()) !== null && _ranked_seed_kind_trim !== void 0 ? _ranked_seed_kind_trim : "";
        return kind !== "" && (generics !== null && generics !== void 0 ? generics : []).some(function(option) {
            return matchesText(option, kind);
        }) ? kind : "";
    };
    var seed = seedFor();
    var fieldKeyRef = useRef8("".concat(answer, ":").concat(seed));
    if (!typed) fieldKeyRef.current = "".concat(answer, ":").concat(seed);
    var fieldKey = fieldKeyRef.current;
    if (answer === "generic") {
        var all = generics !== null && generics !== void 0 ? generics : [];
        var query = genericQuery !== null && genericQuery !== void 0 ? genericQuery : seed;
        return {
            mode: "ranked",
            options: query ? all.filter(function(option) {
                return matchesText(option, query);
            }) : all,
            loading: generics === null && genericsError === null,
            error: genericsError,
            retry: retry,
            search: search,
            searchAll: searchAll,
            defaultQuery: seed,
            fieldKey: fieldKey,
            reason: null,
            ranked: ranked,
            view: "legacy",
            maker: null,
            chooseMaker: chooseMaker,
            autoHighlight: query !== ""
        };
    }
    if (answer === "not_tracked") {
        return {
            mode: "ranked",
            options: [],
            loading: false,
            error: null,
            retry: retry,
            search: search,
            searchAll: searchAll,
            defaultQuery: "",
            fieldKey: fieldKey,
            reason: null,
            ranked: ranked,
            view: "legacy",
            maker: null,
            chooseMaker: chooseMaker,
            autoHighlight: false
        };
    }
    var inRanked = mode === "ranked";
    var shared = {
        mode: mode,
        retry: retry,
        search: search,
        searchAll: searchAll,
        defaultQuery: seed,
        fieldKey: fieldKey,
        ranked: ranked,
        view: view,
        maker: view === "products" ? maker : null,
        chooseMaker: chooseMaker
    };
    if (brandProposal && inRanked && view === "legacy") {
        var _brandProposal_reason;
        return _object_spread_props(_object_spread({}, shared), {
            options: proposalOptions(rankedList, brandProposal, ranked != null ? YOUR_BRANDS : void 0),
            loading: false,
            error: null,
            reason: ((_brandProposal_reason = brandProposal.reason) === null || _brandProposal_reason === void 0 ? void 0 : _brandProposal_reason.trim()) || (ranked === null || ranked === void 0 ? void 0 : ranked.reason) || null,
            autoHighlight: true
        });
    }
    if (inRanked && view === "products") {
        var _brandProposal_reason1;
        var guessHere = !!brandProposal && sameMaker(proposalMaker, maker);
        var list = guessHere ? proposalOptions(rankedList, brandProposal) : rankedList;
        return _object_spread_props(_object_spread({}, shared), {
            options: list.slice(0, EQUIPMENT_SUGGESTION_LIMIT),
            // The guess is offered at once; otherwise the maker's read is loading until it answers.
            loading: !guessHere && makerGroups === null && makerError === null,
            // A failed read leaves the guess offered (the field cannot show rows and an error at once).
            error: guessHere ? null : makerError,
            reason: (guessHere ? brandProposal === null || brandProposal === void 0 ? void 0 : (_brandProposal_reason1 = brandProposal.reason) === null || _brandProposal_reason1 === void 0 ? void 0 : _brandProposal_reason1.trim() : null) || (ranked === null || ranked === void 0 ? void 0 : ranked.reason) || null,
            // Enter takes a To confirm guess on top; a maker's grouped products carry no guess (the
            // *Best guess* tag on the ranked top product is gone), so Enter waits for the operator to
            // move there, as Floor Plan's Product does without a best match.
            autoHighlight: guessHere
        });
    }
    var _ranked_reason;
    return _object_spread_props(_object_spread({}, shared), {
        options: inRanked ? rankedList : found,
        loading: inRanked ? ranked === null && rankedError === null : searching,
        error: inRanked ? rankedError : searchError,
        reason: (_ranked_reason = ranked === null || ranked === void 0 ? void 0 : ranked.reason) !== null && _ranked_reason !== void 0 ? _ranked_reason : null,
        autoHighlight: mode !== "all"
    });
};
// src/components/IdentifyCard/productFieldValues.ts
var NOT_TRACKED_VALUE = "__not_tracked__";
var NOT_TRACKED_OPTION_LABEL = "Not tracked \u2014 no catalogue product";
// src/components/IdentifyCard/IdentifyProductField.tsx
import { useCallback as useCallback5, useEffect as useEffect9, useMemo as useMemo2, useRef as useRef9, useState as useState7 } from "react";
import { Combobox, Field, Icon as Icon8, MenuTrailingLabel } from "@repo/design-system";
import { jsx as jsx15 } from "react/jsx-runtime";
var BEST_GUESS = "Best guess";
var NO_SUGGESTIONS = "No likely products from what was written";
var SHOWING_MAKERS = "Showing manufacturers";
var showingMakerProducts = function(maker) {
    return "Showing ".concat(maker, "’s products");
};
var resultCount = function(shown2, total) {
    return shown2 === total ? "".concat(total, " ").concat(total === 1 ? "result" : "results") : "".concat(shown2, " of ").concat(total, " results");
};
var toComboboxOption = function(option, optionMeta, onPickMaker) {
    if (option.maker !== void 0) {
        var maker = option.maker;
        return {
            value: option.value,
            label: option.label,
            meta: option.meta,
            group: option.group,
            icon: /* @__PURE__ */ jsx15(Icon8, {
                name: "industry",
                size: "xs"
            }),
            trailing: /* @__PURE__ */ jsx15(Icon8, {
                name: "chevron-right",
                size: "xs"
            }),
            trailingText: "",
            onPick: function() {
                return onPickMaker === null || onPickMaker === void 0 ? void 0 : onPickMaker(maker);
            }
        };
    }
    var meta = optionMeta ? optionMeta(option) : option.meta;
    return option.best ? {
        value: option.value,
        label: option.label,
        meta: meta,
        group: option.group,
        icon: /* @__PURE__ */ jsx15(Icon8, {
            name: "star",
            variant: "solid",
            size: "xs"
        }),
        trailing: /* @__PURE__ */ jsx15(MenuTrailingLabel, {
            children: BEST_GUESS
        }),
        trailingText: BEST_GUESS
    } : {
        value: option.value,
        label: option.label,
        meta: meta,
        group: option.group,
        icon: /* @__PURE__ */ jsx15(Icon8, {
            name: "box",
            size: "xs"
        })
    };
};
var IdentifyProductField = function(param) {
    var assetId = param.assetId, answer = param.answer, fetchers = param.fetchers, organisationName = param.organisationName, logContext = param.logContext, _param_busy = param.busy, busy = _param_busy === void 0 ? false : _param_busy, describedBy = param.describedBy, _param_label = param.label, label = _param_label === void 0 ? "Product" : _param_label, aside = param.aside, error = param.error, value = param.value, onChosenChange = param.onChosenChange, onTake = param.onTake, onFieldKey = param.onFieldKey, optionMeta = param.optionMeta, _param_current = param.current, current = _param_current === void 0 ? null : _param_current, _param_notTrackedOption = param.notTrackedOption, notTrackedOption = _param_notTrackedOption === void 0 ? false : _param_notTrackedOption, _param_proposal = param.proposal, proposal = _param_proposal === void 0 ? null : _param_proposal;
    var _picker_ranked;
    var _useState7 = _sliced_to_array(useState7(null), 2), chosenOption = _useState7[0], setChosenOption = _useState7[1];
    var picker = useIdentifyPicker({
        assetId: assetId,
        answer: answer,
        fetchers: fetchers,
        organisationName: organisationName,
        logContext: logContext,
        proposal: proposal
    });
    var enterPressed = useRef9(false);
    var busyRef = useRef9(busy);
    busyRef.current = busy;
    useEffect9(function() {
        onFieldKey === null || onFieldKey === void 0 ? void 0 : onFieldKey(picker.fieldKey);
    }, [
        onFieldKey,
        picker.fieldKey
    ]);
    useEffect9(function() {
        return setChosenOption(null);
    }, [
        answer
    ]);
    var commit = useCallback5(function(next) {
        var byEnter = enterPressed.current;
        enterPressed.current = false;
        if (next === null || next === void 0 ? void 0 : next.startsWith(MAKER_VALUE_PREFIX)) return;
        var _picker_options_find;
        var option = (_picker_options_find = picker.options.find(function(candidate) {
            return candidate.value === next;
        })) !== null && _picker_options_find !== void 0 ? _picker_options_find : null;
        setChosenOption(option);
        onChosenChange(next, option);
        if (next && byEnter && !busyRef.current) onTake === null || onTake === void 0 ? void 0 : onTake(next, option);
    }, [
        onChosenChange,
        onTake,
        picker.options
    ]);
    var options = useMemo2(function() {
        var ranked = current ? picker.options.map(function(option) {
            return option.value === current.referenceId && option.best ? _object_spread_props(_object_spread({}, option), {
                best: false
            }) : option;
        }) : picker.options;
        var listed = ranked.map(function(option) {
            return toComboboxOption(option, optionMeta, picker.chooseMaker);
        });
        var labelOnly = function(option) {
            return _object_spread_props(_object_spread({}, toComboboxOption(_object_spread_props(_object_spread({}, option), {
                best: false
            }), optionMeta)), {
                disabled: true
            });
        };
        var _ref;
        var shown2 = (_ref = value !== null && value !== void 0 ? value : current === null || current === void 0 ? void 0 : current.referenceId) !== null && _ref !== void 0 ? _ref : null;
        if (shown2 && !picker.options.some(function(option) {
            return option.value === shown2;
        })) {
            if (chosenOption && chosenOption.value === shown2) listed.push(labelOnly(chosenOption));
            else if (current && current.referenceId === shown2) {
                listed.push(labelOnly({
                    value: current.referenceId,
                    label: current.label,
                    best: false
                }));
            }
        }
        if (notTrackedOption) {
            listed.push({
                value: NOT_TRACKED_VALUE,
                label: NOT_TRACKED_OPTION_LABEL,
                group: "Or",
                icon: /* @__PURE__ */ jsx15(Icon8, {
                    name: "ban",
                    size: "xs"
                })
            });
        }
        return listed;
    }, [
        picker.options,
        picker.chooseMaker,
        chosenOption,
        value,
        current,
        optionMeta,
        notTrackedOption
    ]);
    var hasProduct = options.some(function(option) {
        return !option.disabled && option.value !== NOT_TRACKED_VALUE;
    });
    var everything = (_picker_ranked = picker.ranked) === null || _picker_ranked === void 0 ? void 0 : _picker_ranked.everythingElse;
    var inRanked = answer === "brand" && picker.mode === "ranked";
    var countText = function(shown2, total) {
        var count = resultCount(shown2, total);
        if (inRanked && picker.view === "makers") return "".concat(SHOWING_MAKERS, ", ").concat(count);
        if (inRanked && picker.view === "products" && picker.maker) {
            return "".concat(showingMakerProducts(picker.maker), ", ").concat(count);
        }
        return count;
    };
    var endAction = answer === "brand" ? {
        label: "Search all manufacturers\u2026",
        meta: everything && everything.count > 0 ? "".concat(everything.count, " ").concat(everything.kind ? "".concat(everything.kind, " ") : "", "products in the catalogue") : void 0,
        icon: /* @__PURE__ */ jsx15(Icon8, {
            name: "magnifying-glass",
            size: "xs"
        }),
        group: "Everything else",
        onSelect: picker.searchAll
    } : void 0;
    var _picker_reason;
    return /* @__PURE__ */ jsx15("div", {
        onKeyDownCapture: function(event) {
            enterPressed.current = event.key === "Enter";
        },
        onPointerDownCapture: function() {
            enterPressed.current = false;
        },
        children: /* @__PURE__ */ jsx15(Field, {
            label: label,
            aside: aside !== void 0 ? aside : answer === "brand" ? (_picker_reason = picker.reason) !== null && _picker_reason !== void 0 ? _picker_reason : void 0 : void 0,
            error: error,
            children: function(wiring) {
                var _ref, _picker_error;
                return /* @__PURE__ */ jsx15(Combobox, _object_spread_props(_object_spread({}, wiring), {
                    "aria-describedby": [
                        wiring["aria-describedby"],
                        describedBy
                    ].filter(Boolean).join(" ") || void 0,
                    searchGlyph: true,
                    autoHighlight: picker.autoHighlight && hasProduct,
                    maxResults: Infinity,
                    options: options,
                    value: (_ref = value !== null && value !== void 0 ? value : current === null || current === void 0 ? void 0 : current.referenceId) !== null && _ref !== void 0 ? _ref : void 0,
                    onChange: commit,
                    onSearch: picker.search,
                    defaultQuery: current ? void 0 : picker.defaultQuery || void 0,
                    loading: picker.loading,
                    loadingText: answer === "brand" ? "Finding likely products\u2026" : "Loading\u2026",
                    error: (_picker_error = picker.error) !== null && _picker_error !== void 0 ? _picker_error : void 0,
                    onRetry: picker.retry,
                    emptyText: answer === "generic" ? "No generic products match" : picker.mode === "ranked" ? picker.view === "products" && picker.maker ? "No ".concat(picker.maker, " products found") : NO_SUGGESTIONS : "No products match",
                    countText: countText,
                    endAction: endAction,
                    commitOnClose: false,
                    disabled: busy
                }), current ? "current" : picker.fieldKey);
            }
        })
    });
};
// src/components/IdentifyCard/planIdentifyOptions.ts
var NO_CAPACITY = "No capacity";
var BEST_MATCH = "Best match";
var productLinesOf = function(products) {
    return(// `Array.from`, never a spread: this package compiles to ES5, where spreading a Set iterates
    // nothing and tsc cannot see it.
    Array.from(new Set(products.map(function(p) {
        var _p_productLine;
        var _p_productLine_trim;
        return (_p_productLine_trim = (_p_productLine = p.productLine) === null || _p_productLine === void 0 ? void 0 : _p_productLine.trim()) !== null && _p_productLine_trim !== void 0 ? _p_productLine_trim : "";
    }).filter(function(line4) {
        return line4 !== "";
    }))).sort(function(a, b) {
        return a.localeCompare(b);
    }));
};
var planRankedOrder = function(groups) {
    return groups.filter(function(group) {
        return group.key !== "similar-other-makers";
    }).map(function(group) {
        return {
            key: group.key,
            referenceIds: group.products.map(function(p) {
                return p.reference_id;
            })
        };
    });
};
var planGroupKeyOf = function(order) {
    var keys = /* @__PURE__ */ new Map();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = order[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var group = _step.value;
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator1 = group.referenceIds[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var id = _step1.value;
                    if (!keys.has(id)) keys.set(id, group.key);
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return function(referenceId) {
        var _keys_get;
        return (_keys_get = keys.get(referenceId)) !== null && _keys_get !== void 0 ? _keys_get : "maker-rest";
    };
};
var planIdentifyProducts = function(products, param) {
    var line4 = param.line, text2 = param.text, bestReferenceId = param.bestReferenceId, order = param.order;
    var q = text2.trim().toLowerCase();
    var filtered = products.filter(function(p) {
        return p.referenceId !== "" && (line4 === null || p.productLine === line4) && (q === "" || p.product.toLowerCase().includes(q));
    });
    var kept = order ? byGroups(filtered, order) : filtered;
    if (!bestReferenceId) return kept;
    var best = kept.filter(function(p) {
        return p.referenceId === bestReferenceId;
    });
    return _to_consumable_array(best).concat(_to_consumable_array(kept.filter(function(p) {
        return p.referenceId !== bestReferenceId;
    })));
};
var byGroups = function(products, order) {
    var rank = /* @__PURE__ */ new Map();
    order.forEach(function(group) {
        return group.referenceIds.forEach(function(id) {
            if (!rank.has(id)) rank.set(id, rank.size);
        });
    });
    return products.slice().sort(function(a, b) {
        var ra = rank.get(a.referenceId);
        var rb = rank.get(b.referenceId);
        if (ra !== void 0 && rb !== void 0) return ra - rb;
        if (ra !== void 0) return -1;
        if (rb !== void 0) return 1;
        return a.product.localeCompare(b.product);
    });
};
var planProductMeta = function(product) {
    return [
        product.capacity !== null ? "Capacity ".concat(product.capacity) : NO_CAPACITY,
        product.hasModel ? "3D model" : null
    ].filter(Boolean).join(" \xB7 ");
};
var rankManufacturers = function(names, text2) {
    var q = text2.trim().toLowerCase();
    var band = function(name) {
        var n = name.toLowerCase();
        if (q === "" || n.startsWith(q)) return 0;
        return n.includes(q) ? 1 : 2;
    };
    return Array.from(new Set(names)).sort(function(a, b) {
        return band(a) - band(b) || a.localeCompare(b);
    });
};
// src/components/IdentifyCard/usePlanIdentifyPicker.ts
import { useCallback as useCallback6, useEffect as useEffect10, useMemo as useMemo3, useRef as useRef10, useState as useState8 } from "react";
import { isGenericCatalogueManufacturer as isGenericCatalogueManufacturer2 } from "@repo/front-end-utils";
var brandMaker = function(name) {
    var trimmed = (name === null || name === void 0 ? void 0 : name.trim()) || null;
    return trimmed && !isGenericCatalogueManufacturer2(trimmed) ? trimmed : null;
};
var guessedMaker = function(ranked) {
    if (!ranked) return null;
    if (isGrouped(ranked)) return brandMaker(ranked.chosenMaker);
    var best = _to_consumable_array(ranked.yours).concat(_to_consumable_array(ranked.otherTwins)).find(function(c) {
        return c.reference_id === ranked.bestGuess;
    });
    var _brandMaker;
    return (_brandMaker = brandMaker(best === null || best === void 0 ? void 0 : best.manufacturer)) !== null && _brandMaker !== void 0 ? _brandMaker : brandMaker(ranked.seed.manufacturer);
};
var describe = function(error) {
    return {
        status: statusOf(error),
        code: error === null || error === void 0 ? void 0 : error.code
    };
};
var usePlanIdentifyPicker = function(param) {
    var assetId = param.assetId, proposal = param.proposal, fetchers = param.fetchers, logContext = param.logContext;
    var _proposal_manufacturer, _latched_current, _latched_current1, _latched_current2, _brandProposal_reason;
    var fetchersRef = useRef10(fetchers);
    fetchersRef.current = fetchers;
    var logRef = useRef10(logContext);
    logRef.current = logContext;
    var brandProposal = proposal && !isGenericCatalogueManufacturer2((_proposal_manufacturer = proposal.manufacturer) === null || _proposal_manufacturer === void 0 ? void 0 : _proposal_manufacturer.trim()) ? proposal : null;
    var proposedMaker = brandMaker(brandProposal === null || brandProposal === void 0 ? void 0 : brandProposal.manufacturer);
    var _useState8 = _sliced_to_array(useState8(null), 2), ranked = _useState8[0], setRanked = _useState8[1];
    var _useState81 = _sliced_to_array(useState8(null), 2), guessError = _useState81[0], setGuessError = _useState81[1];
    var _useState82 = _sliced_to_array(useState8(0), 2), rankedAttempt = _useState82[0], setRankedAttempt = _useState82[1];
    var _useState83 = _sliced_to_array(useState8(void 0), 2), picked = _useState83[0], setPicked = _useState83[1];
    var latched = useRef10(null);
    var seededMaker = proposedMaker !== null && proposedMaker !== void 0 ? proposedMaker : guessedMaker(ranked);
    if (!latched.current && seededMaker) {
        var _ranked_bestGuess, _brandProposal_reference_id;
        latched.current = {
            maker: seededMaker,
            // From a server that ranks by group, only a To confirm guess is a best match (spec, Goes away).
            best: (_brandProposal_reference_id = brandProposal === null || brandProposal === void 0 ? void 0 : brandProposal.reference_id) !== null && _brandProposal_reference_id !== void 0 ? _brandProposal_reference_id : isGrouped(ranked) ? null : (_ranked_bestGuess = ranked === null || ranked === void 0 ? void 0 : ranked.bestGuess) !== null && _ranked_bestGuess !== void 0 ? _ranked_bestGuess : null
        };
    }
    var _latched_current_maker;
    var maker = picked !== void 0 ? picked : (_latched_current_maker = (_latched_current = latched.current) === null || _latched_current === void 0 ? void 0 : _latched_current.maker) !== null && _latched_current_maker !== void 0 ? _latched_current_maker : null;
    var _useState84 = _sliced_to_array(useState8(null), 2), line4 = _useState84[0], setLine = _useState84[1];
    var _useState85 = _sliced_to_array(useState8(false), 2), makerTouched = _useState85[0], setMakerTouched = _useState85[1];
    var _useState86 = _sliced_to_array(useState8(null), 2), found = _useState86[0], setFound = _useState86[1];
    var _useState87 = _sliced_to_array(useState8(false), 2), makersLoading = _useState87[0], setMakersLoading = _useState87[1];
    var _useState88 = _sliced_to_array(useState8(null), 2), makersError = _useState88[0], setMakersError = _useState88[1];
    var seq = useRef10(0);
    var inFlight = useRef10(null);
    var debounce = useRef10(null);
    var lastText = useRef10("");
    var _useState89 = _sliced_to_array(useState8(null), 2), products = _useState89[0], setProducts = _useState89[1];
    var _useState810 = _sliced_to_array(useState8(null), 2), productsFor = _useState810[0], setProductsFor = _useState810[1];
    var _useState811 = _sliced_to_array(useState8(null), 2), productsError = _useState811[0], setProductsError = _useState811[1];
    var _useState812 = _sliced_to_array(useState8(0), 2), productsAttempt = _useState812[0], setProductsAttempt = _useState812[1];
    var _useState813 = _sliced_to_array(useState8(null), 2), makerOrder = _useState813[0], setMakerOrder = _useState813[1];
    var grouped = isGrouped(ranked);
    var openingServesMaker = grouped && !!maker && sameMaker(ranked === null || ranked === void 0 ? void 0 : ranked.chosenMaker, maker);
    useEffect10(function() {
        var controller = new AbortController();
        setGuessError(null);
        fetchersRef.current.ranked(assetId, controller.signal).then(function(answer) {
            if (controller.signal.aborted) return;
            if (!answer.bestGuess && !answer.seed.manufacturer) {
                console.debug("[identify] no guess for the group", _object_spread_props(_object_spread({}, logRef.current), {
                    assetId: assetId
                }));
            }
            setRanked(answer);
        }).catch(function(error) {
            if (controller.signal.aborted || isAbort(error)) return;
            console.warn("[identify] ranked candidates failed", _object_spread(_object_spread_props(_object_spread({}, logRef.current), {
                assetId: assetId
            }), describe(error)));
            setGuessError("Couldn\u2019t load suggestions");
        });
        return function() {
            return controller.abort();
        };
    }, [
        assetId,
        rankedAttempt
    ]);
    useEffect10(function() {
        if (!maker) {
            setProducts(null);
            setProductsFor(null);
            return void 0;
        }
        var controller = new AbortController();
        setProductsError(null);
        fetchersRef.current.products(maker, controller.signal).then(function(rows) {
            if (controller.signal.aborted) return;
            setProducts(rows.filter(function(row) {
                return row.referenceId !== "";
            }));
            setProductsFor(maker);
        }).catch(function(error) {
            if (controller.signal.aborted || isAbort(error)) return;
            console.warn("[identify] manufacturer products failed", _object_spread(_object_spread_props(_object_spread({}, logRef.current), {
                manufacturer: maker
            }), describe(error)));
            setProductsError("Couldn’t load ".concat(maker, "’s products"));
        });
        return function() {
            return controller.abort();
        };
    }, [
        maker,
        productsAttempt
    ]);
    useEffect10(function() {
        if (!maker || !grouped || openingServesMaker) return void 0;
        var controller = new AbortController();
        fetchersRef.current.ranked(assetId, controller.signal, maker).then(function(answer) {
            if (controller.signal.aborted) return;
            var _answer_groups;
            setMakerOrder({
                maker: maker,
                order: planRankedOrder((_answer_groups = answer.groups) !== null && _answer_groups !== void 0 ? _answer_groups : [])
            });
        }).catch(function(error) {
            if (controller.signal.aborted || isAbort(error)) return;
            console.warn("[identify] ranked candidates failed", _object_spread(_object_spread_props(_object_spread({}, logRef.current), {
                assetId: assetId
            }), describe(error)));
            setMakerOrder({
                maker: maker,
                order: null
            });
        });
        return function() {
            return controller.abort();
        };
    }, [
        assetId,
        maker,
        grouped,
        openingServesMaker,
        productsAttempt
    ]);
    useEffect10(function() {
        return function() {
            var _inFlight_current;
            (_inFlight_current = inFlight.current) === null || _inFlight_current === void 0 ? void 0 : _inFlight_current.abort();
            if (debounce.current) clearTimeout(debounce.current);
        };
    }, []);
    var dropSearch = function() {
        var _inFlight_current;
        seq.current += 1;
        (_inFlight_current = inFlight.current) === null || _inFlight_current === void 0 ? void 0 : _inFlight_current.abort();
        if (debounce.current) clearTimeout(debounce.current);
        debounce.current = null;
    };
    var runSearch = useCallback6(function(text2) {
        dropSearch();
        var mine = seq.current;
        var controller = new AbortController();
        inFlight.current = controller;
        setMakersLoading(true);
        setMakersError(null);
        fetchersRef.current.manufacturers(text2, controller.signal).then(function(names) {
            if (mine !== seq.current) return;
            setFound(rankManufacturers(names.filter(function(name) {
                return brandMaker(name) !== null;
            }), text2));
            setMakersLoading(false);
        }).catch(function(error) {
            if (mine !== seq.current || isAbort(error)) return;
            console.warn("[identify] manufacturer search failed", _object_spread(_object_spread_props(_object_spread({}, logRef.current), {
                queryLength: text2.length
            }), describe(error)));
            setMakersError("Couldn\u2019t search the catalogue");
            setMakersLoading(false);
        });
    }, []);
    var searchMakers = useCallback6(function(text2) {
        setMakerTouched(true);
        var q = text2.trim();
        lastText.current = q;
        dropSearch();
        if (q === "") {
            setFound(null);
            setMakersLoading(false);
            setMakersError(null);
            return;
        }
        setMakersLoading(true);
        setMakersError(null);
        debounce.current = setTimeout(function() {
            debounce.current = null;
            runSearch(q);
        }, SEARCH_DEBOUNCE_MS);
    }, [
        runSearch
    ]);
    var chooseMaker = useCallback6(function(next) {
        setMakerTouched(true);
        dropSearch();
        setFound(null);
        setMakersLoading(false);
        setMakersError(null);
        setPicked(next);
        if (next !== maker) {
            setLine(null);
            setProducts(null);
            setProductsFor(null);
        }
    }, [
        maker
    ]);
    var retryMakers = useCallback6(function() {
        if (makersError && lastText.current) runSearch(lastText.current);
        else setRankedAttempt(function(n) {
            return n + 1;
        });
    }, [
        makersError,
        runSearch
    ]);
    var retryProducts = useCallback6(function() {
        return setProductsAttempt(function(n) {
            return n + 1;
        });
    }, []);
    var productOrder = useMemo3(function() {
        if (!grouped || !maker) return null;
        var _ranked_groups;
        if (openingServesMaker) return planRankedOrder((_ranked_groups = ranked === null || ranked === void 0 ? void 0 : ranked.groups) !== null && _ranked_groups !== void 0 ? _ranked_groups : []);
        return makerOrder && makerOrder.maker === maker ? makerOrder.order : null;
    }, [
        grouped,
        maker,
        openingServesMaker,
        ranked,
        makerOrder
    ]);
    var openingPending = ranked === null && guessError === null;
    var orderSettled = !openingPending && (!grouped || !maker || openingServesMaker || makerOrder !== null && makerOrder.maker === maker);
    var current = maker && productsFor === maker && orderSettled ? products : null;
    var isGuess = picked === void 0 || picked === ((_latched_current1 = latched.current) === null || _latched_current1 === void 0 ? void 0 : _latched_current1.maker);
    var _latched_current_best;
    var bestReferenceId = isGuess ? (_latched_current_best = (_latched_current2 = latched.current) === null || _latched_current2 === void 0 ? void 0 : _latched_current2.best) !== null && _latched_current_best !== void 0 ? _latched_current_best : null : null;
    var narrowed = useMemo3(function() {
        return current ? planIdentifyProducts(current, {
            line: line4,
            text: "",
            bestReferenceId: bestReferenceId,
            order: productOrder
        }) : null;
    }, [
        current,
        line4,
        bestReferenceId,
        productOrder
    ]);
    var lines = useMemo3(function() {
        return current ? productLinesOf(current) : [];
    }, [
        current
    ]);
    var rankedMakers = useMemo3(function() {
        var _ranked_makers;
        return isGrouped(ranked) ? ((_ranked_makers = ranked === null || ranked === void 0 ? void 0 : ranked.makers) !== null && _ranked_makers !== void 0 ? _ranked_makers : []).filter(function(entry) {
            return brandMaker(entry.manufacturer) !== null;
        }).slice(0, EQUIPMENT_SUGGESTION_LIMIT) : [];
    }, [
        ranked
    ]);
    var makers = found !== null && found !== void 0 ? found : maker ? [
        maker
    ] : rankedMakers.map(function(entry) {
        return entry.manufacturer;
    });
    var _current_length;
    return {
        maker: maker,
        makerTouched: makerTouched,
        isGuess: isGuess,
        // A failed guess is said only while there is nothing else to show: never over a search's
        // results, and never on a To confirm group, whose maker came with it (review: correctness).
        makerError: makersError !== null && makersError !== void 0 ? makersError : found === null && !makersLoading && !proposedMaker && picked === void 0 ? guessError : null,
        retryMakers: retryMakers,
        retryProducts: retryProducts,
        makers: makers,
        makersSearched: found !== null,
        rankedMakers: rankedMakers,
        makersLoading: makersLoading,
        makersError: makersError,
        searchMakers: searchMakers,
        chooseMaker: chooseMaker,
        guessing: picked === void 0 && !proposedMaker && ranked === null && guessError === null,
        guessError: guessError,
        reason: (brandProposal === null || brandProposal === void 0 ? void 0 : (_brandProposal_reason = brandProposal.reason) === null || _brandProposal_reason === void 0 ? void 0 : _brandProposal_reason.trim()) || (ranked === null || ranked === void 0 ? void 0 : ranked.reason) || null,
        lines: lines,
        line: line4,
        chooseLine: setLine,
        products: narrowed,
        productsLoading: !!maker && current === null && productsError === null,
        productsError: productsError,
        makerProductCount: (_current_length = current === null || current === void 0 ? void 0 : current.length) !== null && _current_length !== void 0 ? _current_length : 0,
        // Only while the line still shows it: a line without it has no best match (review: Copilot).
        bestReferenceId: bestReferenceId && (narrowed === null || narrowed === void 0 ? void 0 : narrowed.some(function(p) {
            return p.referenceId === bestReferenceId;
        })) ? bestReferenceId : null,
        productOrder: productOrder
    };
};
// src/components/IdentifyCard/IdentifyPlanCard.tsx
import { useCallback as useCallback7, useEffect as useEffect12, useId as useId2, useMemo as useMemo4, useRef as useRef12, useState as useState9 } from "react";
import styled14 from "styled-components";
import { Button, Combobox as Combobox2, DockedCard, Field as Field2, Icon as Icon9, MenuTrailingLabel as MenuTrailingLabel2, Note as Note2, Select } from "@repo/design-system";
// src/components/IdentifyCard/useIdentifyCardFocus.ts
import { useEffect as useEffect11, useRef as useRef11 } from "react";
var useIdentifyCardFocus = function(param) {
    var bodyRef = param.bodyRef, target = param.target, groupKey = param.groupKey, onGroupChange = param.onGroupChange, fieldKey = param.fieldKey, busy = param.busy;
    var focusField = function() {
        var _target;
        var body = bodyRef.current;
        if (body) (_target = target(body)) === null || _target === void 0 ? void 0 : _target.focus();
    };
    var focusIsNowhere = function() {
        return document.activeElement === null || document.activeElement === document.body;
    };
    useEffect11(function() {
        focusField();
        onGroupChange === null || onGroupChange === void 0 ? void 0 : onGroupChange(groupKey);
    }, [
        groupKey
    ]);
    var firstField = useRef11(true);
    useEffect11(function() {
        if (firstField.current) {
            firstField.current = false;
            return;
        }
        if (focusIsNowhere()) focusField();
    }, [
        fieldKey
    ]);
    var wasBusy = useRef11(busy);
    useEffect11(function() {
        if (wasBusy.current && !busy && focusIsNowhere()) focusField();
        wasBusy.current = busy;
    }, [
        busy
    ]);
};
// src/components/IdentifyCard/IdentifyPlanCard.tsx
import { jsx as jsx16, jsxs as jsxs11 } from "react/jsx-runtime";
var planIdentifyNote = function(count) {
    return "Sets manufacturer, product, capacity and 3D model on ".concat(count, " register ").concat(count === 1 ? "row" : "rows", ". Their names stay as they are.");
};
var planIdentifyTitle = function(count) {
    return count === 1 ? "Identify 1 machine" : "Identify ".concat(count, " machines");
};
var planIdentifySub = function(label, category) {
    return [
        "Product name “".concat(label, "”"),
        (category === null || category === void 0 ? void 0 : category.trim()) || null
    ].filter(Boolean).join(" \xB7 ");
};
var ALL_LINES = "All lines";
var ALL_LINES_VALUE = "";
var TYPE_A_MANUFACTURER = "Type a manufacturer";
var Body = styled14.div(_templateObject65());
var Foot3 = styled14.div(_templateObject66());
var PRODUCT_FIELD = "identify-product";
var MAKER_FIELD = "identify-manufacturer";
var IdentifyPlanPicker = function(param) {
    var group = param.group, fetchers = param.fetchers, planFetchers = param.planFetchers, _param_busy = param.busy, busy = _param_busy === void 0 ? false : _param_busy, onChosenChange = param.onChosenChange, onTake = param.onTake, productDescribedBy = param.productDescribedBy, onGroupChange = param.onGroupChange, logContext = param.logContext, organisationName = param.organisationName;
    var _group_written_manufacturer;
    var _group_proposal, _planFetchers_manufacturers, _planFetchers_products;
    var picker = usePlanIdentifyPicker({
        assetId: group.sampleAssetId,
        proposal: (_group_proposal = group.proposal) !== null && _group_proposal !== void 0 ? _group_proposal : null,
        fetchers: {
            ranked: fetchers.ranked,
            manufacturers: (_planFetchers_manufacturers = planFetchers === null || planFetchers === void 0 ? void 0 : planFetchers.manufacturers) !== null && _planFetchers_manufacturers !== void 0 ? _planFetchers_manufacturers : function() {
                return Promise.reject(new Error("no manufacturer search"));
            },
            products: (_planFetchers_products = planFetchers === null || planFetchers === void 0 ? void 0 : planFetchers.products) !== null && _planFetchers_products !== void 0 ? _planFetchers_products : function() {
                return Promise.reject(new Error("no product read"));
            }
        },
        logContext: logContext
    });
    var _useState9 = _sliced_to_array(useState9(null), 2), chosen = _useState9[0], setChosen = _useState9[1];
    var bodyRef = useRef12(null);
    var enterPressed = useRef12(false);
    var busyRef = useRef12(busy);
    busyRef.current = busy;
    var _picker_maker, _picker_line;
    var fieldKey = "".concat((_picker_maker = picker.maker) !== null && _picker_maker !== void 0 ? _picker_maker : "", "|").concat((_picker_line = picker.line) !== null && _picker_line !== void 0 ? _picker_line : "");
    var productInput = function(body) {
        return body.querySelector('[data-identify-field="'.concat(PRODUCT_FIELD, '"] input'));
    };
    var makerInput = function(body) {
        return body.querySelector('[data-identify-field="'.concat(MAKER_FIELD, '"] input'));
    };
    useIdentifyCardFocus({
        bodyRef: bodyRef,
        target: function(body) {
            var product = productInput(body);
            return product && !product.disabled ? product : makerInput(body);
        },
        groupKey: group.key,
        onGroupChange: onGroupChange,
        fieldKey: fieldKey,
        busy: busy
    });
    useEffect12(function() {
        var body = bodyRef.current;
        if (!body || !picker.maker || picker.makerTouched) return;
        var maker = makerInput(body);
        var product = productInput(body);
        if (maker && product && !product.disabled && document.activeElement === maker) product.focus();
    }, [
        picker.maker
    ]);
    var _useState91 = _sliced_to_array(useState9(""), 2), productText = _useState91[0], setProductText = _useState91[1];
    var products = useMemo4(function() {
        var _picker_products;
        return planIdentifyProducts((_picker_products = picker.products) !== null && _picker_products !== void 0 ? _picker_products : [], {
            line: null,
            text: productText,
            bestReferenceId: picker.bestReferenceId,
            order: picker.productOrder
        });
    }, [
        picker.products,
        productText,
        picker.bestReferenceId,
        picker.productOrder
    ]);
    var bestShown = !!picker.bestReferenceId && products.some(function(p) {
        return p.referenceId === picker.bestReferenceId;
    });
    var byRef = useMemo4(// Every product of the line, not only those the text shows: a pick outlives later typing.
    function() {
        var _picker_products;
        return new Map(((_picker_products = picker.products) !== null && _picker_products !== void 0 ? _picker_products : []).map(function(product) {
            return [
                product.referenceId,
                product
            ];
        }));
    }, [
        picker.products
    ]);
    var productHeader = picker.maker ? picker.line ? "".concat(picker.maker, " \xb7 ").concat(picker.line) : "".concat(picker.maker, " \xb7 ").concat(picker.makerProductCount, " ").concat(picker.makerProductCount === 1 ? "product" : "products") : void 0;
    var order = picker.productOrder;
    var keyOf = useMemo4(function() {
        return order ? planGroupKeyOf(order) : null;
    }, [
        order
    ]);
    var captionOf = useCallback7(function(referenceId) {
        return keyOf && picker.maker ? groupCaption(keyOf(referenceId), picker.maker, organisationName) : productHeader;
    }, [
        keyOf,
        picker.maker,
        organisationName,
        productHeader
    ]);
    var productOptions = useMemo4(function() {
        return products.map(function(product) {
            var meta = planProductMeta(product);
            return product.referenceId === picker.bestReferenceId ? {
                value: product.referenceId,
                label: product.product,
                meta: meta,
                group: order ? void 0 : productHeader,
                icon: /* @__PURE__ */ jsx16(Icon9, {
                    name: "star",
                    variant: "solid",
                    size: "xs"
                }),
                trailing: /* @__PURE__ */ jsx16(MenuTrailingLabel2, {
                    children: BEST_MATCH
                }),
                trailingText: BEST_MATCH
            } : {
                value: product.referenceId,
                label: product.product,
                meta: meta,
                group: captionOf(product.referenceId),
                icon: /* @__PURE__ */ jsx16(Icon9, {
                    name: "box",
                    size: "xs"
                })
            };
        });
    }, [
        products,
        picker.bestReferenceId,
        captionOf,
        order,
        productHeader
    ]);
    var makerOptions2 = useMemo4(function() {
        return picker.makers.map(function(name) {
            var entry = picker.makersSearched ? void 0 : picker.rankedMakers.find(function(m) {
                return m.manufacturer === name;
            });
            return entry ? {
                value: name,
                label: name,
                meta: makerMeta(entry),
                group: makerCaption(entry, organisationName),
                icon: /* @__PURE__ */ jsx16(Icon9, {
                    name: "industry",
                    size: "xs"
                })
            } : {
                value: name,
                label: name
            };
        });
    }, [
        picker.makers,
        picker.makersSearched,
        picker.rankedMakers,
        organisationName
    ]);
    var rankedMakerList = makerOptions2.length > 0 && makerOptions2.every(function(o) {
        return o.meta !== void 0;
    });
    var makerCountText = function(shown2, total) {
        return rankedMakerList ? "".concat(SHOWING_MAKERS, ", ").concat(resultCount(shown2, total)) : resultCount(shown2, total);
    };
    var productCountText = function(shown2, total) {
        return order && picker.maker ? "".concat(showingMakerProducts(picker.maker), ", ").concat(resultCount(shown2, total)) : resultCount(shown2, total);
    };
    var lineOptions = useMemo4(function() {
        return [
            {
                value: ALL_LINES_VALUE,
                label: ALL_LINES
            }
        ].concat(_to_consumable_array(picker.lines.map(function(line4) {
            return {
                value: line4,
                label: line4
            };
        })));
    }, [
        picker.lines
    ]);
    var identify = useCallback7(function(referenceId) {
        return onTake(referenceId, byRef.get(referenceId));
    }, [
        onTake,
        byRef
    ]);
    var onChosenChangeRef = useRef12(onChosenChange);
    onChosenChangeRef.current = onChosenChange;
    useEffect12(function() {
        onChosenChangeRef.current(chosen, chosen ? byRef.get(chosen) : void 0);
    }, [
        chosen,
        byRef
    ]);
    var commitProduct = useCallback7(function(value) {
        var byEnter = enterPressed.current;
        enterPressed.current = false;
        setChosen(value);
        if (value && byEnter && !busyRef.current) identify(value);
    }, [
        identify
    ]);
    useEffect12(function() {
        setChosen(null);
        setProductText("");
    }, [
        fieldKey
    ]);
    var chooseMaker = function(value) {
        setChosen(null);
        picker.chooseMaker(value);
    };
    var chooseLine = function(value) {
        setChosen(null);
        picker.chooseLine(value === ALL_LINES_VALUE ? null : value);
    };
    var makerAside = ((_group_written_manufacturer = group.written.manufacturer) === null || _group_written_manufacturer === void 0 ? void 0 : _group_written_manufacturer.trim()) ? "Suggested from “".concat(group.written.manufacturer.trim(), "”") : "Suggested from “".concat(group.label, "”");
    var productEmpty = picker.maker ? "No products for ".concat(picker.maker) : "Choose a manufacturer first";
    var _picker_reason;
    return /* @__PURE__ */ jsxs11(Body, {
        ref: bodyRef,
        children: [
            /* @__PURE__ */ jsx16("div", {
                "data-identify-field": MAKER_FIELD,
                children: /* @__PURE__ */ jsx16(Field2, {
                    label: "Manufacturer",
                    aside: picker.maker && picker.isGuess ? makerAside : void 0,
                    helper: picker.maker && picker.isGuess ? (_picker_reason = picker.reason) !== null && _picker_reason !== void 0 ? _picker_reason : void 0 : void 0,
                    children: function(wiring) {
                        var _picker_maker, _picker_makerError;
                        return /* @__PURE__ */ jsx16(Combobox2, _object_spread_props(_object_spread({}, wiring), {
                            searchGlyph: true,
                            options: makerOptions2,
                            value: (_picker_maker = picker.maker) !== null && _picker_maker !== void 0 ? _picker_maker : void 0,
                            onChange: chooseMaker,
                            onSearch: picker.searchMakers,
                            loading: picker.guessing || picker.makersLoading,
                            loadingText: picker.guessing ? "Finding a likely manufacturer\u2026" : "Searching\u2026",
                            error: (_picker_makerError = picker.makerError) !== null && _picker_makerError !== void 0 ? _picker_makerError : void 0,
                            onRetry: picker.retryMakers,
                            emptyText: "No manufacturers match",
                            countText: makerCountText,
                            placeholder: TYPE_A_MANUFACTURER,
                            maxResults: Infinity,
                            commitOnClose: false,
                            disabled: busy
                        }));
                    }
                })
            }),
            /* @__PURE__ */ jsx16(Field2, {
                label: "Product line",
                aside: "Optional",
                children: function(wiring) {
                    var _picker_line;
                    return /* @__PURE__ */ jsx16(Select, {
                        ariaLabelledBy: wiring.labelId,
                        ariaDescribedBy: wiring["aria-describedby"],
                        options: lineOptions,
                        value: (_picker_line = picker.line) !== null && _picker_line !== void 0 ? _picker_line : ALL_LINES_VALUE,
                        onChange: chooseLine,
                        disabled: busy || picker.products === null
                    });
                }
            }),
            /* @__PURE__ */ jsx16("div", {
                "data-identify-field": PRODUCT_FIELD,
                onKeyDownCapture: function(event) {
                    enterPressed.current = event.key === "Enter";
                },
                onPointerDownCapture: function() {
                    enterPressed.current = false;
                },
                children: /* @__PURE__ */ jsx16(Field2, {
                    label: "Product",
                    children: function(wiring) {
                        var _picker_productsError;
                        return /* @__PURE__ */ jsx16(Combobox2, _object_spread_props(_object_spread({}, wiring), {
                            "aria-describedby": [
                                wiring["aria-describedby"],
                                productDescribedBy
                            ].filter(Boolean).join(" ") || void 0,
                            searchGlyph: true,
                            autoHighlight: bestShown && !picker.productsError,
                            onSearch: setProductText,
                            maxResults: Infinity,
                            options: productOptions,
                            value: chosen !== null && chosen !== void 0 ? chosen : void 0,
                            onChange: commitProduct,
                            placeholder: picker.maker ? "Search ".concat(picker.maker, " products…") : void 0,
                            loading: picker.productsLoading,
                            loadingText: "Loading products\u2026",
                            error: (_picker_productsError = picker.productsError) !== null && _picker_productsError !== void 0 ? _picker_productsError : void 0,
                            onRetry: picker.retryProducts,
                            emptyText: productEmpty,
                            countText: productCountText,
                            commitOnClose: false,
                            disabled: busy || !picker.maker
                        }), fieldKey);
                    }
                })
            })
        ]
    });
};
var IdentifyPlanCard = function(param) {
    var group = param.group, fetchers = param.fetchers, planFetchers = param.planFetchers, _param_busy = param.busy, busy = _param_busy === void 0 ? false : _param_busy, onIdentify = param.onIdentify, onSkip = param.onSkip, onClose = param.onClose, _param_placement = param.placement, placement = _param_placement === void 0 ? "inset" : _param_placement, _param_headingLevel = param.headingLevel, headingLevel = _param_headingLevel === void 0 ? 3 : _param_headingLevel, returnFocusTo = param.returnFocusTo, onGroupChange = param.onGroupChange, logContext = param.logContext, organisationName = param.organisationName, className = param.className;
    var _useState9 = _sliced_to_array(useState9(null), 2), chosen = _useState9[0], setChosen = _useState9[1];
    var subId = useId2();
    var onChosenChange = useCallback7(function(referenceId, product) {
        return setChosen(referenceId ? {
            referenceId: referenceId,
            product: product
        } : null);
    }, []);
    var take = useCallback7(function(referenceId, product) {
        return onIdentify(referenceId, "brand", product);
    }, [
        onIdentify
    ]);
    var submit = function() {
        if (!busy && chosen) take(chosen.referenceId, chosen.product);
    };
    var footer = /* @__PURE__ */ jsxs11(Foot3, {
        children: [
            /* @__PURE__ */ jsx16(Button, {
                variant: "text",
                iconLeft: /* @__PURE__ */ jsx16(Icon9, {
                    name: "forward",
                    size: "xs"
                }),
                onClick: onSkip,
                disabled: busy,
                children: "Skip"
            }),
            /* @__PURE__ */ jsx16(Button, {
                variant: "primary",
                iconLeft: /* @__PURE__ */ jsx16(Icon9, {
                    name: "check",
                    size: "xs"
                }),
                loading: busy,
                disabled: !chosen,
                onClick: submit,
                children: "Identify ".concat(group.count)
            })
        ]
    });
    return /* @__PURE__ */ jsx16(DockedCard, {
        className: className,
        tone: "peri",
        placement: placement,
        icon: /* @__PURE__ */ jsx16(Icon9, {
            name: "industry"
        }),
        title: planIdentifyTitle(group.count),
        headingLevel: headingLevel,
        sub: /* @__PURE__ */ jsx16("span", {
            id: subId,
            children: planIdentifySub(group.label, group.written.category)
        }),
        onClose: onClose,
        closeLabel: "Close",
        returnFocusTo: returnFocusTo,
        footer: footer,
        children: /* @__PURE__ */ jsxs11(Body, {
            children: [
                /* @__PURE__ */ jsx16(IdentifyPlanPicker, {
                    group: group,
                    fetchers: fetchers,
                    planFetchers: planFetchers,
                    busy: busy,
                    onChosenChange: onChosenChange,
                    onTake: take,
                    productDescribedBy: subId,
                    onGroupChange: onGroupChange,
                    logContext: logContext,
                    organisationName: organisationName
                }),
                /* @__PURE__ */ jsx16(Note2, {
                    tone: "peri",
                    icon: /* @__PURE__ */ jsx16(Icon9, {
                        name: "wand-magic-sparkles",
                        size: "xs"
                    }),
                    children: planIdentifyNote(group.count)
                })
            ]
        })
    });
};
var planIdentifyToastSub = function(product) {
    if (!product) return null;
    var name = [
        product.manufacturer,
        product.product
    ].filter(Boolean).join(" ");
    return product.capacity !== null ? "".concat(name, ", capacity ").concat(product.capacity, " each") : name;
};
// src/components/IdentifyCard/useRowProductChange.tsx
import { useCallback as useCallback9, useRef as useRef13 } from "react";
import { Icon as Icon10 } from "@repo/design-system";
// src/components/Planner/machineCard/useRegionToast.ts
import { useCallback as useCallback8 } from "react";
import { useToast } from "@repo/design-system";
var useRegionToast = function(region) {
    var toast = useToast();
    return useCallback8(function(options) {
        return toast.show(region ? _object_spread_props(_object_spread({}, options), {
            region: region
        }) : options);
    }, [
        toast,
        region
    ]);
};
// src/components/Planner/machineCard/machineProductText.ts
import { toDisplayManufacturer } from "@repo/front-end-utils";
var productChangedSub = function(product, hadOverride) {
    var name = product ? [
        product.manufacturer ? toDisplayManufacturer(product.manufacturer) : null,
        product.product
    ].filter(Boolean).join(" ") : "";
    var withCapacity = product && product.capacity !== null ? "".concat(name, ", capacity ").concat(product.capacity) : name;
    return [
        withCapacity,
        hadOverride ? "Earlier overrides aren\u2019t restored by Undo." : null
    ].filter(Boolean).join(" \xB7 ");
};
var PRODUCT_CHANGE_FAILED = "Couldn\u2019t change the product.";
var CANT_UNDO_PRODUCT = "Can\u2019t undo: the product has changed since. Change it back with Change Product.";
var text = function(value) {
    return typeof value === "string" && value.trim() !== "" ? value.trim() : null;
};
var productMakerLine = function(row) {
    var maker = text(row.manufacturer);
    var parts = [
        maker ? toDisplayManufacturer(maker) : null,
        text(row.product_line)
    ].filter(function(part) {
        return !!part;
    });
    return parts.length > 0 ? parts.join(" \xB7 ") : null;
};
var productName = function(row) {
    return text(row.product);
};
// src/components/IdentifyCard/useRowProductChange.tsx
import { jsx as jsx17 } from "react/jsx-runtime";
var useRowProductChange = function(param) {
    var row = param.row, identifyRow = param.identifyRow, write = param.write, currentRow = param.currentRow, toastRegion = param.toastRegion;
    var show = useRegionToast(toastRegion);
    var live = useRef13(currentRow);
    live.current = currentRow;
    var change = useCallback9(/*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(referenceId, product, label) {
            var rowId, previous, hadOverride, stillOurs, cantUndo, undo;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!row) return [
                            2,
                            "failed"
                        ];
                        if (!row.reference_id) {
                            if (!identifyRow) return [
                                2,
                                "failed"
                            ];
                            return [
                                2,
                                identifyRow(row.id, referenceId, label, product)
                            ];
                        }
                        if (referenceId === row.reference_id) return [
                            2,
                            "unchanged"
                        ];
                        rowId = row.id;
                        previous = row.reference_id;
                        hadOverride = row.model_3d_source === "override" || row.capacity_source === "override";
                        return [
                            4,
                            write({
                                reference_id: referenceId
                            })
                        ];
                    case 1:
                        if (!_state.sent()) return [
                            2,
                            "failed"
                        ];
                        stillOurs = function() {
                            var now = live.current(rowId);
                            return !!now && now.reference_id === referenceId;
                        };
                        cantUndo = function() {
                            return show({
                                tone: "warning",
                                icon: /* @__PURE__ */ jsx17(Icon10, {
                                    name: "triangle-exclamation"
                                }),
                                title: CANT_UNDO_PRODUCT
                            });
                        };
                        undo = /*#__PURE__*/ function() {
                            var _ref = _async_to_generator(function() {
                                return _ts_generator(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            if (!stillOurs()) {
                                                cantUndo();
                                                return [
                                                    2
                                                ];
                                            }
                                            return [
                                                4,
                                                write({
                                                    reference_id: previous
                                                }, {
                                                    precondition: stillOurs
                                                })
                                            ];
                                        case 1:
                                            if (_state.sent()) {
                                                return [
                                                    2
                                                ];
                                            }
                                            if (!stillOurs()) {
                                                cantUndo();
                                                return [
                                                    2
                                                ];
                                            }
                                            show({
                                                tone: "error",
                                                icon: /* @__PURE__ */ jsx17(Icon10, {
                                                    name: "circle-exclamation"
                                                }),
                                                title: "Couldn\u2019t undo the product change",
                                                inlineAction: {
                                                    label: "Try again",
                                                    onAction: function() {
                                                        return void undo();
                                                    }
                                                }
                                            });
                                            return [
                                                2
                                            ];
                                    }
                                });
                            });
                            return function undo() {
                                return _ref.apply(this, arguments);
                            };
                        }();
                        show({
                            tone: "success",
                            icon: /* @__PURE__ */ jsx17(Icon10, {
                                name: "box"
                            }),
                            title: "Product changed",
                            sub: productChangedSub(product, hadOverride),
                            inlineAction: {
                                label: "Undo",
                                onAction: function() {
                                    return void undo();
                                }
                            }
                        });
                        return [
                            2,
                            "changed"
                        ];
                }
            });
        });
        return function(referenceId, product, label) {
            return _ref.apply(this, arguments);
        };
    }(), [
        row,
        identifyRow,
        write,
        show
    ]);
    return {
        change: change
    };
};
// src/components/ModelPicker/modelPickerCombobox.ts
import * as React11 from "react";
import { isOfferableModelFileName, modelFileMatches, modelFileOptionMatchesExactly, modelFileOptions, resolveModelFileName } from "@repo/frontend-types";
var MODEL_PICKER_FILTER = function(option, query) {
    return modelFileMatches(option.value, query);
};
var MODEL_PICKER_EXACT_MATCH = modelFileOptionMatchesExactly;
var modelPickerNoteState = function(modelFiles, storedModel) {
    if (modelFiles === null || modelFiles.length === 0) return "none";
    if (storedModel === "") return "none";
    var resolved = resolveModelFileName(storedModel);
    var wanted = resolved.toLowerCase();
    var listed = false;
    for(var i = 0; i < modelFiles.length; i += 1){
        if (modelFiles[i].toLowerCase() === wanted) {
            listed = true;
            break;
        }
    }
    if (!listed) return "absent";
    return isOfferableModelFileName(resolved) ? "none" : "retiring";
};
var MODEL_RETIRING_NOTE = "This model is being retired. Pick a replacement when one fits.";
var matchingGroups = function(options, typed) {
    var out = [];
    for(var i = 0; i < options.length; i += 1){
        if (!MODEL_PICKER_FILTER(options[i], typed)) continue;
        var meta = options[i].meta;
        if (meta === void 0 || meta === "") continue;
        if (out.indexOf(meta) < 0) out.push(meta);
    }
    return out;
};
var readAsList = function(items) {
    var _items_;
    return items.length <= 1 ? (_items_ = items[0]) !== null && _items_ !== void 0 ? _items_ : "" : "".concat(items.slice(0, -1).join(", "), " and ").concat(items[items.length - 1]);
};
var modelPickerRefusalKind = function(options, typed) {
    var shown2 = 0;
    for(var i = 0; i < options.length; i += 1){
        if (MODEL_PICKER_FILTER(options[i], typed)) shown2 += 1;
        if (shown2 > 1) return "ambiguous";
    }
    return "unavailable";
};
var modelPickerRefusalTail = function(options, typed, verb) {
    if (modelPickerRefusalKind(options, typed) !== "ambiguous") return "isn’t one of the models you can choose, so nothing was ".concat(verb, ". Pick a model from the list.");
    var groups = matchingGroups(options, typed);
    return groups.length > 1 ? "matches more than one model — ".concat(readAsList(groups), " — so nothing was ").concat(verb, ". Pick the one you want from the list.") : "matches more than one model, so nothing was ".concat(verb, ". Pick the one you want from the list.");
};
var modelPickerEmptyText = function(modelFiles, optionCount) {
    if (modelFiles !== null && modelFiles.length === 0) return "The model store listed no models";
    if (modelFiles !== null && optionCount === 0) return "No models are available to choose";
    return "No models match";
};
var useModelPickerOptions = function(modelFiles, surface8) {
    var options = React11.useMemo(function() {
        return modelFileOptions(modelFiles !== null && modelFiles !== void 0 ? modelFiles : []);
    }, [
        modelFiles
    ]);
    var listed = modelFiles === null ? 0 : modelFiles.length;
    React11.useEffect(function() {
        if (listed > 0 && options.length === 0) {
            console.warn("3D model picker (".concat(surface8, "): ").concat(listed, " listed, 0 offerable"));
        }
    }, [
        listed,
        options.length,
        surface8
    ]);
    return options;
};
var modelSourceNote = function(source, hasReference) {
    if (source == null) return null;
    if (source === "catalogue") return MODEL_SOURCE_NOTES.catalogue;
    return hasReference ? MODEL_SOURCE_NOTES.overrideLinked : MODEL_SOURCE_NOTES.overrideUnlinked;
};
var MODEL_SOURCE_NOTES = {
    catalogue: "From the catalogue.",
    overrideLinked: "Chosen for this asset. Clear it to use the catalogue's model.",
    overrideUnlinked: "Chosen for this asset.",
    /** Announced, politely, when the planner panel's clear returns a model to the catalogue. */ returned: "3D model now follows the catalogue."
};
var namesCatalogueProduct = function(referenceId) {
    return typeof referenceId === "string" && referenceId.trim() !== "";
};
// src/components/Planner/spaceCard/spaceCardText.ts
import { capitaliseFirstLetter } from "@repo/front-end-utils";
// src/components/Planner/machineCard/machineDeleteText.ts
var plural = function(n, one) {
    var many = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "".concat(one, "s");
    return "".concat(n, " ").concat(n === 1 ? one : many);
};
var deleteMachineCopy = function(param) {
    var name = param.name, bid = param.bid, launched = param.launched, summary = param.summary;
    var named = bid ? "".concat(name, " (").concat(bid, ")") : name;
    var is = launched === true ? "is" : "may be";
    var lines = [
        bid ? "".concat(named, " ").concat(is, " in the live twin. It leaves the twin when you launch, and its history stays in reports under ").concat(bid, ".") : "".concat(named, " ").concat(is, " in the live twin. It leaves the twin when you launch, and its history stays in reports.")
    ];
    return {
        title: "Delete ".concat(name, "?"),
        lines: lines,
        takes: takesLines(summary)
    };
};
var takesLines = function(summary) {
    var takes = [];
    if (summary.observers > 0) takes.push("".concat(plural(summary.observers, "camera region"), " drawn on it"));
    if (summary.composites > 0) takes.push("".concat(plural(summary.composites, "composite measure"), " that ").concat(summary.composites === 1 ? "names" : "name", " it"));
    return takes;
};
var machineDeletedToast = function(name, hadRow) {
    return _object_spread({
        tone: "success",
        title: "Deleted ".concat(name)
    }, hadRow ? {
        sub: "Its register row is back in Not on plan."
    } : {});
};
var DELETE_TAKES_CHANGED = "What this takes has changed since this opened. Check the list, then Delete again.";
var CANT_UNDO_DELETE = "Can\u2019t undo: the plan has changed since. Use Undo in the toolbar.";
// src/components/Planner/spaceCard/spaceCardText.ts
var SPACE_KINDS = [
    "zone",
    "section",
    "area"
];
var KIND_ICON = {
    zone: "draw-polygon",
    section: "object-group",
    area: "square"
};
var kindTitle = function(kind) {
    return kind ? capitaliseFirstLetter(kind) : "Space";
};
var withArticle = function(kind) {
    return "".concat(kind === "area" ? "an" : "a", " ").concat(kind);
};
var SPACE_NAME_BLANK = "A space needs a name.";
var CAPACITY_NOT_BELOW_INSIDE = "Capacity cannot be less than what is inside";
var CAPACITY_UNKNOWN_CONTENTS = "Contents aren't known yet, so this can't be checked against them.";
var CAPACITY_REFUSED = "Couldn't set the capacity.";
var CALCULATED = "calculated";
var USE_CALCULATED = "Use calculated";
var PEOPLE = "people";
var changeKindTitle = function(name, from, to) {
    return from ? "Change ".concat(name, " from ").concat(from, " to ").concat(to, "?") : "Change ".concat(name, " to ").concat(withArticle(to), "?");
};
var bidBecomes = function(bid) {
    return "Its BID becomes ".concat(bid, ".");
};
var BID_MOVED = "The next free BID changed while this was open. Check it, then confirm again.";
var drawingDisagrees = function(placeKind) {
    return "The drawing makes it ".concat(withArticle(placeKind), ", so Checks will flag its BID until it is moved or changed back.");
};
var tooDeepInside = function(n, kind) {
    return "".concat(n, " ").concat(n === 1 ? "space" : "spaces", " inside it will be too deep for ").concat(withArticle(kind), " and will show in Checks.");
};
var liveKindLines = function(param) {
    var name = param.name, oldBid = param.oldBid, newBid = param.newBid, chosen = param.chosen, launched = param.launched;
    return [
        "".concat(name, " (").concat(oldBid, ") ").concat(launched === true ? "is" : "may be", " in the live twin."),
        "When you launch, it becomes ".concat(withArticle(chosen), " under ").concat(newBid, ". Its observers and composite measures move with it. Its history up to now stays in reports under ").concat(oldBid, ".")
    ];
};
var CANT_CHECK_LIVE = "We couldn\u2019t check the live twin, so this treats it as live.";
var CHECKING_LIVE = "Checking the live twin\u2026";
var READING_REGISTER = "Reading the register\u2026";
var LIVE_FAILED = "Couldn't check the live twin, so a new BID can't be issued safely.";
var REGISTER_FAILED = "Couldn't read the register, so a new BID can't be issued safely.";
var kindChangedToast = function(name, chosen, bid) {
    return {
        tone: "success",
        title: "".concat(name, " is now ").concat(withArticle(chosen)),
        sub: bid
    };
};
var chosenClause = function(n) {
    return "".concat(plural(n, "parent"), " chosen by hand replaced by the drawing");
};
var spaceDeletedToast = function(name, hadContents, promotion) {
    var parts = [];
    var _promotion_moved;
    var moved = (_promotion_moved = promotion === null || promotion === void 0 ? void 0 : promotion.moved) !== null && _promotion_moved !== void 0 ? _promotion_moved : [];
    if (moved.length === 1) {
        parts.push("".concat(moved[0].name || "The space inside", " is now ").concat(withArticle(moved[0].kind)));
    } else if (moved.length > 1) {
        parts.push("".concat(moved.length, " spaces moved up a level"));
    } else if (hadContents) {
        parts.push("What was inside moved up a level");
    }
    if (promotion && promotion.chosenReplaced > 0) parts.push(chosenClause(promotion.chosenReplaced));
    return _object_spread({
        tone: "success",
        title: "Deleted ".concat(name)
    }, parts.length > 0 ? {
        sub: parts.join(" \xB7 ")
    } : {});
};
var deleteSpaceCopy = function(param) {
    var names = param.names, launched = param.launched, recodes = param.recodes, machineStays = param.machineStays, machineMoves = param.machineMoves, capacity = param.capacity, lost = param.lost, follow = param.follow, chosenReplaced = param.chosenReplaced, _param_cameraRegions = param.cameraRegions, cameraRegions = _param_cameraRegions === void 0 ? 0 : _param_cameraRegions, _param_unnumbered = param.unnumbered, unnumbered = _param_unnumbered === void 0 ? [] : _param_unnumbered, _param_otherSpaces = param.otherSpaces, otherSpaces = _param_otherSpaces === void 0 ? [] : _param_otherSpaces, _param_deletedMachines = param.deletedMachines, deletedMachines = _param_deletedMachines === void 0 ? [] : _param_deletedMachines, _param_total = param.total, total = _param_total === void 0 ? names.length : _param_total;
    var _names = _sliced_to_array(names, 1), first = _names[0];
    var who = total <= 1 ? first : "".concat(first, " and ").concat(total - 1, " more");
    var it = total <= 1 ? first : "They";
    var comes = total <= 1 ? "comes" : "come";
    var inside = total <= 1 ? "it" : "them";
    var when = launched === false ? "now" : "when the twin is launched";
    var lines = [
        recodes.length > 0 ? "".concat(it, " ").concat(comes, " off the plan ").concat(when, ". What sits inside ").concat(inside, " moves up a level and is renumbered, so its BIDs change:") : "".concat(it, " ").concat(comes, " off the plan ").concat(when, ".")
    ];
    if (launched === "unknown") lines.push(CANT_CHECK_LIVE);
    var rows = [];
    otherSpaces.forEach(function(name, i) {
        return rows.push({
            key: "space:".concat(i),
            icon: "trash-can",
            text: "".concat(name, " ").concat(launched === false ? "comes off the plan" : "comes off the plan too")
        });
    });
    deletedMachines.forEach(function(m) {
        return rows.push(_object_spread({
            key: "machine:".concat(m.refid),
            icon: "dumbbell",
            text: "".concat(m.name, " is deleted with it")
        }, m.bid ? {
            note: m.bid
        } : {}));
    });
    recodes.forEach(function(r) {
        return rows.push({
            key: "recode:".concat(r.refid),
            icon: KIND_ICON[r.kind],
            text: "".concat(r.name || "A space", " becomes ").concat(withArticle(r.kind), " ").concat(r.where),
            bids: {
                from: r.from,
                to: r.to
            }
        });
    });
    unnumbered.forEach(function(u) {
        return rows.push({
            key: "unnumbered:".concat(u.refid),
            icon: KIND_ICON[u.kind],
            text: "".concat(u.name || "A space", " becomes ").concat(withArticle(u.kind), " ").concat(u.where),
            note: "BID at Launch"
        });
    });
    machineStays.forEach(function(m) {
        return rows.push({
            key: "stay:".concat(m.refid),
            icon: "dumbbell",
            text: "".concat(plural(m.count, "machine"), " ").concat(m.count === 1 ? "stays" : "stay", " in ").concat(m.name),
            note: "no change"
        });
    });
    machineMoves.forEach(function(m) {
        var _m_toRefid;
        return rows.push({
            key: "move:".concat((_m_toRefid = m.toRefid) !== null && _m_toRefid !== void 0 ? _m_toRefid : "(floor)"),
            icon: "dumbbell",
            text: m.to === null ? "".concat(plural(m.count, "machine"), " ").concat(m.count === 1 ? "is" : "are", " left on the floor, in no space") : "".concat(plural(m.count, "machine"), " ").concat(m.count === 1 ? "moves" : "move", " to ").concat(m.to)
        });
    });
    if (capacity) {
        rows.push({
            key: "capacity",
            icon: "calculator",
            text: "".concat(capacity.parent, " capacity, calculated"),
            bids: {
                from: String(capacity.before),
                to: String(capacity.after)
            }
        });
    }
    if (lost.observers > 0) {
        rows.push({
            key: "lost:observers",
            icon: "video",
            text: "".concat(plural(lost.observers, "camera region"), " drawn on ").concat(who, " ").concat(lost.observers === 1 ? "goes" : "go", " with it")
        });
    }
    if (lost.composites > 0) {
        rows.push({
            key: "lost:composites",
            icon: "chart-simple",
            text: "".concat(plural(lost.composites, "composite measure"), " ").concat(lost.composites === 1 ? "adds" : "add", " up ").concat(who, " and ").concat(lost.composites === 1 ? "loses" : "lose", " it")
        });
    }
    if (follow.observers > 0) {
        rows.push({
            key: "follow:observers",
            icon: "video",
            text: "".concat(plural(follow.observers, "camera region"), " on the renumbered spaces ").concat(follow.observers === 1 ? "follows" : "follow", " them to their new BIDs at Launch")
        });
    }
    if (follow.composites > 0) {
        rows.push({
            key: "follow:composites",
            icon: "chart-simple",
            text: "".concat(plural(follow.composites, "composite measure"), " on the renumbered spaces ").concat(follow.composites === 1 ? "follows" : "follow", " them to their new BIDs at Launch")
        });
    }
    if (cameraRegions > 0) {
        rows.push({
            key: "cameras",
            icon: "camera",
            text: "".concat(plural(cameraRegions, "camera region"), " on the deleted cameras ").concat(cameraRegions === 1 ? "goes" : "go", " with them")
        });
    }
    if (chosenReplaced > 0) {
        rows.push({
            key: "chosen",
            icon: "sitemap",
            text: chosenClause(chosenReplaced)
        });
    }
    return {
        title: launched === false ? "Delete ".concat(who, "?") : "Delete ".concat(who, " from the live twin?"),
        lines: lines,
        rows: rows
    };
};
var spaceDeleteRefused = function(name, unread) {
    var failed = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    return failed ? "Can’t delete ".concat(name, ": what’s inside needs new BIDs, and ").concat(unread === "live" ? "the live twin" : "the register", " couldn’t be read. Reload the page to try again.") : "Can’t delete ".concat(name, " yet: what’s inside needs new BIDs, and ").concat(unread === "live" ? "the live twin hasn\u2019t been checked" : "the register hasn\u2019t been read", ".");
};
// src/components/Planner/machineCard/ModelSquare.ts
import styled15 from "styled-components";
import { line as line3, radius as radius9, surface as surface6 } from "@repo/design-tokens";
var MODEL_SQUARE_PX = 96;
var ModelSquare = styled15.div(_templateObject67(), MODEL_SQUARE_PX, MODEL_SQUARE_PX, radius9.lg, surface6[0], surface6[2], surface6[0], line3[2]);
// src/components/3D/flyToTarget/constants.ts
var MAPBOX_FLIGHT_DURATION = 4e3;
var LOCAL_FLIGHT_DURATION = 1e3;
var THRESHOLD_KM = 1;
var MIN_ZOOM = 14;
var MAX_ZOOM = 22;
var FILL_INFLATION = {
    twin: 1,
    area: 1,
    asset: 2
};
var PITCH_DEFAULT = 60;
var PITCH_AREA = 30;
var ORG_POSE_DEFAULTS = {
    zoom: 19,
    bearing: 340,
    pitch: 70
};
var ASSET_VIRTUAL_SIZE_M = 2;
var PHASE_2_START_SLOPE_HERMITE = 3;
var PHASE_1_ZOOM_DIP = 1;
var PHASE_2_ZOOM_DIP = 1.5;
var FLIGHT_DEFAULT_START_SLOPE = 1.5;
// src/components/3D/flyToTarget/errors.ts
var UnknownBid = /*#__PURE__*/ function(Error1) {
    "use strict";
    _inherits(UnknownBid, Error1);
    function UnknownBid(bid) {
        _class_call_check(this, UnknownBid);
        var _this;
        _this = _call_super(this, UnknownBid, [
            'flyToTarget: BID "'.concat(bid, '" not resolvable to a known target kind')
        ]);
        _this.name = "UnknownBid";
        return _this;
    }
    return UnknownBid;
}(_wrap_native_super(Error));
var UnknownTargetKind = /*#__PURE__*/ function(UnknownBid) {
    "use strict";
    _inherits(UnknownTargetKind, UnknownBid);
    function UnknownTargetKind(bid) {
        _class_call_check(this, UnknownTargetKind);
        var _this;
        _this = _call_super(this, UnknownTargetKind, [
            bid
        ]);
        _this.name = "UnknownTargetKind";
        return _this;
    }
    return UnknownTargetKind;
}(UnknownBid);
var NoOrgContext = /*#__PURE__*/ function(Error1) {
    "use strict";
    _inherits(NoOrgContext, Error1);
    function NoOrgContext() {
        var message = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "flyToTarget: no organisation context (authMetadata is null)";
        _class_call_check(this, NoOrgContext);
        var _this;
        _this = _call_super(this, NoOrgContext, [
            message
        ]);
        _this.name = "NoOrgContext";
        return _this;
    }
    return NoOrgContext;
}(_wrap_native_super(Error));
var IncompleteTargetData = /*#__PURE__*/ function(Error1) {
    "use strict";
    _inherits(IncompleteTargetData, Error1);
    function IncompleteTargetData(message) {
        _class_call_check(this, IncompleteTargetData);
        var _this;
        _this = _call_super(this, IncompleteTargetData, [
            message
        ]);
        _this.name = "IncompleteTargetData";
        return _this;
    }
    return IncompleteTargetData;
}(_wrap_native_super(Error));
var FlightInterrupted = /*#__PURE__*/ function(Error1) {
    "use strict";
    _inherits(FlightInterrupted, Error1);
    function FlightInterrupted() {
        var message = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "flyToTarget: flight interrupted by a newer flight";
        _class_call_check(this, FlightInterrupted);
        var _this;
        _this = _call_super(this, FlightInterrupted, [
            message
        ]);
        _this.name = "FlightInterrupted";
        return _this;
    }
    return FlightInterrupted;
}(_wrap_native_super(Error));
// src/components/Planner/itemRegisterState.ts
import { resolveItemRegisterState } from "@repo/front-end-utils";
var UNKNOWN_REGISTER_REASON = {
    loading: "Reading the Asset Register\u2026",
    /*
   * No reload advice, and that matters MORE here than on the surfaces that first got it
   * (`register-write-ux-hardening`, epic ledger row 67): this panel sits beside the floor-plan
   * canvas, so a reload discards the operator's unsaved plan. FR8's sweep found three sentences
   * and missed this fourth one; the review caught it.
   *
   * It points at the sidebar's **Try again** rather than carrying its own, because the two render
   * on the same screen and one recovery control is better than two that could disagree about what
   * a retry does.
   */ error: "The Asset Register could not be read, so this item\u2019s name and 3D model cannot be edited here. Use Try again in the equipment sidebar \u2014 reloading would lose unsaved changes to the plan.",
    "no-twin": "Select a twin to edit this item\u2019s name and 3D model."
};
var ORPHAN_REGISTER_NOTE = "Not in this twin\u2019s Asset Register, so these edits change the plan only. Unlink it to place it back on the register from the Equipment list.";
var ORPHAN_NO_IDENTITY_NOTE = "Not in this twin\u2019s Asset Register, so these edits change the plan only. Link it to the register row it belongs to below, or Unlink it to release it.";
var UNLINK_BUTTON_LABEL = "Unlink";
var unlinkAccessibleName = function(itemName) {
    var trimmed = typeof itemName === "string" ? itemName.trim() : "";
    return trimmed === "" ? "".concat(UNLINK_BUTTON_LABEL, " this item from the Asset Register") : "".concat(UNLINK_BUTTON_LABEL, " ").concat(trimmed, " from the Asset Register");
};
var UNLINKED_CONFIRMATION_NOTE = "Unlinked from the Asset Register. This item\u2019s name and 3D model are now plan-only \u2014 add it back from the Equipment list.";
var BLANK_DISPLAY_NAME_MESSAGE = "A placed asset needs a name \u2014 it is what the Asset Register and the plan agree on.";
var REGISTER_LINK_BUTTON_LABEL = "Link to a register row";
var registerLinkAccessibleName = function(itemName) {
    var trimmed = typeof itemName === "string" ? itemName.trim() : "";
    return trimmed === "" ? REGISTER_LINK_BUTTON_LABEL : "".concat(REGISTER_LINK_BUTTON_LABEL, ": ").concat(trimmed);
};
var REGISTER_LINK_COMBOBOX_LABEL = "Asset Register row";
var REGISTER_LINK_MIRROR_NOTE = "The register\u2019s name and 3D model will replace this item\u2019s.";
var REGISTER_LINK_EMPTY_REGISTER = "This twin\u2019s Asset Register is empty \u2014 import it on the Equipment step.";
var REGISTER_LINK_ALL_PLACED = "Every asset in the register is already on the plan.";
var REGISTER_LINK_SEARCH_PLACEHOLDER = "Search the register\u2026";
var REGISTER_LINK_NO_MATCH = "No register rows match";
var REGISTER_LINK_UNAVAILABLE_REASON = {
    loading: "Reading the Asset Register\u2026 you can link this item once it loads.",
    error: "The Asset Register could not be read, so this item cannot be linked to a register row. Use Try again in the equipment sidebar \u2014 reloading would lose unsaved changes to the plan.",
    "no-twin": "Select a twin to link this item to a register row."
};
var registerLinkedNote = function(rowName) {
    return "Linked to ".concat(rowName, " in the Asset Register. This item’s name and 3D model now come from the register.");
};
var REGISTER_LINK_IDENTITY_NOT_CARRIED = "Its equipment identity was not carried across \u2014 another item on the plan already has it.";
// src/components/CameraWall/FeedDragCard.tsx
import React12 from "react";
import { createPortal as createPortal2 } from "react-dom";
import styled16 from "styled-components";
import { brand as brand4, inset as inset4, radius as radius10, rgba as rgba6, shadow as shadow7, space as space8, surface as surface7, zIndex } from "@repo/design-tokens";
import { jsx as jsx18 } from "react/jsx-runtime";
var CARD_WIDTH_PX = 150;
var OFFSET_PX = parseInt(space8[4], 10);
var feedDragCardTransform = function(x, y) {
    return "translate(".concat(x + OFFSET_PX, "px, calc(").concat(y - OFFSET_PX, "px - 100%)) rotate(-2deg)");
};
var Card2 = styled16.div(_templateObject68(), zIndex.tooltip, CARD_WIDTH_PX, space8[1], radius10.lg, rgba6(surface7[0], 0.85), surface7[0], inset4[4], rgba6(brand4.frost, 0.9), shadow7.inkGlassRgb);
var Frame = styled16.div(_templateObject69());
var FeedDragCard = function(param) {
    var feed = param.feed, start = param.start;
    var ref = React12.useRef(null);
    React12.useLayoutEffect(function() {
        var node = ref.current;
        if (!node) return;
        node.style.transform = feedDragCardTransform(start.x, start.y);
        var follow = function(e) {
            node.style.visibility = "visible";
            node.style.transform = feedDragCardTransform(e.clientX, e.clientY);
        };
        var leave = function(e) {
            var outside = e.clientX <= 0 || e.clientY <= 0 || e.clientX >= window.innerWidth || e.clientY >= window.innerHeight;
            if (outside) node.style.visibility = "hidden";
        };
        document.addEventListener("dragover", follow, true);
        document.addEventListener("dragleave", leave, true);
        return function() {
            document.removeEventListener("dragover", follow, true);
            document.removeEventListener("dragleave", leave, true);
        };
    }, []);
    return createPortal2(/* @__PURE__ */ jsx18(Card2, {
        ref: ref,
        "aria-hidden": "true",
        "data-testid": "feed-drag-card",
        children: /* @__PURE__ */ jsx18(Frame, {
            children: /* @__PURE__ */ jsx18(CameraPicture, {
                feed: feed,
                size: "drag",
                decorative: true
            })
        })
    }), document.body);
};
// src/components/3D/flyToTarget/arc.ts
function haversineKm(a, b) {
    var earthRadiusKm = 6371;
    var phi1 = degToRad(a.lat);
    var phi2 = degToRad(b.lat);
    var dPhi = degToRad(b.lat - a.lat);
    var dLambda = degToRad(b.lng - a.lng);
    var x = Math.pow(Math.sin(dPhi / 2), 2) + Math.cos(phi1) * Math.cos(phi2) * Math.pow(Math.sin(dLambda / 2), 2);
    return 2 * earthRadiusKm * Math.atan2(Math.sqrt(x), Math.sqrt(1 - x));
}
function degToRad(deg) {
    return deg * Math.PI / 180;
}
// src/components/3D/flyToTarget/animate.ts
function animateSinglePhase(map, start, end, duration) {
    var options = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {};
    var _options_maxZoomDip;
    var maxZoomDip = (_options_maxZoomDip = options.maxZoomDip) !== null && _options_maxZoomDip !== void 0 ? _options_maxZoomDip : PHASE_2_ZOOM_DIP;
    var _options_velocityStart;
    var vStart = (_options_velocityStart = options.velocityStart) !== null && _options_velocityStart !== void 0 ? _options_velocityStart : FLIGHT_DEFAULT_START_SLOPE;
    var _options_velocityEnd;
    var vEnd = (_options_velocityEnd = options.velocityEnd) !== null && _options_velocityEnd !== void 0 ? _options_velocityEnd : 0;
    var zoomDip = scaledZoomDip(start, end, maxZoomDip);
    var startTime = performance.now();
    var signal = options.signal;
    return new Promise(function(resolve, reject) {
        if (signal === null || signal === void 0 ? void 0 : signal.aborted) {
            reject(new FlightInterrupted());
            return;
        }
        function frame(now) {
            if (signal === null || signal === void 0 ? void 0 : signal.aborted) {
                reject(new FlightInterrupted());
                return;
            }
            var t = Math.min((now - startTime) / duration, 1);
            var eased = hermiteEase(vStart, vEnd, t);
            applyPose(map, interpolatePose(start, end, eased, zoomDip));
            if (t < 1) requestAnimationFrame(frame);
            else resolve();
        }
        requestAnimationFrame(frame);
    });
}
function animateTwoPhase(map, start, intermediate, end, phaseDurations) {
    var options = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {};
    var _phaseDurations = _sliced_to_array(phaseDurations, 2), d1 = _phaseDurations[0], d2 = _phaseDurations[1];
    var phase1Dip = scaledZoomDip(start, intermediate, PHASE_1_ZOOM_DIP);
    var phase2Dip = scaledZoomDip(intermediate, end, PHASE_2_ZOOM_DIP);
    var startTime = performance.now();
    var total = d1 + d2;
    var signal = options.signal;
    return new Promise(function(resolve, reject) {
        if (signal === null || signal === void 0 ? void 0 : signal.aborted) {
            reject(new FlightInterrupted());
            return;
        }
        function frame(now) {
            if (signal === null || signal === void 0 ? void 0 : signal.aborted) {
                reject(new FlightInterrupted());
                return;
            }
            var elapsed = now - startTime;
            var pose;
            if (elapsed < d1) {
                var t = elapsed / d1;
                var eased = hermiteEase(0, PHASE_2_START_SLOPE_HERMITE, t);
                pose = interpolatePose(start, intermediate, eased, phase1Dip);
            } else if (elapsed < total) {
                var t1 = (elapsed - d1) / d2;
                var easedPath = hermiteEase(PHASE_2_START_SLOPE_HERMITE, 0, t1);
                var easedBearing = hermiteEase(PHASE_2_START_SLOPE_HERMITE, 0, t1);
                pose = interpolatePose(intermediate, end, easedPath, phase2Dip, {
                    bearingEase: easedBearing
                });
            } else {
                pose = end;
            }
            applyPose(map, pose);
            if (elapsed < total) requestAnimationFrame(frame);
            else resolve();
        }
        requestAnimationFrame(frame);
    });
}
function scaledZoomDip(from, to, maxDip) {
    var km = haversineKm({
        lng: from.lng,
        lat: from.lat
    }, {
        lng: to.lng,
        lat: to.lat
    });
    return maxDip * Math.min(1, km);
}
function interpolatePose(from, to, eased, zoomDip, options) {
    var lng = lerp(from.lng, to.lng, eased);
    var lat = lerp(from.lat, to.lat, eased);
    var zoom = lerp(from.zoom, to.zoom, eased) - zoomDip * 4 * eased * (1 - eased);
    var pitch = lerp(from.pitch, to.pitch, eased);
    var _options_bearingEase;
    var bearing = shortestArcLerp(from.bearing, to.bearing, (_options_bearingEase = options === null || options === void 0 ? void 0 : options.bearingEase) !== null && _options_bearingEase !== void 0 ? _options_bearingEase : eased);
    return {
        lat: lat,
        lng: lng,
        zoom: zoom,
        pitch: pitch,
        bearing: bearing
    };
}
function applyPose(map, pose) {
    map.jumpTo({
        center: [
            pose.lng,
            pose.lat
        ],
        zoom: pose.zoom,
        pitch: pose.pitch,
        bearing: pose.bearing
    });
}
function lerp(from, to, t) {
    return from + (to - from) * t;
}
function shortestArcLerp(from, to, t) {
    var start = (from % 360 + 360) % 360;
    var end = (to % 360 + 360) % 360;
    var delta = end - start;
    if (delta > 180) delta -= 360;
    if (delta < -180) delta += 360;
    return start + delta * t;
}
function hermiteEase(vStart, vEnd, t) {
    return vStart * t + (3 - 2 * vStart - vEnd) * t * t + (vStart + vEnd - 2) * t * t * t;
}
// src/utils/edgeScroll.ts
var EDGE_SCROLL_BAND_PX = 32;
var EDGE_SCROLL_MAX_PX = 12;
var edgeScrollStep = function(y, top, bottom) {
    var fromTop = y - top;
    var fromBottom = bottom - y;
    if (fromTop < EDGE_SCROLL_BAND_PX) {
        return -EDGE_SCROLL_MAX_PX * Math.min(1, (EDGE_SCROLL_BAND_PX - fromTop) / EDGE_SCROLL_BAND_PX);
    }
    if (fromBottom < EDGE_SCROLL_BAND_PX) {
        return EDGE_SCROLL_MAX_PX * Math.min(1, (EDGE_SCROLL_BAND_PX - fromBottom) / EDGE_SCROLL_BAND_PX);
    }
    return 0;
};
var createEdgeScroller = function(target, afterScroll) {
    var frame = null;
    var step = function() {
        frame = null;
        var at = target();
        if (!at) return;
        var rect = at.el.getBoundingClientRect();
        var by = edgeScrollStep(at.y, rect.top, rect.bottom);
        if (by === 0) return;
        at.el.scrollTop += by;
        afterScroll === null || afterScroll === void 0 ? void 0 : afterScroll();
        frame = requestAnimationFrame(step);
    };
    return {
        kick: function() {
            if (frame === null) frame = requestAnimationFrame(step);
        },
        stop: function() {
            if (frame !== null) cancelAnimationFrame(frame);
            frame = null;
        }
    };
};
export { TagSwitcher_default, TLDialog_default, ConfirmDialog, useConfirm, UNKNOWN_REGISTER_REASON, ORPHAN_REGISTER_NOTE, ORPHAN_NO_IDENTITY_NOTE, UNLINK_BUTTON_LABEL, unlinkAccessibleName, UNLINKED_CONFIRMATION_NOTE, BLANK_DISPLAY_NAME_MESSAGE, REGISTER_LINK_BUTTON_LABEL, registerLinkAccessibleName, REGISTER_LINK_COMBOBOX_LABEL, REGISTER_LINK_MIRROR_NOTE, REGISTER_LINK_EMPTY_REGISTER, REGISTER_LINK_ALL_PLACED, REGISTER_LINK_SEARCH_PLACEHOLDER, REGISTER_LINK_NO_MATCH, REGISTER_LINK_UNAVAILABLE_REASON, registerLinkedNote, REGISTER_LINK_IDENTITY_NOT_CARRIED, resolveItemRegisterState, useDragPosition, DraggablePanel_default, ListGroup_default, prefersReducedMotion, layoutBoxWithin, scrollWithin, ROW_MOTION_KEY_ATTR, ROW_MOTION_ARRIVED_ATTR, ROW_MOTION_GAP_CLASS, ROW_MOTION_ARRIVED_MS, useRowMotion, LIST_ROW_STATUS_LOOK, linkedRing, dropTargetLook, rowArrivedLook, listRowLook, draggedLook, rowMotionGapLook, ICON_DISC_ROW_SIZE, IconDisc, IconDisc_default, ROW_STATE_ROLE, ROW_STATE_LOOK, rowStateLookOf, RowNote, kindGlyphName, KindGlyph, RowGrip, rowPropsEqual, HierarchyEntityRow, HierarchyTreeRows, buildHierarchyTree, CapacityTag, CAMERA_WALL_STATE_ROLE, CAMERA_WALL_STATES, CAMERA_WALL_STATE_ORDER, CAMERA_WALL_PLACEMENT_STATUS_ORDER, CAMERA_WALL_FILTER_LABELS, EXPAND_MS, EXPAND_EASE, FRAME_ZOOM_REST_MS, ARRIVED_MS, FRAME_ZOOM_INSET_PX, FRAME_ZOOM_LAYER, placementSummary, placementKey, PLACEMENT_TONE, PlacementDot, PlacementFoot, STREAM_DRAG_TYPE, createEdgeScroller, expandedRectFor, RefreshIcon, CollapseIcon, VideoIcon, FEED_OUTER_RADIUS, CameraWallSurround, pictureAvailable, CameraPicture, feedDragCardTransform, FeedDragCard, IDENTIFIED_SCORE_FOOTNOTE, IDENTIFIED_SCORE_NOTHING, identifiedScoreLine, IdentifiedScoreCard, otherTwinsCaption, groupCaption, MAKERS_IN_TWIN, makersOnOtherTwinsCaption, EQUIPMENT_SUGGESTION_LIMIT, MAKER_VALUE_PREFIX, makerOptions, groupedOptions, MATCHES, ALL_MANUFACTURERS, seedText, toCatalogueQuery, legacyRankedOptions, useIdentifyPicker, NOT_TRACKED_VALUE, NOT_TRACKED_OPTION_LABEL, BEST_GUESS, NO_SUGGESTIONS, IdentifyProductField, useIdentifyCardFocus, NO_CAPACITY, BEST_MATCH, productLinesOf, planIdentifyProducts, planProductMeta, rankManufacturers, guessedMaker, usePlanIdentifyPicker, planIdentifyNote, planIdentifyTitle, planIdentifySub, ALL_LINES, TYPE_A_MANUFACTURER, IdentifyPlanPicker, IdentifyPlanCard, planIdentifyToastSub, useRegionToast, PRODUCT_CHANGE_FAILED, productMakerLine, productName, useRowProductChange, MODEL_PICKER_FILTER, MODEL_PICKER_EXACT_MATCH, modelPickerNoteState, MODEL_RETIRING_NOTE, modelPickerRefusalTail, modelPickerEmptyText, useModelPickerOptions, modelSourceNote, MODEL_SOURCE_NOTES, namesCatalogueProduct, deleteMachineCopy, takesLines, machineDeletedToast, DELETE_TAKES_CHANGED, CANT_UNDO_DELETE, SPACE_KINDS, KIND_ICON, kindTitle, withArticle, SPACE_NAME_BLANK, CAPACITY_NOT_BELOW_INSIDE, CAPACITY_UNKNOWN_CONTENTS, CAPACITY_REFUSED, CALCULATED, USE_CALCULATED, PEOPLE, changeKindTitle, bidBecomes, BID_MOVED, drawingDisagrees, tooDeepInside, liveKindLines, CANT_CHECK_LIVE, CHECKING_LIVE, READING_REGISTER, LIVE_FAILED, REGISTER_FAILED, kindChangedToast, spaceDeletedToast, deleteSpaceCopy, spaceDeleteRefused, MODEL_SQUARE_PX, ModelSquare, haversineKm, MAPBOX_FLIGHT_DURATION, LOCAL_FLIGHT_DURATION, THRESHOLD_KM, MIN_ZOOM, MAX_ZOOM, FILL_INFLATION, PITCH_DEFAULT, PITCH_AREA, ORG_POSE_DEFAULTS, ASSET_VIRTUAL_SIZE_M, PHASE_2_START_SLOPE_HERMITE, FLIGHT_DEFAULT_START_SLOPE, UnknownBid, UnknownTargetKind, NoOrgContext, IncompleteTargetData, FlightInterrupted, animateSinglePhase, animateTwoPhase, hermiteEase };
